import * as monaco from 'monaco-editor'

export const languages =
{
    'Bash':{
      desc: "Shell scripting, command-line, and Unix-based",
      highlighting:"shell",
      ext: 'sh',
      kor: '리눅스 셸',
      template:"bash",
      icon:'mdi-bash',
      command:"chmod 755 {FILENAME}.{EXT} && bash {ARGS} ./{FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*\\.sh: .+? (\\d+): (.*)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_L),
      dockerImage: "ryusatgat/base",
      homepage: 'https://www.gnu.org/software/bash',
      repo: 'https://git.savannah.gnu.org/cgit/bash.git',
    },
    'Python3':{
      desc: "Easy, versatile, general-purpose interpreter",
      highlighting:"python",
      ext: 'py',
      kor: '파이썬3',
      template:"python",
      icon:'mdi-language-python',
      command:"python3 {ARGS} {FILENAME}.{EXT}",
      cli: 'python3 {ARGS}',
      errorRegEx: ".+?\\.py\", line (\\d+)(?:.*?\r\n)+?(.*?Error: .*)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_P),
      dockerImage: "ryusatgat/python",
      homepage: 'https://www.python.org',
      repo: 'https://github.com/python',
    },
    'Python2.7':{
      desc: "Easy, versatile, general-purpose interpreter",
      highlighting:"python",
      ext: 'py',
      kor: '파이썬2',
      template:"python2",
      icon:'mdi-language-python',
      command:"python2.7 {ARGS} {FILENAME}.{EXT}",
      cli: 'python2.7 {ARGS}',
      errorRegEx: ".+?: Error #\\d+: .*\r\n.*:(\\d+)\\]",
      keyBindings: null,
      dockerImage: "ryusatgat/ubuntu2004",
      homepage: 'https://www.python.org',
      repo: 'https://github.com/python',
    },
    'Python1.6':{
      desc: "Easy, versatile, general-purpose interpreter",
      highlighting:"python",
      ext: 'py',
      kor: '파이썬1',
      template:"python1",
      icon:'mdi-language-python',
      command:"python1.6 {ARGS} {FILENAME}.{EXT}",
      cli: 'python1.6 {ARGS}',
      errorRegEx: ".+?: Error #\\d+: .*\r\n.*:(\\d+)\\]",
      keyBindings: null,
      dockerImage: "ryusatgat/python",
      homepage: 'https://www.python.org',
      repo: 'https://github.com/python',
    },
    'Snek':{
      desc: "Lightweight, embeddable, Python-inspired interpreter",
      highlighting:"python",
      ext: 'py',
      kor: '스넥',
      template:"snek",
      icon:'mdi-language-python',
      command:"snek {ARGS} {FILENAME}.{EXT}",
      cli: 'snek {ARGS}',
      errorRegEx: ".+\\.py:(\\d+) (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://sneklang.org',
      repo: 'https://github.com/keith-packard/snek',
    },
    'C (gcc)':{
      desc: "Low-level, efficient, and fast compiler",
      highlighting:"c",
      ext: 'c',
      kor: 'C언어 - gcc',
      template:"c",
      icon:'mdi-language-c',
      args: '-Wall -lm -lcrypto',
      command:"gcc -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.c:(\\d+):\\d+: error: (.*)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_C),
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C 89 (gcc)':{
      desc: "Low-level, efficient, and fast compiler",
      highlighting:"c",
      ext: 'c',
      kor: 'C언어(gcc) 89',
      template:"c89",
      icon:'mdi-language-c',
      args: '-Wall -lm -lcrypto -std=c89',
      command:"gcc -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.c:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C 11 (gcc)':{
      desc: "Low-level, efficient, and fast compiler",
      highlighting:"c",
      ext: 'c',
      kor: 'C언어 - gcc 11',
      template:"c11",
      icon:'mdi-language-c',
      args: '-Wall -lm -lcrypto -std=c11',
      command:"gcc -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.c:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C 17 (gcc)':{
      desc: "Low-level, efficient, and fast compiler",
      highlighting:"c",
      ext: 'c',
      kor: 'C언어 - gcc 17',
      template:"c17",
      icon:'mdi-language-c',
      args: '-Wall -lm -lcrypto -std=c17',
      command:"gcc -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.c:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C 18 (gcc)':{
      desc: "Low-level, efficient, and fast compiler",
      highlighting:"c",
      ext: 'c',
      kor: 'C언어 - gcc 18',
      template:"c18",
      icon:'mdi-language-c',
      args: '-Wall -lm -lcrypto -std=c18',
      command:"gcc -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.c:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C 2x (gcc)':{
      desc: "Low-level, efficient, and fast compiler",
      highlighting:"c",
      ext: 'c',
      kor: 'C언어 - gcc 2x',
      template:"c2x",
      icon:'mdi-language-c',
      args: '-Wall -lm -lcrypto -std=c2x',
      command:"gcc -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.c:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'CLang':{
      desc: "Low-level, efficient, and fast compiler",
      highlighting:"c",
      ext: 'c',
      kor: 'C랭 - clang',
      template:"clang",
      icon:'mdi-language-c',
      args: '-Wall -lm',
      command:"clang -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.c:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/clang",
      homepage: 'https://clang.llvm.org',
      repo: 'https://github.com/llvm/llvm-project',
    },
    'SubC':{
      desc: "Legacy, Scripting, Subset, C-based, Niche",
      highlighting:"c",
      ext: 'c',
      kor: '서브C - scc',
      template:"subc",
      icon:'mdi-language-c',
      command:"scc -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: "error: .+?: (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.t3x.org/subc',
      repo: 'https://github.com/jezze/subc',
    },
    'PortableC':{
      desc: "Cross-platform, C-syntax, Portability, Embedded, Efficiency",
      highlighting:"c",
      ext: 'c',
      kor: '포터블C - pcc',
      template:"pc",
      icon:'mdi-language-c',
      command:"pcc -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.c, line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sourcery.dyndns.org/wiki.cgi?PortableC',
      repo: 'https://github.com/IanHarvey/pcc',
    },
    'TinyC':{
      desc: "Minimal, Lightweight, C-like, Embedded, Simplistic",
      highlighting:"c",
      ext: 'c',
      kor: '타이니C - tcc',
      template:"tinyc",
      args: '-Wall -lm',
      icon:'mdi-language-c',
      command:"tcc -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.c:(\\d+): error: (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://bellard.org/tcc',
      repo: 'https://github.com/TinyCC/tinycc',
    },
    'CLang++':{
      desc: "C++ compiler with Clang infrastructure",
      highlighting:"cpp",
      ext: 'cc',
      kor: 'C랭++ - clang++',
      template:"clang-cpp",
      icon:'mdi-language-cpp',
      args: '-Wall',
      command:"clang++ -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/clang",
      homepage: 'https://clang.llvm.org',
      repo: 'https://github.com/llvm/llvm-project',
    },
    'C++ (g++)':{
      desc: "Object-oriented, high-performance, versatile, compiled, complex",
      highlighting:"cpp",
      ext: 'cc',
      kor: 'C++ - g++',
      template:"cc",
      icon:'mdi-language-cpp',
      args: '-Wall -lboost_system -lboost_thread -pthread -ltbb',
      command:"g++ -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C++ 98 (g++)':{
      desc: "Object-oriented, high-performance, versatile, compiled, complex",
      highlighting:"cpp",
      ext: 'cc',
      kor: 'C++ - g++ 98',
      template:"cc98",
      icon:'mdi-language-cpp',
      args: '-Wall -std=c++98 -lboost_system -lboost_thread -pthread -ltbb',
      command:"g++ -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C++ 11 (g++)':{
      desc: "Object-oriented, high-performance, versatile, compiled, complex",
      highlighting:"cpp",
      ext: 'cc',
      kor: 'C++ - g++ 11',
      template:"cc11",
      icon:'mdi-language-cpp',
      args: '-Wall -std=c++11 -lboost_system -lboost_thread -pthread -ltbb',
      command:"g++ -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C++ 14 (g++)':{
      desc: "Object-oriented, high-performance, versatile, compiled, complex",
      highlighting:"cpp",
      ext: 'cc',
      kor: 'C++ - g++ 14',
      template:"cc14",
      icon:'mdi-language-cpp',
      args: '-Wall -std=c++14 -lboost_system -lboost_thread -pthread -ltbb',
      command:"g++ -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C++ 17 (g++)':{
      desc: "Object-oriented, high-performance, versatile, compiled, complex",
      highlighting:"cpp",
      ext: 'cc',
      kor: 'C++ - g++ 17',
      template:"cc17",
      icon:'mdi-language-cpp',
      args: '-Wall -std=c++17 -lboost_system -lboost_thread -pthread -ltbb',
      command:"g++ -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C++ 20 (g++)':{
      desc: "Object-oriented, high-performance, versatile, compiled, complex",
      highlighting:"cpp",
      ext: 'cc',
      kor: 'C++ - g++ 20',
      template:"cc20",
      icon:'mdi-language-cpp',
      args: '-Wall -std=c++20 -lboost_system -lboost_thread -pthread -ltbb',
      command:"g++ -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C++ 23 (g++)':{
      desc: "Object-oriented, high-performance, versatile, compiled, complex",
      highlighting:"cpp",
      ext: 'cc',
      kor: 'C++ - g++ 23',
      template:"cc23",
      icon:'mdi-language-cpp',
      args: '-Wall -std=c++23 -lboost_system -lboost_thread -pthread -ltbb',
      command:"g++ -fdiagnostics-color=never -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://gcc.gnu.org',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'C# - .NET Core':{
      desc: "Cross-platform .NET runtime environment",
      highlighting:"csharp",
      ext: 'cs',
      kor: 'C샵 - 닷넷 코어',
      template:"csharp",
      icon:'mdi-language-csharp',
      command:"([ -d {FILENAME}_Dotnet ] || dotnet new console -o {FILENAME}_Dotnet) && mv -f {FILENAME}.{EXT} {FILENAME}_Dotnet/Program.{EXT} && dotnet run {ARGS} --project {FILENAME}_Dotnet",
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+?\\((\\d+),\\d+\\): error .+?: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ms",
      homepage: 'https://dotnet.microsoft.com/en-us/languages/csharp',
      repo: 'https://github.com/dotnet/csharplang',
    },
    'C# - Mono':{
      desc: "Cross-platform .NET runtime environment",
      highlighting:"csharp",
      ext: 'cs',
      kor: 'C샵 - 모노',
      template:"csmono",
      icon:'mdi-language-csharp',
      command:"mcs {ARGS} {FILENAME}.{EXT} && mono ./{FILENAME}.exe",
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".*\\((\\d+),\\d+\\): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/mono",
      homepage: 'https://www.mono-project.com',
      repo: 'https://github.com/mono/mono',
    },
    'Java (OpenJDK)':{
      desc: "Object-oriented, high-performance, and cross-platform",
      highlighting:"java",
      ext: 'java',
      kor: '자바',
      template:"java",
      icon:'mdi-language-java',
      command:"javac {ARGS} {FILENAME}.{EXT} && java {FILENAME}",
      cli: 'jshell',
      defaultFilename: 'Main',
      errorRegEx: ".+?:(\\d+): (\\w+: .+)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_V),
      dockerImage: "ryusatgat/jvm",
      homepage: 'https://openjdk.org',
      repo: 'https://github.com/openjdk',
    },
    'Javascript (Node.js)':{
      desc: "JavaScript runtime, event-driven, and non-blocking",
      highlighting:"javascript1",
      ext: 'js',
      kor: '자바스크립트 (노드.js)',
      template:"javascript",
      icon:'mdi-nodejs',
      command:"node {ARGS} {FILENAME}.{EXT}",
      cli: 'node {ARGS}',
      errorRegEx: ".+:(\\d+)\r\n.+\r\n.+\r\n\r\n(.+)\r\n",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_J),
      dockerImage: "ryusatgat/base",
      homepage: 'https://nodejs.org',
      repo: 'https://github.com/nodejs',
    },
    'Javascript (SpiderMonkey)':{
      desc: "JavaScript-based, GUI framework, and cross-platform",
      highlighting:"javascript1",
      ext: 'js',
      kor: '자바스크립트 (파이어몽키)',
      template:"spidermonkey",
      icon:'mdi-language-javascript',
      command:"js115 {ARGS} {FILENAME}.{EXT}",
      cli: 'js115 {ARGS}',
      errorRegEx: ".+?\\.js:(\\d+):\\d+ (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://spidermonkey.dev/',
      repo: 'https://github.com/mozilla-spidermonkey',
    },
    'Javascript (JerryScript)':{
      desc: "Embedded, lightweight, and JavaScript engine",
      highlighting:"javascript1",
      ext: 'js',
      kor: '자바스크립트 (제리스크립트)',
      template:"jerryscript",
      icon:'mdi-language-javascript',
      command:"jerry {ARGS} {FILENAME}.{EXT}",
      cli: 'jerry {ARGS}',
      errorRegEx: null,
      keyBindings: null,
      homepage: 'https://jerryscript.net',
      repo: 'https://github.com/jerryscript-project',
    },
    'Javascript (Rhino)':{
      desc: "JavaScript engine, Java-integrated, and embeddable",
      highlighting:"javascript1",
      ext: 'js',
      kor: '자바스크립트 (라이노)',
      template:"rhino",
      icon:'mdi-language-javascript',
      command:"rhino {ARGS} {FILENAME}.{EXT}",
      cli: 'rhino {ARGS}',
      errorRegEx: ".+?: .+?, line (\\d+): (.+)",
      keyBindings: null,
      homepage: 'https://rhino.github.io',
      repo: 'https://github.com/mozilla/rhino',
    },
    'Javascript (Duktape)':{
      desc: "Embeddable Javascript engine",
      highlighting:"javascript1",
      ext: 'js',
      kor: 'Javascript (덕테이프)',
      template:"duktape",
      icon:'mdi-tape-drive',
      command: 'duk {ARGS} {FILENAME}.{EXT}',
      cli: 'duk',
      errorRegEx: '.+?: .+? \\(line (\\d+)[\\),]',
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://duktape.org',
      repo: 'https://duktape.org/download',
    },
    'Javascript (Espruino)':{
      desc: "Javascript interpreter for microcontrollers",
      highlighting:"javascript1",
      ext: 'js',
      kor: '자바스크립트 (에스프루이노)',
      template:"espruino",
      icon:'mdi-language-javascript',
      command:"espruino {ARGS} {FILENAME}.{EXT}",
      cli: 'espruino',
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://www.espruino.com',
      repo: 'https://github.com/espruino',
    },
    'Javascript (goja)':{
      desc: "Implementation of ECMAScript 5.1 in pure Go with emphasis on standard compliance and performance",
      highlighting:"javascript1",
      ext: 'js',
      kor: '자바스크립트 (goja)',
      template:"goja",
      icon:'mdi-language-javascript',
      command:"goja {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?: Line (\\d+):\\d+ (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://pkg.go.dev/github.com/dop251/goja',
      repo: 'https://github.com/dop251/goja',
    },
    'Javascript (Microvium)':{
      desc: "Tiny JavaScript engine for microcontrollers for running a small",
      highlighting:"javascript1",
      ext: 'js',
      kor: '자바스크립트 (마이크로비엄)',
      template:"microvium",
      icon:'mdi-language-javascript',
      args: '--no-snapshot',
      command:"microvium {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\r\n.+? at \\(.+?\\.js:(\\d+):\\d+\\)",
      keyBindings: null,
      dockerImage: 'ryusatgat/base',
      homepage: 'https://microvium.com',
      repo: 'https://github.com/coder-mike/microvium',
    },
    'Javascript (mujs)':{
      desc: "Lightweight Javascript interpreter designed for embedding",
      highlighting:"javascript1",
      ext: 'js',
      kor: '자바스크립트 (mujs)',
      template:"mujs",
      icon:'mdi-language-javascript',
      command:"mujs {ARGS} {FILENAME}.{EXT}",
      cli: 'mujs',
      errorRegEx: ".+?\\.js:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://mujs.com',
      repo: 'https://github.com/ccxvii/mujs',
    },
    'Javascript (njs)':{
      desc: "Nginx module that extends the server's functionality through JavaScript scripting",
      highlighting:"javascript1",
      ext: 'js',
      kor: '자바스크립트 (njs)',
      template:"njs",
      icon:'mdi-language-javascript',
      command:"njs {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?Error: .+?\r?\n?.+?\\.js:(\\d+)\\)?",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://nginx.org/en/docs/njs',
      repo: 'https://github.com/nginx/njs',
    },
    'TypeScript':{
      desc: "JavaScript with static types and tooling",
      highlighting:"typescript1",
      ext: 'ts',
      kor: '타입스크립트',
      template:"typescript",
      icon:'mdi-language-typescript',
      args: "--pretty false --target es2015",
      command:"tsc {ARGS} {FILENAME}.{EXT} && node {FILENAME}.js",
      cli: 'ts-node',
      errorRegEx: ".+?\\((\\d+),\\d+\\): (.+)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_T),
      dockerImage: "ryusatgat/base",
      homepage: 'https://www.typescriptlang.org',
      repo: 'https://github.com/microsoft/TypeScript',
    },
    'TypeScript (Deno)':{
      desc: "Secure, modern, and TypeScript runtime",
      highlighting:"javascript1",
      ext: 'ts',
      kor: '데노',
      template:"deno",
      icon:'mdi-language-typescript',
      command:"deno {ARGS} -q run {FILENAME}.{EXT}",
      cli: 'deno repl {ARGS}',
      errorRegEx: ".+?: .+?:(\\d+):(\\d+)",
      keyBindings: null,
      dockerImage: "ryusatgat/deno",
      homepage: 'https://deno.com',
      repo: 'https://github.com/denoland/deno',
    },
    'HTML5':{
      desc: "Markup language, multimedia, and web standard",
      highlighting:"html",
      ext: 'html',
      kor: 'HTML5',
      template:"html",
      icon:'mdi-language-html5',
      command:null,
      isCompiler:false,
      cli: null,
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_H),
      homepage: 'https://www.w3.org',
      repo: '',
    },
    'AngularJS':{
      desc: "JavaScript framework, MVC-based, and dynamic web applications",
      highlighting:"html",
      ext: 'html',
      kor: '앵귤러JS',
      template:"angular",
      icon:'mdi-angularjs',
      command:null,
      isCompiler:false,
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://angularjs.org',
      repo: 'https://github.com/angular/angular.js',
    },
    'JQuery':{
      desc: "JavaScript library, DOM manipulation, and cross-browser",
      highlighting:"html",
      ext: 'html',
      kor: '제이쿼리',
      template:"jquery",
      icon:'mdi-jquery',
      command:null,
      isCompiler:false,
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://jquery.com',
      repo: 'https://github.com/jquery/jquery',
    },
    'React.js':{
      desc: "Component-based, declarative, and UI library",
      highlighting:"html",
      ext: 'html',
      kor: '리액트',
      template:"react",
      icon:'mdi-react',
      command:null,
      isCompiler:false,
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://react.dev',
      repo: 'https://github.com/facebook/react',
    },
    'Vue.js':{
      desc: "Reactive, Component-based, Lightweight, Flexible, Progressive",
      highlighting:"html",
      ext: 'html',
      kor: '뷰',
      template:"vue",
      icon:'mdi-vuejs',
      command:null,
      isCompiler:false,
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://vuejs.org',
      repo: 'https://github.com/vuejs',
    },
    'Markdown':{
      desc: "Plain text formatting syntax",
      highlighting:"markdown",
      ext: 'md',
      kor: '마크다운',
      template:"md",
      icon:'mdi-language-markdown',
      command:null,
      isCompiler:false,
      cli: null,
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M),
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Markdown',
      repo: 'https://github.com/markdown-it/markdown-it',
    },
    'PHP':{
      desc: "Server-side web scripting tool",
      highlighting:"php",
      ext: 'php',
      kor: 'PHP',
      template:"php",
      icon:'mdi-language-php',
      args: '-q',
      command:'php-cgi {ARGS} {FILENAME}.{EXT} > {FILENAME}.html && imshow {FILENAME}.html',
      cli: null,
      errorRegEx: "PHP \\w+ error:  .*?(\\d+)(\r\n)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.php.net',
      repo: 'https://github.com/php/php-src',
    },
    'VB.NET mono':{
      desc: "Cross-platform .NET framework runtime",
      highlighting:"vb",
      ext: 'vb',
      kor: '비주얼베이식닷넷 - vbnc',
      template:"vbmono",
      icon:'mdi-dot-net',
      args: '-nologo',
      command:'vbnc {ARGS} {FILENAME}.{EXT} /out:{FILENAME}.exe && mono {FILENAME}.exe',
      cli: null,
      errorRegEx: ".+? \\((\\d+),(\\d+)\\) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.mono-project.com',
      repo: 'https://github.com/mono/mono-basic',
    },
    'VB.NET Core':{
      desc: "Cross-platform object-oriented programming language",
      highlighting:"vb",
      ext: 'vb',
      kor: '비주얼베이식닷넷 - dotnet',
      template:"vbnet",
      icon:'mdi-dot-net',
      command:'([ -d {FILENAME}_Vb ] || dotnet new console -lang "vb" -o {FILENAME}_Vb) && mv -f {FILENAME}.{EXT} {FILENAME}_Vb/Program.{EXT} && dotnet run {ARGS} --project {FILENAME}_Vb',
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+?\\((\\d+),\\d+\\): error .+?: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ms",
      homepage: 'https://dotnet.microsoft.com',
      repo: 'https://github.com/dotnet/vblang',
    },
    'VBScript':{
      desc: "Windows scripting for automation tasks",
      highlighting:"vb",
      ext: 'vbs',
      kor: 'VB스크립트 - cscript',
      template:"vbscript",
      icon:'mdi-window-maximize',
      args: '//Nologo',
      command:'WINEDEBUG=-all wine cscript {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".*?\\((\\d+), \\d+\\) (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/VBScript',
      repo: 'https://gitlab.winehq.org/wine/wine',
    },
    'Windows Batch':{
      desc: "Windows command automation script",
      highlighting:"bat",
      ext: 'cmd',
      kor: 'Windows 배치 - cmd',
      template:"cmd",
      icon:'mdi-microsoft-windows',
      command:'wine cmd {ARGS} /c {FILENAME}.{EXT}',
      cli: "wine cmd {ARGS} /k c:",
      keyBindings: null,
      dockerImage: "ryusatgat/wine",
      homepage: 'https://windows.microsoft.com',
      repo: 'https://gitlab.winehq.org/wine/wine',
    },
    'Aardvark':{
      desc: "Designed to be easy, yet powerful, compiling to LLVM and self-hosting",
      highlighting:"aardvark",
      ext: 'adk',
      kor: '아드바크',
      template:"aardvark",
      icon:'mdi-pig-variant',
      command:"adk {ARGS} {FILENAME}.{EXT}",
      cli: "adk",
      errorRegEx: ".+?\\.adk:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: 'ryusatgat/aardvark',
      homepage: 'https://aardvark-docs.replit.app',
      repo: 'https://github.com/zplusfour/aardvark',
    },
    'ABC':{
      desc: "Educational, procedural, simple, high-level, interactive",
      highlighting:"abc",
      ext: 'abc',
      kor: 'ABC',
      template:"abc",
      icon:'mdi-ab-testing',
      command:"abc {ARGS} < {FILENAME}.{EXT}",
      cli: "abc {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/ABC_(programming_language)',
      repo: 'https://homepages.cwi.nl/~steven/abc/implementations.html',
    },
    'ABS':{
      desc: "Procedural, simple, educational, legacy, intuitive",
      highlighting:"abs",
      ext: 'abs',
      kor: 'ABS',
      template:"abs",
      icon:'mdi-car-brake-abs',
      command:"abs {ARGS} {FILENAME}.{EXT}",
      cli: "abs",
      errorRegEx: "Error: .+\\.ds Line: (\\d+)(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.abs-lang.org',
      repo: 'https://github.com/abs-lang/abs',
    },
    'ActionScript3':{
      desc: "Event-driven, object-oriented, dynamic, web-focused, versatile",
      highlighting:"actionscript",
      ext: 'as3',
      kor: '액션스크립트3',
      template:"actionscript",
      icon:'mdi-flash',
      command:"as3shebang {ARGS} {FILENAME}.{EXT}",
      errorRegEx: ".+?: Error #\\d+: .*\r\n.*:(\\d+)\\]",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://apache.github.io/royale-docs/features/as3',
      repo: 'https://github.com/Corsaair/as3shebang',
    },
    'Ada':{
      desc: "Strongly-typed, reliable, and concurrent compiler",
      highlighting:"ada",
      ext: 'adb',
      kor: '에이다 (gnatmake)',
      template:"ada",
      icon:'mdi-alpha-a-circle-outline',
      command:'gnatmake {ARGS} -q {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+:(\\d+):\\d+: (.*)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_A),
      dockerImage: '',
      homepage: 'https://ada-lang.io',
      repo: 'https://github.com/adacore',
    },
    'Adept':{
      desc: "Concise, statically-typed, functional compiler",
      highlighting:"adept",
      ext: 'adept',
      kor: '어뎁트',
      template:"adept",
      icon:'mdi-inbox-multiple',
      args:'-std=2.4',
      command:'/opt/adept/adept {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.adept:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/AdeptLanguage/Adept/wiki',
      repo: 'https://github.com/AdeptLanguage/Adept',
    },
    'AdvSys':{
      desc: "Writing text adventure games",
      highlighting:"advsys",
      ext: 'adv',
      kor: 'AdvSys',
      template:"advsys",
      icon:'mdi-sword-cross',
      tabSize: 2,
      args: null,
      command: 'advcom {ARGS} {FILENAME} && advint {FILENAME}',
      cli: null,
      errorRegEx: ">>> in line (\\d+) <<<\r\n(.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://www.ifwiki.org/AdvSys',
      repo: 'https://github.com/dbetz/advsys',
    },
    'Agena':{
      desc: "Declarative, rule-based, and relational interpreter",
      highlighting:"agena",
      ext: 'agn',
      kor: '아제나',
      template:"agena",
      icon:'mdi-code-greater-than-or-equal',
      command:'AGENAPATH=/opt/agena/lib /opt/agena/bin/agena {ARGS} {FILENAME}.{EXT}',
      cli: 'export AGENAPATH=/opt/agena/lib\n/opt/agena/bin/agena {ARGS}',
      errorRegEx: ".+?: Error in .+?\\.agn at line (\\d+):\r\n(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://agena.sourceforge.net',
      repo: 'https://agena.sourceforge.net/download.html',
    },
    'AFNIX':{
      desc: "Concurrent, modular, dynamic, extensible, high-level",
      highlighting:"afnix",
      ext: 'als',
      kor: 'AFNIX - axi',
      template:"afnix",
      icon:'mdi-flare',
      command:'axi {ARGS} {FILENAME}.{EXT}',
      cli: 'axi {ARGS}',
      errorRegEx: ".+?\\.als .+? line (\\d+).*\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.afnix.org',
      repo: 'http://www.afnix.org/xht/wax-us-dload.xht',
    },
    'Agda':{
      desc: "Proof-assistant, dependently-typed, functional",
      highlighting:"agda",
      ext: 'agda',
      kor: '아그다',
      template:"agda",
      icon:'mdi-hard-hat',
      command:'agda -c {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: "agda -I {ARGS}",
      defaultFilename: 'ryugod',
      errorRegEx: ".+?\\.agda:(\\d+),(.+\r\n.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://wiki.portal.chalmers.se/agda/pmwiki.php',
      repo: 'https://github.com/agda/agda',
    },
    'Agora':{
      desc: "Interactive, declarative, and rule-based interpreter",
      highlighting:"agora",
      ext: 'agora',
      kor: '아고라',
      template:"agora",
      icon:'mdi-fireplace-off',
      command:'/opt/agora/agora run {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+\\.agora:(\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/mna/agora/wiki',
      repo: 'https://github.com/mna/agora',
    },
    'Aime':{
      desc: "AI-focused, dynamic, and interactive interpreter",
      highlighting:"aime",
      ext: 'aime',
      kor: 'Aime',
      template:"aime",
      icon:'mdi-coach-lamp',
      command:'aime {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?: .+?: (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sourceforge.net/projects/aime-embedded',
      repo: 'https://sourceforge.net/projects/aime-embedded/files',
    },
/*
    'Aith':{
      desc: "",
      highlighting:"aith",
      ext: 'ath',
      kor: '에이스',
      template:"aith",
      icon:'mdi-waves',
      command:'aith {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\.ath:(\\d+):\\d+:",
      keyBindings: null,
      dockerImage: '',
      homepage: '',
      repo: 'https://github.com/Superstar64/aith',
    },
*/
    'Aku':{
      desc: "Concise, functional, modular, expressive, modern",
      highlighting:"aku",
      ext: 'aku',
      kor: '아쿠',
      template:"aku",
      icon:'mdi-car-parking-lights',
      command:'akucc {ARGS} {FILENAME}.{EXT} && gcc -o {FILENAME} -I/opt/aku/include -L/opt/aku/lib out{FILENAME}.{EXT}.c -laku && ./{FILENAME}',
      cli: null,
      errorRegEx: "akucc: .+?:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/akulang',
      repo: 'https://github.com/akulang/akulang',
    },
    'Alan':{
      desc: "Interactive, dynamically-typed, and extensible interpreter",
      highlighting:"alan",
      ext: 'ln',
      kor: '알란',
      template:"alan",
      icon:'mdi-google-cardboard',
      command:'alan compile {ARGS} {FILENAME}.{EXT} {FILENAME}.agc && alan run {FILENAME}.agc',
      cli: null,
      errorRegEx: ".+? line (\\d+):\\d+(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://alan-lang.org',
      repo: 'https://github.com/alantech/alan',
    },
    'Aldor':{
      desc: "High-level, algebraic, and extensible compiler",
      highlighting:"aldor",
      ext: 'as',
      kor: '알도르',
      template:"aldor",
      icon:'mdi-bowl-mix-outline',
      args: '-G interp',
      command:'/opt/aldor/bin/aldor {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+\\.as\", line (\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.aldor.org',
      repo: 'https://github.com/aldorlang/aldor',
    },
    'Aleph':{
      desc: "Mathematical, high-level, and symbolic interpreter",
      highlighting:"aleph",
      ext: 'ale',
      kor: '알레프',
      template:"aleph",
      icon:'mdi-infinity',
      args: '',
      command:'rm -f {FILENAME}; /opt/aleph/bin/alephbuild {FILENAME}.{EXT} {ARGS} && ./{FILENAME}',
      cli: null,
      errorRegEx: "E  (\\d+)/(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/lcsirmaz',
      repo: 'https://github.com/lcsirmaz/aleph',
    },
    'Algae':{
      desc: "Functional, type-safe, concise, modern, expressive",
      highlighting:"algae",
      ext: 'A',
      kor: '알지',
      template:"algae",
      icon:'mdi-source-branch',
      command:'/opt/algae/bin/algae {ARGS} {FILENAME}.{EXT}',
      cli: '/opt/algae/bin/algae',
      errorRegEx: "algae: .+?\\.A: line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sourceforge.net/projects/algae',
      repo: 'https://sourceforge.net/projects/algae/files',
    },
    'Algol60':{
      desc: "Structured, procedural, and foundational compiler",
      highlighting:"algol60",
      ext: 'alg',
      kor: '알골60 - jff-algol',
      template:"algol60",
      icon:'mdi-alpha',
      command:'/opt/algol60/bin/jff-algol {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?, line (\\d+) \\(file .+?\\.alg\\):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/ALGOL_60',
      repo: 'https://github.com/JvanKatwijk/algol-60-compiler',
    },
    'Algol68':{
      desc: "Structured, versatile, and extensible compiler",
      highlighting:"algol",
      ext: 'alg',
      kor: '알골68',
      template:"algol",
      icon:'mdi-alpha',
      command:'a68g {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "(\\d+) +?.*\r\n.*?\r\na68g: .*?: \\d+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://jmvdveer.home.xs4all.nl/en.algol-68-genie.html',
      repo: 'https://sourceforge.net/projects/algol68/files/algol68g',
    },
    'Algol W':{
      desc: "Compact, structured, and procedural compiler",
      highlighting:"algol60",
      ext: 'alw',
      kor: '알골W',
      template:"algolw",
      icon:'mdi-alpha',
      args: '{FILENAME}.{EXT} -c {FILENAME}.c && gcc {FILENAME}.c -o {FILENAME} -I/opt/algolw/include -L/opt/algolw/lib -lawe -lgc -lm',
      command:'/opt/algolw/bin/awe {ARGS} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.alw:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/ALGOL_W',
      repo: 'https://github.com/sergev/algol-w-compiler',
    },
    'Alice':{
      desc: "Educational, functional, and visual compiler",
      highlighting:"sml",
      ext: 'aml',
      kor: '앨리스',
      template:"alice",
      icon:'mdi-shoe-heel',
      command:'/opt/alice/bin/alicec {ARGS} {FILENAME}.{EXT} && /opt/alice/bin/alicerun {FILENAME}.alc',
      cli: null,
      errorRegEx: ".+?\\.aml:(\\d+)(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.ps.uni-saarland.de/alice',
      repo: 'https://www.ps.uni-saarland.de/alice/download.html',
    },
    'Alma':{
      desc: "Declarative, functional, and modular interpreter",
      highlighting:"alma",
      ext: 'alma',
      kor: '알마',
      template:"alma",
      icon:'mdi-skateboard',
      command:'export ALMA_PATH=/opt/alma/lib\nalma {ARGS} {FILENAME}.{EXT}',
      cli: 'export ALMA_PATH=/opt/alma/lib\nalma',
      errorRegEx: ".+? at line (\\d+)[:.](.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/cassowarii',
      repo: 'https://github.com/cassowarii/alma',
    },
    'Alore':{
      desc: "Object-oriented, dynamic, and extensible interpreter",
      highlighting:"alore",
      ext: 'alo',
      kor: '알로어',
      template:"alore",
      icon:'mdi-triangle-outline',
      command:'/opt/alore/bin/alorec {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.alo, line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.alorelang.org',
      repo: 'https://github.com/JukkaL/alore',
    },
    'Alta':{
      desc: "Systems-oriented, statically-typed, and efficient compiler",
      highlighting:"alta",
      ext: 'alta',
      kor: '알타',
      template:"alta",
      icon:'mdi-road-variant',
      args: '-c',
      command:'genalta {FILENAME} && altac {ARGS} && alta-build/_build/bin/{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.alta:(\\d+):\\d+(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/alta-lang',
      repo: 'https://github.com/alta-lang/alta',
    },
    'Alumina':{
      desc: "Type-safe, concurrent, high-performance, lightweight",
      highlighting:"alumina",
      ext: 'alu',
      kor: '알루미나',
      template:"alumina",
      icon:'mdi-triangle-outline',
      args: '--cfg threading',
      command:'ALUMINA_SYSROOT=/opt/alumina/include/alumina/ /opt/alumina/bin/alumina-boot {ARGS} {FILENAME}.{EXT} > {FILENAME}.c && gcc -o {FILENAME} {FILENAME}.c && ./{FILENAME}',
      cli: null,
      errorRegEx: "error: .+?\r\n  --> .+?\\.alu:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://docs.alumina-lang.net',
      repo: 'https://github.com/alumina-lang/alumina',
    },
    'Amber':{
      desc: "Object-oriented, dynamic, modular, flexible, modern",
      highlighting:"amber",
      ext: 'ab',
      kor: '앰버',
      template:"amber",
      icon:'mdi-road-variant',
      command:'amber {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\.alta:(\\d+):\\d+(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://nineties.github.com/amber',
      repo: 'https://github.com/nineties/amber',
    },
    'Amiga E':{
      desc: "Procedural, modular, system-oriented, efficient, extensible",
      highlighting:"amigae",
      ext: 'e',
      kor: '아미가 E',
      template:"amigae",
      icon:'mdi-alpha-e',
      command:'vamos /opt/amiga/EC {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "ERROR: .+\r\nLINE (\\d+):.+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Amiga_E',
      repo: 'https://github.com/cnvogelg/amitools',
    },
    'Amp':{
      desc: "General-purpose systems language built on modern standards",
      highlighting:"amp",
      ext: 'amp',
      kor: '앰프',
      template:"amp",
      icon:'mdi-amplifier',
      args: 'build-obj',
      command:'ampc {ARGS} {FILENAME}.{EXT} -o {FILENAME}.o && gcc -Wl,-no-pie -o {FILENAME} {FILENAME}.o && ./{FILENAME}',
      cli: null,
      errorRegEx: '.+?\\.amp:(\\d+):\\d+: (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/amp",
      homepage: 'https://github.com/amp-lang',
      repo: 'https://github.com/amp-lang/amp',
    },
    'Amrit':{
      desc: "Interpreted, WASM, based on Hindi",
      highlighting:"amrit",
      ext: 'amr',
      kor: '암릿',
      template:"amrit",
      icon:'mdi-elephant',
      command:'amrit {ARGS} {FILENAME}.{EXT}',
      cli: null,
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/Suryansh-23',
      repo: 'https://github.com/Suryansh-23/amrit',
    },
    'Amun':{
      desc: "Statically typed, low level, LLVM, simple, productive",
      highlighting:"amun",
      ext: 'amun',
      kor: '아문',
      template:"amun",
      icon:'mdi-television-ambient-light',
      args: '-w',
      command:'amun compile {FILENAME}.{EXT} -o {FILENAME} {ARGS} && ./{FILENAME}',
      cli: null,
      errorRegEx: "ERROR in .+?\\.amun:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://amrdeveloper.github.io/Amun',
      repo: 'https://github.com/amrdeveloper/amun',
    },
    'AngelScript':{
      desc: "Scripting, C++-integrated, dynamic, flexible, lightweight",
      highlighting:"angelscript",
      ext: 'as',
      kor: '엔젤스크립트',
      template:"angelscript",
      icon:'mdi-star-four-points-outline',
      command:'asrun {ARGS} {FILENAME}.{EXT}',
      cli: '/opt/angelscript/bin/console',
      errorRegEx: ".+?\\.as \\((\\d+), \\d+\\) : ERR  : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://angelcode.com/',
      repo: 'https://angelcode.com/angelscript/downloads.html',
    },
    'Anko':{
      desc: "Scriptable interpreter with syntax similar to Go, Scripting",
      highlighting:"anko",
      ext: 'ank',
      kor: '앙꼬',
      template:"anko",
      icon:'mdi-baguette',
      command:'anko {ARGS} {FILENAME}.{EXT}',
      cli: 'anko',
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: 'ryusatgat/go',
      homepage: 'https://pkg.go.dev/github.com/mattn/anko/vm',
      repo: 'https://github.com/mattn/anko',
    },
    'Ante':{
      desc: "Providing extensibility through the use of a compile-time API",
      highlighting:"ante",
      ext: 'an',
      kor: '안테',
      template:"ante",
      icon:'mdi-antenna',
      args: null,
      command:'ante {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?:(\\d+):\\d+.+",
      keyBindings: null,
      dockerImage: "ryusatgat/ante",
      homepage: 'http://antelang.org',
      repo: 'https://github.com/jfecher/ante',
    },
    'Antimony':{
      desc: "Bullshit-free (©) programming language",
      highlighting:"antimony",
      ext: 'sb',
      kor: ' 안티모니',
      template:"antimony",
      icon:'mdi-chemical-weapon',
      args: '-t js run',
      command:'sb {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "Error: (\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://antimony-lang.github.io/antimony',
      repo: 'https://github.com/antimony-lang/antimony',
    },
    'Ape':{
      desc: "Simple, Minimalist, Functional, Educational, Lightweight",
      highlighting:"ape",
      ext: 'ape',
      kor: '에이프',
      template:"ape",
      icon:'mdi-pickaxe',
      args: null,
      command:'/opt/ape/bin/ape {FILENAME}.{EXT} {ARGS}',
      cli: '/opt/ape/bin/repl',
      errorRegEx: ".+\\.ape\" on (\\d+):\\d+: .+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/kgabis/ape/blob/master/documentation.md',
      repo: 'https://github.com/kgabis/ape',
    },
    'APL':{
      desc: "Array-oriented, concise, and symbolic interpreter",
      highlighting:"apl",
      ext: 'apl',
      kor: 'APL',
      template:"apl",
      icon:'mdi-smoking-pipe',
      args: '--OFF -s',
      command:'apl {ARGS} -f {FILENAME}.{EXT}',
      cli: 'apl',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/APL_(programming_language)',
      repo: 'https://git.savannah.gnu.org/git/apl.git',
    },
    'APlus':{
      desc: "Educational, procedural, and interactive interpreter",
      highlighting:"aplus",
      ext: 'a+',
      kor: 'A플러스 - a+',
      template:"aplus",
      icon:'mdi-plus-box-outline',
      args: '-q',
      command:'iconv -f utf-8 -t iso-8859-1 {FILENAME}.{EXT} -o {FILENAME}.{EXT} 2> /dev/null\n/opt/aplus/bin/a+ {ARGS} {FILENAME}.{EXT}',
      cli: '/opt/aplus/bin/a+',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.aplusdev.org',
      repo: 'https://github.com/louyx/aplus',
    },
    'Arc':{
      desc: "Minimalist, functional, and expressive interpreter",
      highlighting:"arc",
      ext: 'arc',
      kor: '아크 - arcadia',
      template:"arc",
      icon:'mdi-circle-multiple-outline',
      command:'arcadia {ARGS} {FILENAME}.{EXT}',
      cli: 'arcadia {ARGS}',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.arclanguage.org',
      repo: 'https://github.com/kimtg/arcadia',
    },
    'Arduino':{
      desc: "Italian open-source hardware and software",
      highlighting:"arduino",
      ext: 'ino',
      kor: '아두이노',
      template:"arduino",
      icon:'mdi-electric-switch',
      args: 'compile --fqbn arduino:avr:uno {FILENAME} --build-path {FILENAME}_out',
      command:'arduino-cli sketch new {FILENAME} 2>/dev/null; mv {FILENAME}.{EXT} {FILENAME} && arduino-cli {ARGS}',
      cli: null,
      errorRegEx: '.+?\\.ino:(\\d+):\\d+: error: (.+)',
      keyBindings: null,
      dockerImage: 'ryusatgat/arduino',
      homepage: 'https://www.arduino.cc',
      repo: 'https://github.com/arduino/arduino-cli',
    },
    'Argon':{
      desc: "",
      highlighting:"argon",
      ext: 'ar',
      kor: '아르곤',
      template:"argon",
      icon:'mdi-gas-cylinder',
      command:"Argon {ARGS} {FILENAME}.{EXT}",
      cli: 'Argon',
      errorRegEx: ".+?column: \\d+, line: (\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/argon",
      homepage: 'https://www.arlang.io',
      repo: 'https://github.com/ArgonLang/Argon',
    },
    'Argile':{
      desc: "Declarative, pattern-matching, and modular interpreter",
      highlighting:"argile",
      ext: 'arg',
      kor: '아르질 - arc',
      template:"argile",
      icon:'mdi-car-convertible',
      command:'arc {ARGS} {FILENAME}.{EXT} > {FILENAME}.c && gcc -I/opt/argile/include -L/opt/argile/lib -o {FILENAME} {FILENAME}.c -l:libargrt.a && ./{FILENAME}',
      cli: null,
      errorRegEx: "arc: .+? error: .+?\r\n.*?\r\n.+? at .+? line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.nongnu.org/argile',
      repo: 'https://download.savannah.nongnu.org/releases/argile',
    },
    'Aribas':{
      desc: "Mathematical, Symbolic, Computational, Algebraic, Specialized",
      highlighting:"pascal",
      ext: 'ari',
      kor: '아리바스',
      template:"aribas",
      icon:'mdi-guitar-pick-outline',
      args: '-q',
      command:'aribas {ARGS} -b {FILENAME}.{EXT}',
      cli: 'aribas {ARGS}',
      errorRegEx: "error in line <= (\\d+) (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.mathematik.uni-muenchen.de/~forster/sw/aribas.html',
      repo: 'https://www.mathematik.uni-muenchen.de/~forster/sw/UNIX_LINUX',
    },
    'ArkScript':{
      desc: "Scripting, high-level, and flexible interpreter",
      highlighting:"arkscript",
      ext: 'ark',
      kor: '아크스크립트',
      template:"arkscript",
      icon:'mdi-code-parentheses',
      command:'arkscript {ARGS} {FILENAME}.{EXT}',
      cli: 'arkscript {ARGS}',
      errorRegEx: "On line (\\d+):\\d+, (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/arkscript',
      homepage: 'https://arkscript-lang.dev',
      repo: 'https://github.com/ArkScript-lang/Ark',
    },
    'ArnoldC':{
      desc: "Esoteric, Syntax-based, C-like, Fun, Thematic",
      highlighting:"arnoldc",
      ext: 'arnoldc',
      kor: '아놀드씨',
      template:"arnoldc",
      icon:'mdi-glasses',
      command:'arnoldc {ARGS} {FILENAME}.{EXT} && java {FILENAME}',
      cli: null,
      errorRegEx: ".+\\(line (\\d+), pos \\d+\\)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://lhartikk.github.io/ArnoldC',
      repo: 'https://github.com/lhartikk/ArnoldC',
    },
    'Arrow':{
      desc: "Dataflow, high-level, and declarative interpreter",
      highlighting:"arrow",
      ext: 'ar',
      kor: '애로우',
      template:"arrow",
      icon:'mdi-bullseye-arrow',
      command:'arrow {ARGS} {FILENAME}.{EXT}',
      cli: 'arrow {ARGS}',
      errorRegEx: "Error: .+?on line number (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://jprendes.github.io/arrow-playground',
      repo: 'https://github.com/benhj/arrow',
    },
    'Arturo':{
      desc: "Meta-programming, high-level, and extensible compiler",
      highlighting:"arturo",
      ext: 'art',
      kor: '아르뚜로',
      template:"arturo",
      icon:'mdi-zodiac-capricorn',
      args:'--no-color',
      command:'arturo {ARGS} {FILENAME}.{EXT}',
      cli: 'arturo {ARGS}',
      errorRegEx: " +error \\| Line: (\\d+)\r\n( +\\| (.*)\r\n)+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://arturo-lang.io',
      repo: 'https://github.com/arturo-lang/arturo',
    },
    'ASP.NET mono':{
      desc: "Cross-platform, web framework, and runtime",
      highlighting:"html",
      ext: 'aspx',
      kor: 'ASP닷넷 - xsp4',
      template:"aspnet",
      icon:'mdi-dot-net',
      args: '--nonstop --quiet',
      command:'ps -ef | grep xsp4 | grep -v grep > /dev/null || (xsp4 {ARGS} & > /dev/null)\ncurl -4 -s --retry-connrefused --retry 10 --retry-delay 1 http://localhost:9000/{FILENAME}.{EXT} > {FILENAME}.html && imshow {FILENAME}.html',
      cli: null,
      defaultFilename: 'index',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.mono-project.com',
      repo: 'https://github.com/mono/mono',
    },
    'AspectC++':{
      desc: "Aspect-oriented, C++-based, and modular compiler",
      highlighting:"cpp",
      ext: 'cc',
      kor: '애스펙트C++ - ag++',
      template:"acpp",
      icon:'mdi-language-cpp',
      args: '-Wall',
      command:"ag++ -o {FILENAME} {FILENAME}.{EXT} {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.aspectc.org',
      repo: 'https://www.aspectc.org/Download.php',
    },
    'AspectJ':{
      desc: "Aspect-oriented, Java-based, and modular compiler",
      highlighting:"java",
      ext: 'aj',
      kor: '애스펙트J',
      template:"aspectj",
      icon:'mdi-aspect-ratio',
      command:'ajc {ARGS} {FILENAME}.{EXT} && java {FILENAME}',
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+?\\.aj:(\\d+) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://eclipse.dev/aspectj',
      repo: 'https://eclipse.dev/aspectj/downloads.php',
    },
    'ASPL':{
      desc: "Simple, safe, cross platform, modular",
      highlighting:"aspl",
      ext: 'aspl',
      kor: 'ASPL',
      template:"aspl",
      icon:'mdi-check-bold',
      args: 'run',
      command:'aspl {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\.aspl:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/aspl-lang',
      repo: 'https://github.com/aspl-lang/aspl',
    },
    'Assembly(MC68K)':{
      desc: "Low-level, Motorola 68k-specific, and efficient",
      highlighting:"a68k",
      ext: 's',
      kor: '어셈블리 - a68k',
      template:"a68k",
      icon:'mdi-alpha-a-box-outline',
      command:'vamos /opt/amiga/a68k {ARGS} {FILENAME}.{EXT} && vamos /opt/amiga/blink {FILENAME}.o && vamos {FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.s line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://amitools.readthedocs.io/en/latest',
      repo: 'https://github.com/cnvogelg/amitools',
    },
    'Assembly(x86)':{
      desc: "Low-level, x86-specific, and efficient",
      highlighting:"assembly",
      ext: 'asm',
      kor: '어셈블리 - nasm',
      template:"assembly",
      icon:'mdi-alpha-a-box-outline',
      args: '-f elf64',
      command:'nasm {ARGS} {FILENAME}.{EXT} && ld -s -o {FILENAME} {FILENAME}.o && ./{FILENAME}',
      cli: null,
      errorRegEx: ".*?:(\\d+): \\w+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.nasm.us',
      repo: 'https://github.com/netwide-assembler/nasm',
    },
    'Asymptote':{
      desc: "Graphical, Scripting, Vector-based, Mathematical, Document-oriented",
      highlighting:"asymptote",
      ext: 'asy',
      kor: '아심토트',
      template:"asymptote",
      icon:'mdi-chart-sankey',
      args: '-f svg',
      command:'/opt/asy/bin/asy {ARGS} {FILENAME}.{EXT} && ( [ -f {FILENAME}.svg ] && imshow {FILENAME}.svg && rm -f {FILENAME}.svg )',
      cli: '/opt/asy/bin/asy {ARGS}',
      errorRegEx: ".+?\\.asy: (\\d+)\\.\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://asymptote.sourceforge.io',
      repo: 'https://github.com/vectorgraphics/asymptote',
    },
    'ATS':{
      desc: "Statically-typed, Functional, Imperative, High-performance, Type-safe",
      highlighting:"ats",
      ext: 'dats',
      kor: 'ATS (Applied Type System)',
      template:"ats",
      icon:'mdi-alpha-a',
      command:'patscc {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.dats: \\d+\\(line=(\\d+), offs=\\d+\\) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.ats-lang.org',
      repo: 'https://www.cs.bu.edu/~hwxi/atslangweb/Downloads.html',
    },
    'Avalon':{
      desc: "Declarative, UI-focused, XAML-based, Component-oriented, Microsoft",
      highlighting:"avalon",
      ext: 'avl',
      kor: '아발론',
      template:"avalon",
      icon:'mdi-island',
      command:'AVALON_HOME=/opt/avalon/sdk /opt/avalon/bin/avaloni {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\.avl:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/avalon-lang',
      repo: 'https://github.com/avalon-lang/avaloni',
    },
    'AviatorScript':{
      desc: "Lightweight, high performance scripting language hosted on the JVM",
      highlighting:"aviator",
      ext: 'av',
      kor: ' 에이비에이터',
      template:"aviator",
      icon:'mdi-account-tie-hat-outline',
      command:'aviator {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\(.+?\\.av:(\\d+)\\)",
      keyBindings: null,
      dockerImage: 'ryusatgat/jvm',
      homepage: 'https://github.com/killme2008/aviatorscript/blob/master/README-EN.md',
      repo: 'https://github.com/killme2008/aviatorscript',
    },
    'Awk':{
      desc: "Pattern-matching, text-processing, and scripting",
      highlighting:"shell",
      ext: 'awk',
      kor: '오크',
      template:"awk",
      icon:'mdi-alpha-a-box',
      args: '-f {FILENAME}.{EXT}',
      command:'awk {ARGS}',
      cli: null,
      errorRegEx: "\\w+?: .+?: line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gnu.org/software/gawk',
      repo: 'https://ftp.gnu.org/gnu/gawk',
    },
    'Aument':{
      desc: "Dynamically-typed, scripting, simple, easy to use",
      highlighting:"aument",
      ext: 'au',
      kor: '오먼트',
      template:"aument",
      icon:'mdi-augmented-reality',
      args: 'run',
      command:'aument {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: '(\\d+) \\| (.+)',
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://aument-lang.github.io',
      repo: 'https://github.com/aument-lang/aument',
    },
    'AutoHotKey':{
      desc: "Pattern-matching, text-processing, and scripting",
      highlighting:"autohotkey",
      ext: 'ahk',
      kor: '오토핫키',
      template:"autohotkey",
      icon:'mdi-keyboard-outline',
      command:'([ -f /tmp/xvfb.pid ] || (/etc/init.d/xvfb start && sleep 2)) && DISPLAY=:0 WINEPATH=C:\\\\AutoHotKey wine Ahk2Exe.exe /in {FILENAME}.{EXT} /out {FILENAME}.exe {ARGS} && imshow ./{FILENAME}.exe',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.autohotkey.com',
      repo: 'https://www.autohotkey.com/download',
    },
    'AutoIt':{
      desc: "Scripting, automation, and Windows-focused",
      highlighting:"autoit",
      ext: 'au3',
      kor: '오토잇',
      template:"autoit",
      icon:'mdi-alpha-a-circle',
      args: '/nopack',
      command:'WINEPATH=C:\\\\Autoit wine Au3Check.exe {FILENAME}.{EXT} && WINEPATH=C:\\\\Autoit\\\\Aut2Exe wine Aut2exe.exe /in {FILENAME}.{EXT} /out {FILENAME}.exe {ARGS} && imshow ./{FILENAME}.exe',
      cli: null,
      errorRegEx: ".*?\\((\\d+),\\d+\\) : (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.autoitscript.com',
      repo: 'https://www.autoitscript.com/site/autoit/downloads',
    },
    'B':{
      desc: "Simple, procedural, and early programming language",
      highlighting:"c",
      ext: 'b',
      kor: 'B언어 - ybc',
      template:'b',
      icon:'mdi-alpha-b',
      command:'rm -f {FILENAME} && ybc {ARGS} -o `pwd`/{FILENAME} `pwd`/{FILENAME}.{EXT} && [ -f {FILENAME} ] && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.b\\] at line (\\d+), (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.bell-labs.com/usr/dmr/www/bintro.html',
      repo: 'https://github.com/AlexCeleste/ybc',
    },
    'Bacon':{
      desc: "Simple, data-driven, and extensible scripting",
      highlighting:"vb",
      ext: 'bac',
      kor: '베이컨',
      template:'bacon',
      icon:'mdi-pig-variant',
      args:'-y -z',
      command:'bacon {ARGS} {FILENAME} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?: .+? line (\\d+) in file .+?\\.bac: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://bkhome.org/archive/bacon',
      repo: 'https://github.com/tomgco/bacon',
    },
    'Baik':{
      desc: "Concise, modern, statically-typed, expressive, efficient",
      highlighting:"baik",
      ext: 'ina',
      kor: '바이크',
      template:'baik',
      icon:'mdi-map',
      command:'baik {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "Program Utama : .+? (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://baik-lang.id/baikx',
      repo: 'https://github.com/baik-lang/baik',
    },
    'Ballerina':{
      desc: "Concurrent, integration-focused, expressive, type-safe, declarative",
      highlighting:"ballerina",
      ext: 'bal',
      kor: '발레리나',
      template:'ballerina',
      icon:'mdi-human-handsup',
      args: 'build {FILENAME}.{EXT} && java -jar {FILENAME}.jar',
      command:'/opt/ballerina/bin/bal {ARGS}',
      cli: '/opt/ballerina/bin/bal shell',
      errorRegEx: ".+\\.bal:\\((\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://ballerina.io',
      repo: 'https://github.com/ballerina-platform/ballerina-lang',
    },
    'Barn':{
      desc: "Simple, efficient",
      highlighting:"barn",
      ext: 'ba',
      kor: '반',
      template:'barn',
      icon:'mdi-barn',
      command:'barn {ARGS} {FILENAME}.{EXT} && ./a.out',
      cli: null,
      errorRegEx: ".+\\.ba:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://barn-lang.github.io/barn-docs',
      repo: 'https://github.com/barn-lang/barn',
    },
    'Bas':{
      desc: "Procedural, simple, educational, legacy, intuitive",
      highlighting:"vb",
      ext: 'bas',
      kor: '바스',
      template:'bas',
      icon:'mdi-alpha-b-box-outline',
      args: null,
      command:'/opt/bas/bin/bas {ARGS} {FILENAME}.{EXT}',
      cli: '/opt/bas/bin/bas {ARGS}',
      errorRegEx: "Error: .+? in line (\\d+) at:\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.moria.de/~michael/bas',
      repo: 'https://github.com/zvezdochiot/bas',
    },
    'BASIC (FreeBASIC)':{
      desc: "Simple, procedural, and beginner-friendly interpreter",
      highlighting:"vb",
      ext: 'bas',
      kor: '베이식 - FreeBASIC',
      template:'basic',
      icon:'mdi-alpha-b-box-outline',
      args: '-lang deprecated',
      command:'fbc {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".*?\\((\\d+)\\) (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://freebasic.net',
      repo: 'https://github.com/freebasic/fbc',
    },
    'Battlestar':{
      desc: "Game-oriented, scripting, dynamic, flexible, interactive",
      highlighting:"battlestar",
      ext: 'bts',
      kor: '배틀스타',
      template:'battlestar',
      icon:'mdi-airport',
      args: 'run',
      command:'bts {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://rosettacode.org/wiki/Category:Battlestar',
      repo: 'https://github.com/xyproto/battlestar',
    },
    'Bau':{
      desc: "simple, concise, safe, powerful and fast, memory-safe, statically typed",
      highlighting:"bau",
      ext: 'bau',
      kor: '바우',
      template:'bau',
      icon:'mdi-bookmark-outline',
      args: null,
      command:'bau {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: '.+? at line (\\d+):',
      keyBindings: null,
      dockerImage: 'ryusatgat/jvm',
      homepage: 'https://thomasmueller.github.io/bau-lang',
      repo: 'https://github.com/thomasmueller/bau-lang',
    },
    'BBC BASIC':{
      desc: "Interpreted",
      highlighting:"vb",
      ext: 'bas',
      kor: 'BBC베이식',
      template:'bbcbasic',
      icon:'mdi-alpha-b-box-outline',
      args: '-quit',
      command:'echo -e "LOAD {FILENAME}.{EXT}\nSAVE {FILENAME}.bbc\n*QUIT" | bbcbasic > /dev/null && bbcbasic {ARGS} {FILENAME}.bbc',
      cli: 'bbcbasic',
      errorRegEx: ".+? at line (\\d+)",
      keyBindings: null,
      dockerImage: "ryusatgat/bbcbasic",
      homepage: 'https://www.bbcbasic.co.uk',
      repo: 'https://www.bbcbasic.net/console',
    },
    'BC':{
      desc: "Precision, arithmetic, and command-line calculator",
      highlighting:"bc",
      ext: 'bc',
      kor: 'BC(계산기)',
      template:'bc',
      icon:'mdi-calculator',
      command:'bc {ARGS} < {FILENAME}.{EXT}',
      cli: "bc {ARGS}",
      errorRegEx: "\\(.+?\\) (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gnu.org/software/bc',
      repo: 'https://ftp.gnu.org/gnu/bc',
    },
    'BCPL':{
      desc: "Simple, procedural, and system-oriented compiler",
      highlighting:"bcpl",
      ext: 'b',
      kor: 'BCPL',
      template:'bcpl',
      icon:'mdi-alpha-b-circle-outline',
      command:'source /opt/BCPL/setbcplenv && echo -e "c b64 {FILENAME}\n{FILENAME}\n" > {FILENAME}.in && cintsys64  {ARGS} < {FILENAME}.in',
      cli: "bcpl {ARGS}",
      errorRegEx: "Error .+?\\[(\\d+)\\]: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.cl.cam.ac.uk/~mr10/BCPL.html',
      repo: 'https://github.com/8l/bcpl',
    },
    'Bean':{
      desc: "Lightweight, Java-based, and modular compiler",
      highlighting:"bean",
      ext: 'bn',
      kor: '빈',
      template:'bean',
      icon:'mdi-scatter-plot-outline',
      command:'/opt/bean/bean {ARGS} {FILENAME}.{EXT}',
      cli: "/opt/bean/bean",
      errorRegEx: ".+?\\.bn:(\\d+) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/lanzhiheng',
      repo: 'https://github.com/lanzhiheng/bean',
    },
    'BeanShell':{
      desc: "Scripting, lightweight, and Java-compatible interpreter",
      highlighting:"java",
      ext: 'bsh',
      kor: '빈셸',
      template:'beanshell',
      icon:'mdi-peanut-outline',
      command:'/opt/beanshell/bsh {ARGS} {FILENAME}.{EXT}',
      cli: "/opt/beanshell/bsh",
      errorRegEx: ".+?Error: .+? at [lL]ine:? (\\d+)[, ](.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.beanshell.org',
      repo: 'https://github.com/beanshell/beanshell',
    },
    'Befunge':{
      desc: "Esoteric, two-dimensional, stack-based, minimalistic, unconventional",
      highlighting:"befunge",
      ext: 'bf',
      kor: '비펀지',
      template:'befunge',
      icon:'mdi-football-helmet',
      args: '-q',
      command:'bef {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://catseye.tc/node/Befunge-93',
      repo: 'https://github.com/catseye/Befunge-93',
    },
    'Bend':{
      desc: "High-level, massively parallel, HVM, CUDA",
      highlighting:"bend",
      ext: 'bend',
      kor: '벤드',
      template:'bend',
      icon:'mdi-view-parallel',
      tabSize: 2,
      args: 'run',
      command:'bend {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "  (\\d+) \\| (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/rust",
      homepage: 'https://higherorderco.com',
      repo: 'https://github.com/HigherOrderCO/Bend',
    },
    'Berry':{
      desc: "Esoteric, two-dimensional, and stack-based interpreter",
      highlighting:"berry",
      ext: 'be',
      kor: '베리',
      template:'berry',
      icon:'mdi-egg-easter',
      command:'berry {ARGS} {FILENAME}.{EXT}',
      cli: 'berry',
      errorRegEx: ".+?\\.be:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://berry-lang.github.io',
      repo: 'https://github.com/berry-lang/berry',
    },
    'Beryl':{
      desc: "Small, embeddable scripting, executes directly",
      highlighting:"beryl",
      ext: 'beryl',
      kor: '베릴',
      template:'beryl',
      icon:'mdi-diamond-outline',
      command:'BERYL_SCRIPT_INIT=/opt/beryl/berylscript/init.beryl beryl {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/KarlAndr1',
      repo: 'https://github.com/KarlAndr1/beryl',
    },
    'Bhuna':{
      desc: "Functional, high-level, and concurrent interpreter",
      highlighting:"bhuna",
      ext: 'bhu',
      kor: '부나',
      template:'bhuna',
      icon:'mdi-pot-steam-outline',
      command:'bhuna {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+ \\(line (\\d+), (column \\d+.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://catseye.tc/node/Bhuna',
      repo: 'https://github.com/catseye/Bhuna',
    },
    'Bimble':{
      desc: "Procedural, simplicity, modern, enjoyable, user-friendly",
      highlighting:"bimble",
      ext: 'bb',
      kor: '빔블',
      template:'bimble',
      icon:'mdi-music-accidental-flat',
      command:' echo name:{FILENAME}>config.bconf && bimble build . && build/{FILENAME}_lin',
      cli: null,
      errorRegEx: "",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://virtuastartups.gitbook.io/bimble',
      repo: 'https://github.com/VStartups/bimble',
    },
    'Bite':{
      desc: "Dynamically typed, object oriented, written in C#.",
      highlighting:"bite",
      ext: 'bite',
      kor: '바이트',
      template:"bite",
      icon:'mdi-cookie',
      command:"bite {ARGS} -i {FILENAME}.{EXT}",
      cli: 'bite',
      errorRegEx: '.+?: line (\\d+): (.+)',
      defaultFilename: 'Main',
      keyBindings: null,
      dockerImage: "ryusatgat/ms",
      homepage: 'https://github.com/Maximilian-Winter/Bite-Programming-Language/wiki',
      repo: 'https://github.com/Maximilian-Winter/Bite-Programming-Language',
    },
    'BlackLight':{
      desc: "Concurrent, stack-based, concatenative, threadsafe",
      highlighting:"blacklight",
      ext: 'bl',
      kor: '블랙라이트',
      template:'blacklight',
      icon:'mdi-lightbulb-cfl-spiral',
      command:'blacklight {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+\\.bl BL_LINE#(\\d+) BL_LINE_COL#\\d+ (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://blog.anthonymcook.com/blacklight',
      repo: 'https://github.com/acook/blacklight',
    },
    'Blade':{
      desc: "Staged, Compiled, Embedded, Efficient, DSL",
      highlighting:"blade",
      ext: 'b',
      kor: '블레이드',
      template:'blade',
      icon:'mdi-alpha-b',
      command:'blade {ARGS} {FILENAME}.{EXT}',
      cli: 'blade',
      errorRegEx: ".+?: .+?\r\n.+\\.b:(\\d+)",
      keyBindings: null,
      dockerImage: "ryusatgat/blade",
      homepage: 'https://bladelang.org',
      repo: 'https://github.com/blade-lang/blade',
    },
    'Blombly':{
      desc: "interpreted by the BLOck aseMBLY Virtual Machine",
      highlighting:"blombly",
      ext: 'bb',
      kor: '블롬블리',
      template:'blombly',
      icon:'mdi-code-block-brackets',
      command:'blombly {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\.bb line (\\d+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/blombly',
      homepage: 'https://blombly.readthedocs.io/en/latest',
      repo: 'https://github.com/maniospas/Blombly',
    },
    'Blossom':{
      desc: "Declarative, type-safe, modular, concise, expressive",
      highlighting:"blossom",
      ext: 'bls',
      kor: '블라섬',
      template:'blossom',
      icon:'mdi-flower-tulip-outline',
      command:'blossom {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\.bls:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://cstanze.github.io/blossom',
      repo: 'https://github.com/cstanze/blossom',
    },
    'Blue':{
      desc: "Concise, modern, high-level, expressive, flexible",
      highlighting:"blue",
      ext: 'bl',
      kor: '블루',
      template:'blue',
      icon:'mdi-blur',
      command:'blue {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\r\n(?:.+?\\.bl +?)?line: ?(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://cstanze.github.io/blossom',
      repo: 'https://github.com/elechak/blue',
    },
    'Bluespec':{
      desc: "Hardware-oriented, high-level, declarative, concurrent, expressive",
      highlighting:"bluespec",
      ext: 'bsv',
      kor: '블루스펙',
      template:'bluespec',
      icon:'mdi-alpha-b',
      command:'/opt/bluespec/bin/bsc {ARGS} -verilog {FILENAME}.{EXT} && /opt/bluespec/bin/bsc -o {FILENAME} -e {FILENAME}_module {FILENAME}_module.v && ./{FILENAME}',
      cli: null,
      errorRegEx: "Error: .+?, line (\\d+), .*?\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://bluespec.com',
      repo: 'https://github.com/B-Lang-org/bsc',
    },
    'Bob':{
      desc: "Declarative, rule-based, and interactive interpreter",
      highlighting:"bob",
      ext: 'bob',
      kor: '밥',
      template:'bob',
      icon:'mdi-flask-round-bottom-empty-outline',
      command:'bob {ARGS} {FILENAME}.{EXT}',
      cli: 'bob',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/dbetz',
      repo: 'https://github.com/dbetz/bob',
    },
    'Bone Lisp':{
      desc: "Minimalistic, Lisp-based, dynamic, extensible, simple",
      highlighting:"lisp",
      ext: 'bn',
      kor: '본리스프',
      template:'bonelisp',
      icon:'mdi-skull-crossbones-outline',
      command:'cd /opt/bone\n/opt/bone/bone {ARGS} ${OLDPWD}/{FILENAME}.{EXT} ; cd - > /dev/null',
      cli: 'cd /opt/bone\n/opt/bone/bone ; cd - > /dev/null',
      errorRegEx: ".+?\\.bn\":(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/wolfgangj',
      repo: 'https://github.com/wolfgangj/bone-lisp',
    },
    'Boo':{
      desc: "Object-oriented, dynamic, statically-typed, concise, flexible",
      highlighting:"python",
      ext: 'boo',
      kor: '부',
      template:'boo',
      icon:'mdi-dot-net',
      command:'booi {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+\\((\\d+),\\d+\\): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://boo-language.github.io',
      repo: 'https://github.com/boo-lang/boo',
    },
    'Borland C++':{
      desc: "Integrated, efficient, object-oriented, legacy, compiled",
      highlighting:"cpp",
      ext: 'cpp',
      kor: '볼랜드 C++',
      template:"bcpp",
      icon:'mdi-microsoft-windows-classic',
      args: '-lq  -IC:\\\\bcc55\\\\Include -LC:\\\\bcc55\\\\Lib',
      command:'WINEPATH=C:\\\\bcc55\\\\Bin wine bcc32 {ARGS} {FILENAME}.{EXT} && wine ./{FILENAME}.exe',
      cli: null,
      errorRegEx: ".*? (\\d+): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Borland_C%2B%2B',
      repo: 'https://www.embarcadero.com/free-tools/ccompiler',
    },
    'Borealis':{
      desc: "High-level, concurrent, modular, extensible",
      highlighting:"borealis",
      ext: 'bor',
      kor: '보어앨리스',
      template:"borealis",
      icon:'mdi-octagon-outline',
      args: '-f {FILENAME}.{EXT}',
      command:'borealis {ARGS}',
      cli: null,
      errorRegEx: ".+?: .+\r\nLine: (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://getborealis.com',
      repo: 'https://github.com/Usbac/borealis',
    },
    'Boron':{
      desc: "Lightweight, scripting, dynamic, flexible, modern",
      highlighting:"boron",
      ext: 'b',
      kor: '보론',
      template:"boron",
      icon:'mdi-octagon-outline',
      command:'boron {ARGS} {FILENAME}.{EXT}',
      cli: 'boron',
      errorRegEx: ".+?: .+? \\(line (\\d+)\\)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://urlan.sourceforge.io/boron',
      repo: 'https://sourceforge.net/projects/urlan/files',
    },
    'Boson':{
      desc: "Functional, concurrent, type-safe, modern, expressive",
      highlighting:"boson",
      ext: 'bs',
      kor: '보손',
      template:"boson",
      icon:'mdi-atom-variant',
      command:'/opt/boson/boson {FILENAME}.{EXT} && gcc -o {FILENAME} {FILENAME}.o /opt/boson/startupscript.o && ./{FILENAME}',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://bosonlang.org/Home',
      repo: 'https://github.com/Narasimha1997/boson-lang',
    },
    'BrainFuck':{
      desc: "Esoteric, minimalist, Turing-complete, challenging, low-level",
      highlighting:"bf",
      ext: 'bf',
      kor: '브레인퍽',
      template:"bf",
      icon:'mdi-brain',
      command:'bf {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://esolangs.org/wiki/Brainfuck',
      repo: 'https://github.com/Jomy10/Brainfuck-rs',
    },
    'Brandy':{
      desc: "Interpreter for BBC Basic",
      highlighting:"vb",
      ext: 'bas',
      kor: '브랜디',
      template:'brandy',
      icon:'mdi-glass-tulip',
      args: '-quit',
      command:'brandy {ARGS} {FILENAME}.{EXT}',
      cli: 'brandy',
      errorRegEx: '[lL]ine (\\d+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://jaguar.orpheusweb.co.uk/',
      repo: 'https://jaguar.orpheusweb.co.uk/branpage.html',
    },
    'Brat':{
      desc: "Dynamic, prototype-based, minimalistic, scripting, flexible",
      highlighting:"brat",
      ext: 'brat',
      kor: '브랫',
      template:"brat",
      icon:'mdi-human-child',
      command:'brat {ARGS} {FILENAME}.{EXT}',
      cli: "brat {ARGS}",
      errorRegEx: ".+? on line (\\d+)(:)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.brat-lang.info',
      repo: 'https://github.com/presidentbeef/brat',
    },
    'Buzz':{
      desc: "Esoteric, minimalist, stack-based, experimental, unconventional",
      highlighting:"buzz",
      ext: 'bzz',
      kor: '버즈',
      template:"buzz",
      icon:'mdi-bee',
      command:'bzzc {ARGS} {FILENAME}.{EXT} && bzzrun {FILENAME}.bo {FILENAME}.bdb',
      cli: null,
      errorRegEx: ".+?\\.bzz:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://the.swarming.buzz',
      repo: 'https://github.com/buzz-lang/Buzz',
    },
    'Bywater BASIC':{
      desc: "Simple, educational, procedural, interpreted, interactive",
      highlighting:"vb",
      ext: 'bas',
      kor: '바이워터 베이식',
      template:'bwbasic',
      icon:'mdi-cup-water',
      command:'bwbasic {ARGS} {FILENAME}.{EXT}',
      cli: 'bwbasic {ARGS}',
      errorRegEx: "Program Utama : .+? (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sourceforge.net/projects/bwbasic',
      repo: 'https://github.com/nerun/bwbasic',
    },
    'C2':{
      desc: "Minimalistic, procedural, concise, lightweight, efficient",
      highlighting:"c2",
      ext: 'c2',
      kor: 'C2',
      template:'c2',
      icon:'mdi-numeric-2-circle-outline',
      command:'/opt/c2/bin/gen_recipe {FILENAME} && C2_LIBDIR=/opt/c2/lib /opt/c2/bin/c2c {ARGS} && output/{FILENAME}/{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.c2:(\\d+):\\d+: error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://c2lang.org',
      repo: 'https://github.com/c2lang',
    },
    'C3':{
      desc: "Concise, functional, modern, expressive, dynamic, C-like",
      highlighting:"c3",
      ext: 'c3',
      kor: 'C3',
      template:'c3',
      icon:'mdi-numeric-3-circle-outline',
      args: 'compile',
      command:'c3c {ARGS} {FILENAME}.{EXT} > /dev/null && ./{FILENAME}',
      cli: null,
      errorRegEx: "\\(.+?\\.c3:(\\d+)\\) Error: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'http://www.c3-lang.org',
      repo: 'https://github.com/c3lang',
    },
    'Caboose':{
      desc: "Concise, expressive, functional, modular, high-level",
      highlighting:"caboose",
      ext: 'cb',
      kor: '카부스',
      template:'caboose',
      icon:'mdi-bag-carry-on',
      command:'cb {ARGS} {FILENAME}.{EXT}',
      cli: 'cb {ARGS}',
      errorRegEx: "\\[line (\\d+)\\] Error(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/studio-code',
      repo: 'https://github.com/studio-code/CabooseLang',
    },
    'CakeLisp':{
      desc: "High performance, iteratively-developed, inspiration from Lisp",
      highlighting:"cakelisp",
      ext: 'cake',
      kor: '케이크리스프',
      template:"cakelisp",
      icon:'mdi-cake',
      args: '--execute',
      command:"cakelisp {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.cake:(\\d+):\\d+: error: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://macoy.me/blog/programming/CakelispIntro',
      repo: 'https://github.com/makuto/cakelisp',
    },
    'Calc4':{
      desc: "Everything in its code is an operator",
      highlighting:"calc4",
      ext: 'calc4',
      kor: '캘크4',
      template:"calc4",
      icon:'mdi-calculator',
      args: null,
      command:"calc4 {ARGS} {FILENAME}.{EXT}",
      cli: 'calc4',
      errorRegEx: ".+?\\.calc4:(\\d+):\\d+: Error: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://proprowataya.github.io/calc4',
      repo: 'https://github.com/proprowataya/calc4',
    },
    'CAML (OCaml)':{
      desc: "Functional, type-safe, expressive, concise, powerful",
      highlighting:"ocaml",
      ext: 'ml',
      kor: 'CAML - camllight',
      template:"caml",
      icon:'mdi-image-size-select-actual',
      command:"camlc {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: "camllight",
      errorRegEx: "(\\d+) \\| (.+?\r\n.+\r\n.+: .*)",
      keyBindings: null,
      homepage: 'https://ocaml.org',
      repo: 'https://github.com/ocaml/ocaml',
    },
    'Cant':{
      desc: "Descended mainly from E and Scheme",
      highlighting:"cant",
      ext: 'cant',
      kor: '캔트',
      template:"cant",
      icon:'mdi-sine-wave',
      args: null,
      command:"incant {ARGS} {FILENAME}.{EXT}",
      cli: 'incant',
      errorRegEx: "",
      keyBindings: null,
      dockerImage: "ryusatgat/scheme",
      homepage: 'https://github.com/darius/cant/blob/master/guide.md',
      repo: 'https://github.com/darius/cant',
    },
    'Carbon':{
      desc: "Modern, statically-typed, high-performance, C++-compatible, safe",
      highlighting:"carbon",
      ext: 'carbon',
      kor: '카본',
      template:"carbon",
      icon:'mdi-octagram-outline',
      command:"ASAN_OPTIONS=use_sigaltstack=false /opt/carbon/explorer {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*? ERROR: .*?:(\\d+): (.+)",
      keyBindings: null,
      //dockerImage: "ryusatgat/carbon",
      homepage: 'http://docs.carbon-lang.dev',
      repo: 'https://github.com/carbon-language/carbon-lang',
    },
    'Carp':{
      desc: "Statically-typed, functional, minimalist, efficient, expressive",
      highlighting:"carp",
      ext: 'carp',
      kor: ' 카프',
      template:"carp",
      icon:'mdi-fishbowl-outline',
      command:'CARP_DIR=/opt/carp /opt/carp/bin/carp {ARGS} -x {FILENAME}.{EXT}',
      cli: "CARP_DIR=/opt/carp /opt/carp/bin/carp {ARGS}",
      errorRegEx: ".+? at .+?\\.carp:(\\d+):(\\d+.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/carp-lang/Carp/blob/master/docs/LanguageGuide.md',
      repo: 'https://github.com/carp-lang/Carp',
    },
    'Castile':{
      desc: "Object-oriented, type-safe, modular, expressive, modern",
      highlighting:"castile",
      ext: 'castile',
      kor: ' 카스티야',
      template:"castile",
      icon:'mdi-map-legend',
      command:'castile {ARGS} {FILENAME}.{EXT}',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://catseye.tc/node/Castile',
      repo: 'https://github.com/catseye/Castile',
    },
    'Ceu':{
      desc: "Concurrent, reactive, event-driven, deterministic, high-level",
      highlighting:"ceu",
      ext: 'ceu',
      kor: '세우',
      template:'ceu',
      icon:'mdi-alpha-c-box-outline',
      args: "",
      command:'/opt/ceu/bin/ceuc {FILENAME}.{EXT} {ARGS} && ./{FILENAME}',
      cli: null,
      errorRegEx: "ERR : .+? : line (\\d+) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.ceu-lang.org',
      repo: 'https://github.com/ceu-lang/ceu',
    },
    'Ceylon':{
      desc: "Modular, type-safe, expressive, JVM-compatible, concise",
      highlighting:"ceylon",
      ext: 'ceylon',
      kor: '실론',
      template:'ceylon',
      icon:'mdi-elephant',
      args: "run --compile=force --run={FILENAME} default",
      command:'mkdir -p source && mv -f {FILENAME}.{EXT} source && ceylon {ARGS}',
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+?:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://ceylon-lang.org',
      repo: 'https://github.com/eclipse-archived/ceylon',
    },
    'ChaiScript':{
      desc: "Embedded, scripting, C++-integrated, dynamic, expressive",
      highlighting:"chaiscript",
      ext: 'chai',
      kor: '카이스크립트',
      template:"chaiscript",
      icon:'mdi-snowflake',
      command:'chai {ARGS} {FILENAME}.{EXT}',
      cli: "chai {ARGS}",
      errorRegEx: "Error: .+? \\(.*?(\\d+), \\d+\\)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://chaiscript.com',
      repo: 'https://github.com/ChaiScript/ChaiScript',
    },
    'Chaos':{
      desc: "Esoteric, Minimalistic, Unconventional, Turing-complete, Obfuscated",
      highlighting:"chaos",
      ext: 'kaos',
      kor: '카오스',
      template:"chaos",
      icon:'mdi-rotate-3d-variant',
      command:'chaos {ARGS} {FILENAME}.{EXT}',
      cli: "chaos",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://chaos-lang.org',
      repo: 'https://github.com/chaos-lang',
    },
    'Chapel':{
      desc: "Concurrent, parallel, high-level, scalable, expressive",
      highlighting:"chapel",
      ext: 'chpl',
      kor: '채플',
      template:"chapel",
      icon:'mdi-church',
      args: '--baseline',
      command:'/opt/chapel/bin/chpl {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+\\.chpl:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://chapel-lang.org',
      repo: 'https://github.com/chapel-lang/chapel',
    },
    'Chipmunk Basic':{
      desc: "Simple, educational, procedural, interpreted, interactive",
      highlighting:"vb",
      ext: 'bas',
      kor: '칩멍크 베이식',
      template:'cbasic',
      icon:'mdi-foot-print',
      command:'basic {ARGS} {FILENAME}.{EXT}',
      cli: "basic {ARGS}",
      errorRegEx: ".+ line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.nicholson.com/rhn/basic',
      repo: 'http://www.nicholson.com/rhn/files',
    },
    'Cheddar':{
      desc: "Type-safe, functional, statically-typed, expressive, concise",
      highlighting:"cheddar",
      ext: 'cdr',
      kor: '체다',
      template:'cheddar',
      icon:'mdi-cheese',
      command:'cheddar {ARGS} {FILENAME}.{EXT}',
      cli: "cheddar",
      errorRegEx: ".+? at (\\d+):(\\d+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://cheddar.vihan.org',
      repo: 'https://github.com/cheddar-lang/Cheddar',
    },
    'Chef':{
      desc: "Esoteric, playful, code-as-recipe, minimalistic, unconventional",
      highlighting:"chef",
      ext: 'chef',
      kor: '셰프',
      template:'chef',
      icon:'mdi-chef-hat',
      command:'rchef {ARGS} {FILENAME}.{EXT}',
      errorRegEx: "\\[line (\\d+)\\] runtime error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.dangermouse.net/esoteric/chef.html',
      repo: 'https://github.com/booleancoercion/rchef',
    },
    'ChibiScheme':{
      desc: "Small library intended for use as an extension and scripting language",
      highlighting:"scheme",
      ext: 'scm',
      kor: '치비스킴',
      template:"chibischeme",
      icon:'mdi-lambda',
      args: null,
      command:"chibi-scheme {ARGS} {FILENAME}.{EXT}",
      cli: "chibi-scheme",
      errorRegEx: "ERROR on line (\\d+) of file .+",
      keyBindings: null,
      dockerImage: "ryusatgat/scheme",
      homepage: 'https://synthcode.com/scheme/chibi',
      repo: 'https://github.com/ashinn/chibi-scheme',
    },
    'CHICKEN Scheme':{
      desc: "Implements R5RS",
      highlighting:"scheme",
      ext: 'scm',
      kor: '치킨스킴',
      template:"chickenscheme",
      icon:'mdi-lambda',
      args: null,
      command:"csc {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.scm:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/scheme",
      homepage: 'https://code.call-cc.org',
      repo: 'https://code.call-cc.org/git/chicken-core.git',
    },
    'Chili':{
      desc: "Concurrent, Reactive, Statically-typed, Embedded, Efficient",
      highlighting:"chili",
      ext: 'chl',
      kor: '칠리',
      template:'chili',
      icon:'mdi-chili-mild',
      args: '--no-color --run',
      command:'/opt/chili/chili {ARGS} {FILENAME}.{EXT}',
      errorRegEx: "error: .+?\r\n.+?.+?\\.chl:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/ubuntu2004",
      homepage: 'https://github.com/r0nsha',
      repo: 'https://github.com/r0nsha/chili',
    },
    'Chuck':{
      desc: "Audio-oriented, concurrent, real-time, expressive, dynamic",
      highlighting:"chuck",
      ext: 'ck',
      kor: '척',
      template:"chuck",
      icon:'mdi-music-note',
      args: '--silent',
      command:'/opt/chuck/chuck {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "\\[.+?\\.ck\\]:line\\((\\d+)\\)(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://chuck.stanford.edu',
      repo: 'https://github.com/ccrma/chuck',
    },
    'Ciao':{
      desc: "Logic-based, declarative, multi-paradigm, flexible, extensible",
      highlighting:"ciao",
      ext: 'pl',
      kor: '차오',
      template:"ciao",
      icon:'mdi-human-greeting',
      args: '-o {FILENAME}',
      command:'ciaoc {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: "ciao",
      errorRegEx: "ERROR: \\(lns \\d+-(\\d+)\\)(.+\r\n.+\r\n.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/ciao',
      homepage: 'https://ciao-lang.org',
      repo: 'https://github.com/ciao-lang/ciao',
    },
    'CIL':{
      desc: "Intermediate, portable, platform-independent, bytecode, modular",
      highlighting:"cil",
      ext: 'il',
      kor: '공통중간언어 - ilasm',
      template:"cil",
      icon:'mdi-dot-net',
      command:"ilasm {FILENAME}.{EXT} -out:{FILENAME}.exe && mono {FILENAME}.exe",
      cli: null,
      errorRegEx: ".+?\\((\\d+), \\d+\\) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://cil-project.github.io/cil',
      repo: 'https://github.com/cil-project/cil',
    },
    'Circle':{
      desc: "Functional, statically-typed, concise, expressive, modern",
      highlighting:"cpp",
      ext: 'cxx',
      kor: '서클',
      template:"circle",
      icon:'mdi-circle-double',
      command:"circle {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+\\.cxx:(\\d+):(\\d+).*\r\n.+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.circle-lang.org',
      repo: 'https://github.com/seanbaxter/circle',
    },
    'Cish':{
      desc: "Minimal, performant, strongly-typed, multi-paradigmn",
      highlighting:"cish",
      ext: 'cish',
      kor: '시쉬',
      template:"cish",
      icon:'mdi-alpha-c',
      args: '-cr -s {FILENAME}.{EXT}',
      command:'ln -sf /opt/cish/stdlib && cish {ARGS}',
      cli: null,
      errorRegEx: ".+?\\.cish: row (\\d+), col \\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/TheRealMichaelWang/cish/wiki',
      repo: 'https://github.com/TheRealMichaelWang/cish',
    },
    'Citrine':{
      desc: "Concise, dynamic, object-oriented, expressive, modern",
      highlighting:"citrine",
      ext: 'ctr',
      kor: '시트린',
      template:"citrine",
      icon:'mdi-diamond-stone',
      args: "",
      command:"/opt/citrine/bin/ctren {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? \\( ?.+\\.ctr: (\\d+) ?\\)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://citrine-lang.org',
      repo: 'https://github.com/gabordemooij/citrine',
    },
    'Citron':{
      desc: "Statically-typed, object-oriented, expressive, concise, modern",
      highlighting:"citron",
      ext: 'ctr',
      kor: '시트론',
      template:"citron",
      icon:'mdi-storefront-outline',
      args: "",
      command:"/opt/citron/bin/ctr {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? \\(.+\\.ctr: (\\d+)\\)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://alimpfard.github.io/citron_book/book',
      repo: 'https://github.com/alimpfard/citron',
    },
    'Clean':{
      desc: "Functional, lazy, pure, statically-typed, concise",
      highlighting:"clean",
      ext: 'icl',
      kor: '클린',
      template:"clean",
      icon:'mdi-silverware-clean',
      args: '-nw -ms',
      command:'ln -sfT /opt/clean clean\nclean/bin/clm {ARGS} {FILENAME} -o {FILENAME} && ./{FILENAME}',
      cli: null,
      errorRegEx: "(?:Parse )?[Ee]rror \\[.+?\\.icl,(\\d+).*?\\]: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://clean-lang.org',
      repo: 'https://github.com/Abhiroop/Clean',
    },
    'Clipper(harbour)':{
      desc: "Procedural, database-oriented, compiled, legacy, efficient",
      highlighting:"clipper",
      ext: 'prg',
      kor: '클리퍼 - 하버',
      template:"clipper",
      icon:'mdi-flag-triangle',
      args: '-q0',
      command:'harbour {ARGS} {FILENAME}.{EXT} && gcc -I/usr/local/include/harbour -o {FILENAME} {FILENAME}.c -lharbour && ./{FILENAME}',
      cli: null,
      defaultFilename: 'program',
      errorRegEx: ".+?\\.prg\\((\\d+)\\) Error (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://harbour.github.io',
      repo: 'https://sourceforge.net/projects/harbour-project/files',
    },
    'CLIPS':{
      desc: "Rule-based, expert-system, declarative, logical, extensible",
      highlighting:"clips",
      ext: 'clp',
      kor: '클립스',
      template:"clips",
      icon:'mdi-pencil-ruler',
      args: '-f2',
      command:'/opt/clips/clips {ARGS} {FILENAME}.{EXT}',
      cli: '/opt/clips/clips',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.clipsrules.net',
      repo: 'https://sourceforge.net/projects/clipsrules/files',
    },
    'Clojure':{
      desc: "Functional, immutable, Lisp-based, concurrent, expressive",
      highlighting:"clojure",
      ext: 'clj',
      kor: '클로저',
      template:"clojure",
      icon:'mdi-chart-donut-variant',
      command:'clojure {ARGS} {FILENAME}.{EXT}',
      cli: "clojure {ARGS}",
      errorRegEx: ".*?\\(.*?:(\\d+)\\:(\\d+)\\).",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://clojure.org',
      repo: 'https://github.com/clojure/clojure',
    },
    'CLox':{
      desc: "ByteCode VM, lox implementation, stacked based, on-demand scanner",
      highlighting:"lox",
      ext: 'lox',
      kor: '클록스',
      template:"clox",
      icon:'mdi-pill',
      command:'CLox {ARGS} {FILENAME}.{EXT}',
      cli: "CLox",
      errorRegEx: "\\[line (\\d+)\\] Error at (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/HallofFamer',
      repo: 'https://github.com/HallofFamer/CLox',
    },
    'Clover':{
      desc: "Type-safe, functional, modular, concise, expressive",
      highlighting:"clover",
      ext: 'cl',
      kor: '클로버',
      template:"clover",
      icon:'mdi-clover',
      command:'/opt/clover/bin/cclover {ARGS} {FILENAME}.{EXT} && /opt/clover/bin/clover {ARGS} {FILENAME}.{EXT}',
      cli: "/opt/clover/bin/iclover",
      errorRegEx: ".+?\\.cl (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/ab25cq',
      repo: 'https://github.com/ab25cq/clover',
    },
    'Clue':{
      desc: "Fast, simple, Lua",
      highlighting:"clue",
      ext: 'clue',
      kor: '클루',
      template:"clue",
      icon:'mdi-help',
      args: null,
      command:'clue {ARGS} {FILENAME}.{EXT} > /dev/null && lua {FILENAME}.lua',
      cli: null,
      errorRegEx: "Error in .+?\\.clue:(\\d+):\\d+!\r\n(.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://crates.io/crates/clue',
      repo: 'https://github.com/ClueLang/Clue',
    },
    'Cobol':{
      desc: "Business-oriented, procedural, verbose, legacy, structured",
      highlighting:"cobol",
      ext: 'cob',
      kor: '코볼',
      template:"cobol",
      icon:'mdi-alpha-c-circle-outline',
      command:'cobc {ARGS} -x {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".*?: (\\d+): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/COBOL',
      repo: 'https://sourceforge.net/projects/gnucobol/files/',
    },
    'CobolScript':{
      desc: "Business-oriented, procedural, scripting, legacy, verbose",
      highlighting:"cobol",
      ext: 'cob',
      kor: '코볼스크립트',
      template:"cobolscript",
      icon:'mdi-alpha-c-box-outline',
      command:'node /opt/cobolscript/run {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".*?: (\\d+): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/ajlopez',
      repo: 'https://github.com/ajlopez/CobolScript',
    },
    'Cobra':{
      desc: "Object-oriented, statically-typed, expressive, concurrent, dynamic",
      highlighting:"cobra",
      ext: 'cobra',
      kor: '코브라',
      template:"cobra",
      icon:'mdi-snake',
      args: '-run',
      command:'export MONO_PATH=/opt/cobra && cobra {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\((\\d+)(?:,\\d+)?\\): error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://cobra-language.com',
      repo: 'https://github.com/gorauskas/cobra-lang',
    },
    'Coco':{
      desc: "Object-oriented, modular, statically-typed, concise, structured",
      highlighting:"coffeescript",
      ext: 'co',
      kor: '코코',
      template:"coco",
      icon:'mdi-coffee-maker',
      command:'coco {ARGS} {FILENAME}.{EXT}',
      cli: "coco {ARGS}",
      errorRegEx: ".*?:(\\d+):\\d+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://cocolang.dev',
      repo: 'https://github.com/sarvalabs',
    },
    'Coconut':{
      desc: "Functional, Python-based, expressive, concise, pattern-matching",
      highlighting:"coconut",
      ext: 'coco',
      kor: '코코넛',
      template:"coconut",
      icon:'mdi-seed',
      command:"coconut {ARGS} {FILENAME}.{EXT} && python3 {FILENAME}.py",
      cli: 'coconut {ARGS}',
      errorRegEx: ".+?: .+? \\(line (\\d+)\\)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://coconut-lang.org',
      repo: 'https://github.com/evhub/coconut',
    },
    'Cod':{
      desc: "concatenative, stack-based, written in python",
      highlighting:"cod",
      ext: 'cod',
      kor: '코드',
      template:"cod",
      icon:'mdi-fish',
      args: null,
      command:'ln -sfT /opt/cod/stdlib std && cod {ARGS} {FILENAME}.{EXT} && gcc -o {FILENAME} {FILENAME}.c 2> /dev/null && ./{FILENAME}',
      cli: null,
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://www.codlang.com',
      repo: 'https://github.com/justlucdewit/cod',
    },
    'CoffeeScript':{
      desc: "Concise, expressive, JavaScript-compiled, readable, syntactic",
      highlighting:"coffeescript",
      ext: 'coffee',
      kor: '커피스크립트',
      template:"coffee",
      icon:'mdi-coffee-outline',
      command:'coffee {ARGS} {FILENAME}.{EXT}',
      cli: "coffee {ARGS}",
      errorRegEx: ".*?:(\\d+):\\d+: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/coffeescript",
      homepage: 'https://coffeescript.org',
      repo: 'https://github.com/jashkenas/coffeescript',
    },
    'Cognate':{
      desc: "Dynamic, quasi-concatenative, functional, simple",
      highlighting:"cognate",
      ext: 'cog',
      kor: '코그네이트',
      template:"cognate",
      icon:'mdi-account-cog',
      args: null,
      command:'cognac {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://cognate-playground.hedy.dev',
      repo: 'https://github.com/cognate-lang/cognate',
    },
    'Colm':{
      desc: "Pattern-based, declarative, efficient, versatile, extensible",
      highlighting:"colm",
      ext: 'lm',
      kor: 'Colm',
      template:"colm",
      icon:'mdi-cupboard',
      command:'colm {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.lm:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/colm",
      homepage: 'https://github.com/adrian-thurston',
      repo: 'https://github.com/adrian-thurston/colm',
    },
    'Comal':{
      desc: "Educational, procedural, structured, simple, portable",
      highlighting:"comal",
      ext: 'lst',
      kor: '코멀 - opencomal',
      template:"comal",
      icon:'mdi-egg',
      command:'echo -e "save \\"{FILENAME}.cml\\"\nbye" >> {FILENAME}.{EXT} && /opt/opencomal/bin/opencomal {ARGS} < {FILENAME}.{EXT} | head -n -1 && /opt/opencomal/bin/opencomalrun {FILENAME}.cml | head -n -1',
      cli: "/opt/opencomal/bin/opencomal {ARGS}",
      errorRegEx: ".*?:(\\d+):\\d+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.josvisser.nl/opencomal',
      repo: 'https://github.com/pietsch/OpenCOMAL',
    },
    'Commodore BASIC':{
      desc: "Simple, interactive, procedural, educational, vintage",
      highlighting:"vb",
      ext: 'bas',
      kor: '코모도어베이식 - cbmbasic',
      template:"cbmbasic",
      icon:'mdi-keyboard',
      command:'/opt/cbmbasic/cbmbasic {ARGS} {FILENAME}.{EXT}',
      cli: "/opt/cbmbasic/cbmbasic",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/mist64',
      repo: 'https://github.com/mist64/cbmbasic',
    },
    'CommonLisp':{
      desc: "Powerful, dynamic, functional, extensible, multi-paradigm",
      highlighting:"lisp",
      ext: 'lisp',
      kor: '커먼리스프',
      template:"lisp",
      icon:'mdi-code-parentheses',
      command:"clisp {ARGS} {FILENAME}.{EXT}",
      cli: "clisp {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://lisp-lang.org',
      repo: 'https://gitlab.com/gnu-clisp/clisp',
    },
    'Cone':{
      desc: "Concise, functional, statically-typed, modern, expressive",
      highlighting:"cone",
      ext: 'cone',
      kor: '콘',
      template:"cone",
      icon:'mdi-traffic-cone',
      command:'conec {ARGS} {FILENAME}.{EXT} && gcc -static -o {FILENAME} {FILENAME}.o /opt/local/lib/libconestd.a && ./{FILENAME}',
      cli: null,
      errorRegEx: "Error .+\r\n.+\r\n.+?\\.cone:(\\d+):(\\d+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://cone.jondgoodwin.com',
      repo: 'https://github.com/jondgoodwin/cone',
    },
    'Conure':{
      desc: "Dynamic, object-oriented, concise, modern, expressive",
      highlighting:"conure",
      ext: 'cn',
      kor: '코뉴어',
      template:"conure",
      icon:'mdi-linux',
      command:'conure {ARGS} {FILENAME}.{EXT}',
      cli: 'conure',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/MichaelSDavid',
      repo: 'https://github.com/MichaelSDavid/conure-lang',
    },
    'Cor':{
      desc: "Concise, expressive, functional, dynamic, modern",
      highlighting:"cor",
      ext: 'cor',
      kor: '코르',
      template:"cor",
      icon:'mdi-alpha-c',
      args: 'run',
      command:'cor {ARGS} {FILENAME}.{EXT}',
      cli: 'cor',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://yosbelms.github.io/cor',
      repo: 'https://github.com/yosbelms/cor',
    },
    'Core':{
      desc: "Modern, minimal, simplicity, readability, modifiability, stability",
      highlighting:"core",
      ext: 'dora',
      kor: '코어',
      template:"core",
      icon:'mdi-set-center',
      command:'dora {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "error in .+?\\.dora\" at (\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://core-lang.dev',
      repo: 'https://github.com/core-lang/core',
    },
    'CoreScript':{
      desc: "Versatile, scripting, dynamic, extensible, high-level",
      highlighting:"javascript1",
      ext: 'cor',
      kor: '코어스크립트',
      template:"corescript",
      icon:'mdi-wall',
      command:"/opt/corescript/corescript {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/corescript/corescript {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/stephanbruny/corescript/blob/master/Docs/index.md',
      repo: 'https://github.com/stephanbruny/corescript',
    },
    'Cotowali':{
      desc: "Static, scripting, transpiled into shell script",
      highlighting:"cotowali",
      ext: 'li',
      kor: '코토왈리',
      template: "cotowali",
      icon: 'mdi-script-text-play-outline',
      args: 'run',
      command:'lic {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "error: .+?\\.li (\\d+),\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/cotowali",
      homepage: 'https://cotowali.org',
      repo: 'https://github.com/cotowali/cotowali',
    },
    'CovariantScript':{
      desc: "Bloat-free extension, scripting, interpreter",
      highlighting:"covscript",
      ext: 'csc',
      kor: '코베리언트 스크립트',
      template: "covscript",
      icon: 'mdi-water',
      command:'cs {ARGS} {FILENAME}.{EXT}',
      cli: 'cs {ARGS}',
      errorRegEx: "File .+?, line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://covscript.org.cn',
      repo: 'https://github.com/covscript/covscript',
    },
    'CppScript':{
      desc: "Embedded, C++-based, scripting, flexible, dynamic",
      highlighting:"cppscript",
      ext: 'cpp',
      kor: 'Cpp스크립트',
      template:"cppscript",
      icon:'mdi-layers-triple-outline',
      command:"cpps {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? line: ?(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://cppscript.org',
      repo: 'https://github.com/johnsonyl/cpps',
    },
    'Crafting':{
      desc: "Dynamic-typing, general-purpose, interpreter",
      highlighting:"crafting",
      ext: 'craft',
      kor: '크래프팅',
      template:"crafting",
      icon:'mdi-flag-outline',
      command:'craft {ARGS} -f {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+? at 'Line (\\d+) (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://craftinginterpreters.com',
      repo: 'https://github.com/nibblebits/craft-compiler',
    },
    'Creed':{
      desc: "Text processing script, inspired by ed and sam",
      highlighting:"creed",
      ext: 'cr',
      kor: '크리드',
      template:"creed",
      icon:'mdi-shield-cross-outline',
      command:'creed {ARGS} -s {FILENAME}.{EXT}',
      cli: 'creed {ARGS}',
      errorRegEx: ",token\\((\\d+):\\d+: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://mrms.cz/creed',
      repo: 'https://git.sr.ht/~mrms/creed',
    },
    'Cricket':{
      desc: "Functional, object-oriented",
      highlighting:"cricket",
      ext: 'ct',
      kor: '크리켓',
      template:"cricket",
      icon:'mdi-cricket',
      args: null,
      command:"ln -sf /opt/cricket/stdlib && cricket_rs {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?:(\\d+):\\d+`.",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://ryanbrewer.dev/cricket',
      repo: 'https://github.com/RyanBrewer317/cricket_rs',
    },
    'Cript':{
      desc: "simple and lightweight script language",
      highlighting:"cript",
      ext: 'cr',
      kor: '크립트',
      template:"cript",
      icon:'mdi-lock-outline',
      args: null,
      command:"cript {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "ERROR: .+?\r\n.+?\\.cr:(\\d+) \\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/i386",
      homepage: 'https://github.com/clarkok',
      repo: 'https://github.com/clarkok/cript',
    },
    'Crumb':{
      desc: "High level, functional, interpreted, dynamically typed, general-purpose",
      highlighting:"crumb",
      ext: 'crumb',
      kor: '크럼',
      template:"crumb",
      icon:'mdi-bread-slice',
      command:'crumb {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+? @ Line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/liam-ilan',
      repo: 'https://github.com/liam-ilan/crumb',
    },
    'Crystal':{
      desc: "Fast, statically-typed, compiled, expressive, modern",
      highlighting:"crystal",
      ext: 'cr',
      kor: '크리스탈',
      template:"crystal",
      icon:'mdi-crystal-ball',
      command:'crystal {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".*?:(\\d+):\\d+.*?\r\n\r\n.+\\d+ .+?\r\n.+?\r\n(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://crystal-lang.org',
      repo: 'https://github.com/crystal-lang/crystal',
    },
    'CUPL/CORC':{
      desc: "Hardware-oriented, minimalistic, assembly-like, concise, low-level",
      highlighting:"cupl",
      ext: 'cupl',
      kor: 'CUPL/CORC',
      template:"cupl",
      icon:'mdi-key-outline',
      args: "{FILENAME}.{EXT}",
      command:'/opt/cupl/cupl {ARGS}',
      errorRegEx: ".+?: line (\\d+), (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.catb.org/~esr',
      repo: 'http://www.catb.org/~esr/cupl',
    },
    'CupScript':{
      desc: "Simple scripting, for fun",
      highlighting:"cupscript",
      ext: 'cup',
      kor: '컵스크립트',
      template:"cupscript",
      icon:'mdi-cup',
      command:'python3 /opt/cupscript/cup.py {ARGS} {FILENAME}.{EXT}',
      errorRegEx: "File .*?, line (\\d+)",
      keyBindings: null,
      dockerImage: "ryusatgat/python",
      homepage: 'https://github.com/Fus3n',
      repo: 'https://github.com/Fus3n/cupscript',
    },
    'Curry(PAKCS)':{
      desc: "Functional, declarative, logic-based, higher-order, expressive",
      highlighting:"curry",
      ext: 'curry',
      kor: '커리- PACKS',
      template:"curry",
      icon:'mdi-lambda',
      command:'curry {ARGS} :compile {FILENAME} :eval {FILENAME} :quit',
      cli: 'curry {ARGS}',
      errorRegEx: ".+\\.curry:(\\d+):\\d+(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.curry-language.org',
      repo: 'https://github.com/curry-language/curry2go',
    },
    'Curry(Sloth)':{
      desc: "Functional, declarative, logic-based, higher-order, expressive",
      highlighting:"curry",
      ext: 'curry',
      kor: '커리 - 슬로스',
      template:"sloth",
      icon:'mdi-bacteria-outline',
      command:"sloth {ARGS} {FILENAME}.{EXT} && ciaoc {FILENAME} && ./{FILENAME}",
      cli: "sloth -i {ARGS}",
      defaultFilename: 'Main',
      errorRegEx: "Parser error in: line\\((\\d+)\\)(.+\r\n.+\r\n.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://babel.ls.fi.upm.es/research/Sloth',
      repo: 'https://babel.ls.fi.upm.es/software/Sloth',
    },
    'Curv':{
      desc: "3D, graphics, simple, powerful, dynamically typed, pure functional",
      highlighting:"curv",
      ext: 'curv',
      kor: '커브',
      template:"curv",
      icon:'mdi-video-3d',
      command:"xvfb-run curv {ARGS} -o {FILENAME}.png {FILENAME}.{EXT} && imshow {FILENAME}.png",
      cli: "curv {ARGS}",
      errorRegEx: ".*?(\\d+)\\|.*?(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/headless",
      homepage: 'https://curv3d.org',
      repo: 'https://codeberg.org/doug-moen/curv',
    },
    'Cyber':{
      desc: "Fast, efficient, concurrent scripting",
      highlighting:"cyber",
      ext: 'cy',
      kor: '사이버',
      template:"cyber",
      icon:'mdi-virtual-reality',
      command: 'cyber {ARGS} {FILENAME}.{EXT}',
      cli: 'cyber {ARGS}',
      errorRegEx: ".+?\\.cy:(\\d+):\\d+:\r\n(.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://cyberscript.dev',
      repo: 'https://github.com/fubark/cyber',
    },
    'D(Digital Mars)':{
      desc: "Minimalistic, expressive, dynamic, concise, modern",
      highlighting:"d",
      ext: 'd',
      kor: 'D언어 - dmd',
      template:"dmd",
      icon:'mdi-alpha-d',
      args: '-defaultlib=libphobos2.so -color=off',
      command:"/opt/dmd/linux/bin64/dmd {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.d\\((\\d+)\\): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://dlang.org',
      repo: 'https://github.com/dlang',
    },
    'D(GNU)':{
      desc: "Minimalistic, expressive, dynamic, concise, modern",
      highlighting:"d",
      ext: 'd',
      kor: 'D언어 - gdc',
      template:"d",
      icon:'mdi-alpha-d',
      args: '-fdiagnostics-color=never -Wall',
      command:"gdc {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.d:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://gdcproject.org',
      repo: 'https://github.com/D-Programming-GDC/gcc',
    },
    'D(LLVM)':{
      desc: "Minimalistic, expressive, dynamic, concise, modern",
      highlighting:"d",
      ext: 'd',
      kor: 'D언어 - ldc2',
      template:"ldc2",
      icon:'mdi-alpha-d',
      args: '--enable-color=false',
      command:"ldc2 {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.d\\((\\d+)\\): (Error: .+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://wiki.dlang.org/LDC',
      repo: 'https://github.com/ldc-developers/ldc',
    },
    'D2':{
      desc: "Diagrammatic, declarative, visual, concise, flexible",
      highlighting:"hcl",
      ext: 'd2',
      kor: 'D2',
      template:"d2",
      icon:'mdi-disqus',
      command:"d2 {FILENAME}.{EXT} && imshow {FILENAME}.svg",
      cli: null,
      errorRegEx: ".*?err.*?: .+?: (\\d+):\\d+:(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://d2lang.com',
      repo: 'https://github.com/terrastruct/d2',
    },
    'Dassie':{
      desc: "Concise, simple, object-oriented, functional, .NET CRL",
      highlighting:"dassie",
      ext: 'ds',
      kor: '다씨',
      template:"dassie",
      icon:'mdi-dot-net',
      command:"/opt/dotnet/dotnet /opt/dassie/dc.dll {ARGS} ./{FILENAME}.{EXT} && /opt/dotnet/dotnet ./build/{FILENAME}.dll",
      cli: null,
      errorRegEx: ".+?\\((\\d+),\\d+\\): error (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ms",
      homepage: 'https://github.com/loschsoftware/dassie',
      repo: 'https://github.com/loschsoftware/dc',
    },
    'Dafny':{
      desc: "Verification, functional, formal, logic-based, proof-oriented",
      highlighting:"dafny",
      ext: 'dfy',
      kor: '다프니',
      template:"dafny",
      icon:'mdi-microsoft',
      args: "/nologo",
      command:"dafny {ARGS} {FILENAME}.{EXT} && mono ./{FILENAME}.exe",
      cli: null,
      errorRegEx: ".+?\\((\\d+),\\d+\\): Error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://dafny.org',
      repo: 'https://github.com/dafny-lang/dafny',
    },
    'Dale':{
      desc: "S-expressions, no GC, local type deduction, compiler ",
      highlighting:"dale",
      ext: 'dt',
      kor: '데일',
      template:"dale",
      icon:'mdi-image-filter-hdr',
      args: '-o {FILENAME}',
      command: 'dalec {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.dt:(\\d+):\\d+: error: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ubuntu2004",
      homepage: 'https://github.com/tomhrr/dale/blob/master/doc/index.md',
      repo: 'https://github.com/tomhrr/dale',
    },
    'Dart':{
      desc: "Optimized, modern, scalable, concurrent, type-safe",
      highlighting:"dart",
      ext: 'dart',
      kor: '다트',
      template:"dart",
      icon:'mdi-arrow-top-left-thick',
      command:'dart {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?:(\\d+):\\d+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://dart.dev',
      repo: 'https://github.com/dart-lang/sdk',
    },
    'Dao':{
      desc: "Dao",
      highlighting:"dao",
      ext: 'dao',
      kor: '다오',
      template:"dao",
      icon:'mdi-knife',
      command:"/opt/dao/bin/dao {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "  At line (\\d+) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://daoscript.org',
      repo: 'https://github.com/daokoder/dao',
    },
    'daScript':{
      desc: "Dynamic, versatile, concise, scripting, high-level",
      highlighting:"dascript",
      ext: 'das',
      kor: '다스크립트',
      template:"dascript",
      icon:'mdi-view-dashboard-outline',
      command:"daScript {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\d+:(\\d+) - \\d+:\\d+\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://daslang.io',
      repo: 'https://github.com/GaijinEntertainment/daScript',
    },
    'DayBreak':{
      desc: "Compiles to C",
      highlighting:"daybreak",
      ext: 'day',
      kor: '사이버',
      template:"daybreak",
      icon:'mdi-coffee-outline',
      args: '-o {FILENAME}',
      command: 'daybreak {ARGS} {FILENAME}.{EXT} > /dev/null && ./{FILENAME}',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/ExoKomodo',
      repo: 'https://github.com/ExoKomodo/Daybreak',
    },
    'DDP':{
      desc: "Structured, German-based, procedural, educational, simple",
      highlighting:"ddp",
      ext: 'ddp',
      kor: 'Der Deutschen Programmiersprache',
      template:"ddp",
      icon:'mdi-hamburger',
      args: 'starte',
      command:"/opt/DDP/bin/kddp {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.ddp \\(Z: (\\d+), S: \\d+\\)\r\n\r\n.*?\r\n.*\r\n\r\n.*",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://ddp.le0n.dev/Spielplatz',
      repo: 'https://github.com/DDP-Projekt/Kompilierer',
    },
    'DoKev':{
      desc: "Concise, expressive, functional, modern, lightweight",
      highlighting:"dokev",
      ext: 'dkv',
      kor: '도깨비',
      template:"dokev",
      icon:'mdi-sword',
      command:"/opt/DoKev/build.sh {FILENAME}",
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/BackGwa',
      repo: 'https://github.com/BackGwa/DoKev',
    },
    'Dosato':{
      desc: "Interpreted, simple and easy to use, dynamically typed, supports static typing as well",
      highlighting:"dosato",
      ext: 'to',
      kor: '도사토',
      template:"dosato",
      icon:'mdi-bottle-wine',
      command:"dosato {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: '.+?\r\nAt line (\\d+):\\d+ in .+',
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://robotnik08.github.io/Dosato-docs',
      repo: 'https://github.com/Robotnik08/cdosato',
    },
    'Dictu':{
      desc: "Scripting, dynamic, simple, extensible, modern",
      highlighting:"dictu",
      ext: 'du',
      kor: '딕투',
      template:"dictu",
      icon:'mdi-bottle-tonic-outline',
      command:"/opt/dictu/bin/dictu {ARGS} {FILENAME}.{EXT}",
      cli: '/opt/dictu/bin/dictu {ARGS}',
      errorRegEx: ".+\\.du',.*?line (\\d+).*\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://dictu-lang.com',
      repo: 'https://github.com/dictu-lang/Dictu',
    },
    'Dino':{
      desc: "Simple, minimalistic, statically-typed, efficient, functional",
      highlighting:"dino",
      ext: 'd',
      kor: '다이노',
      template:"dino",
      icon:'mdi-google-downasaur',
      command:"/opt/dino/bin/dino {ARGS} {FILENAME}.{EXT}",
      cli: '/opt/dino/bin/dino {ARGS}',
      errorRegEx: ".+?.d:(\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/dino-lang',
      repo: 'https://github.com/dino-lang/dino',
    },
    'DogeScript':{
      desc: "Fun, minimalistic, quirky, scripting, playful",
      highlighting:"dogescript",
      ext: 'djs',
      kor: '도지스크립트',
      template:"dogescript",
      icon:'mdi-dog-side',
      command:"dogescript {ARGS} {FILENAME}.{EXT} | node",
      cli: "dogescript {ARGS}",
      errorRegEx: ".+:(\\d+)\r\n.+\r\n.+\r\n\r\n(.+)\r\n",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://dogescript.io',
      repo: 'https://github.com/dogescript/dogescript',
    },
    'Dragon (Native)':{
      desc: "Simple, trying to be natural, encourage organization and comes with transparent and visual implementation",
      highlighting:"dragonlang",
      ext: 'dgn',
      kor: '드래곤',
      template:"dragonlang",
      icon:'🐉',
      command:"dragon {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*?Line \\(?(\\d+)\\)? Error (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/dragon',
      homepage: 'https://www.dragon-lang.org',
      repo: 'https://native.dragon-lang.org/dragon-native',
    },
    'Dragon (NodeJS)':{
      desc: "Interpreted language, built ontop of NodeJS",
      highlighting:"dragon",
      ext: 'drg',
      kor: '드래곤',
      template:"dragon",
      icon:'mdi-alpha-d-circle',
      command:"dragon {ARGS} {FILENAME}.{EXT}",
      cli: "dragon {ARGS}",
      errorRegEx: "\\[.+?\\.drg\\] \\[Line: (\\d+)\\] (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://unpkg.com/browse/fca-dragon@1.0.9',
      repo: 'https://github.com/TomPrograms/dragon',
    },
    'Drift':{
      desc: "Minimalist grammar, frame and stack structure interpreter",
      highlighting:"drift",
      ext: 'ft',
      kor: '드리프트',
      template:"drift",
      icon:'mdi-weather-dust',
      command:"drift {ARGS} {FILENAME}.{EXT}",
      cli: "drift {ARGS}",
      errorRegEx: ".+?\\.ft:(\\d+)(.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://drift-lang.fun',
      repo: 'https://github.com/drift-lang/drift-cpp',
    },
    'Duck':{
      desc: "Dynamic, lightweight, flexible, scripting, easy",
      highlighting:"duck",
      ext: 'duck',
      kor: '덕',
      template:"duck",
      icon:'mdi-duck',
      command:"/opt/duck/bin/duck {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/duck/bin/duck {ARGS}",
      errorRegEx: ".+?on line (\\d+)(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.ducklang.org',
      repo: 'https://github.com/gregtour/duck-lang',
    },
    'DuckScript':{
      desc: "Scripting, dynamic, lightweight, flexible, simple",
      highlighting:"duckscript",
      ext: 'ds',
      kor: '덕스크립트',
      template:"duckscript",
      icon:'mdi-duck',
      command:"duck {ARGS} {FILENAME}.{EXT}",
      cli: "duck",
      errorRegEx: "Error: .+\\.ds Line: (\\d+)(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sagiegurari.github.io/duckscript',
      repo: 'https://github.com/sagiegurari/duckscript',
    },
    'Dylan':{
      desc: "Dynamic, multi-paradigm, expressive, object-oriented, functional",
      highlighting:"dylan",
      ext: 'dylan',
      kor: '딜런',
      template:"dylan",
      icon:'mdi-chart-tree',
      command:"([ -d {FILENAME} ] || make-dylan-app {FILENAME}) && mv -f {FILENAME}.{EXT} {FILENAME} && dylan-compiler {ARGS} -build {FILENAME}/{FILENAME}.lid && echo && _build/bin/{FILENAME}",
      cli: "dylan-compiler {ARGS}",
      defaultFilename: 'ryugod',
      errorRegEx: ".+:(\\d+)\\.\\d+-\\d+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/dylan-lang',
      repo: 'https://github.com/dylan-lang/opendylan',
    },
    'Dyon':{
      desc: "Dynamically typed, scripting",
      highlighting:"dyon",
      ext: 'dyon',
      kor: '다이온',
      template:"dyon",
      icon:'mdi-unicorn-variant',
      command:"dyonrun {ARGS} {FILENAME}.{EXT}",
      cli: "dyon",
      defaultFilename: 'ryugod',
      errorRegEx: "(\\d+),\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://www.piston.rs/dyon-tutorial',
      repo: 'https://github.com/PistonDevelopers/dyon',
    },
    'E':{
      desc: "Concise, functional, expressive, efficient, modern",
      highlighting:"e",
      ext: 'e',
      kor: 'E언어',
      template:"e",
      icon:'mdi-alpha-e-box',
      command:'rune {ARGS} {FILENAME}.{EXT}',
      cli: "rune {ARGS}",
      errorRegEx: "# +@ <.+?\\w+::(\\d+):(\\d+)::\\d+:\\d+>",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://erights.org',
      repo: 'http://www.erights.org/download/index.html',
    },
    'EasyLang':{
      desc: "Simple, readable, intuitive, beginner-friendly, high-level",
      highlighting:"easylang",
      ext: 'ea',
      kor: '이지랭',
      template:"easylang",
      icon:'mdi-emoticon-cool-outline',
      command:'EasyLang {ARGS} {FILENAME}.{EXT}',
      cli: "EasyLang {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/erhanbaris',
      repo: 'https://github.com/erhanbaris/EasyLang',
    },
    'eC':{
      desc: "C-like, embedded, object-oriented, efficient, compact",
      highlighting:"ec",
      ext: 'ec',
      kor: 'eC',
      template:"ec",
      icon:'mdi-printer-3d',
      command:'mk_epj {FILENAME}\nepj2make {FILENAME}.epj && make -f {FILENAME}-Release.Makefile > /dev/null && obj/release.linux/{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\.ec:(\\d+):\\d+: error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://ec-lang.org',
      repo: 'https://github.com/ecere/ecere-sdk',
    },
    'Ecla':{
      desc: "Simple, effortless, interpreted",
      highlighting:"ecla",
      ext: 'ecla',
      kor: '에클라',
      template:"ecla",
      icon:'mdi-timelapse',
      command:'ecla {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\.ec:(\\d+):\\d+: error: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://ecla.dev',
      repo: 'https://github.com/Eclalang/Ecla',
    },
    'EGA':{
      desc: "Declarative, logic-based, constraint-oriented, flexible, modular",
      highlighting:"ega",
      ext: 'ega',
      kor: 'EGA',
      template:"ega",
      icon:'mdi-script',
      command:'ega {ARGS} {FILENAME}.{EXT}',
      cli: "ega",
      errorRegEx: ".+? at Line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/katahiromz/EGA/blob/master/EGA-Manual.md',
      repo: 'https://github.com/katahiromz/EGA',
    },
    'Egel':{
      desc: "untyped, concurrent, functional, scripting",
      highlighting:"egel",
      ext: 'eg',
      kor: '이겔',
      template:"egel",
      icon:'mdi-razor-double-edge',
      command:'egel {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: '.+?\\.eg:(\\d+):\\d+:.*',
      keyBindings: null,
      dockerImage: "ryusatgat/egel",
      homepage: 'https://egel-lang.github.io',
      repo: 'https://github.com/egel-lang/egel',
    },
    'Egison':{
      desc: "Pattern-based, functional, extensible, expressive, unique",
      highlighting:"egison",
      ext: 'egi',
      kor: '에기손',
      template:"egison",
      icon:'mdi-gamepad-circle',
      command:'egison {ARGS} {FILENAME}.{EXT}',
      cli: "egison {ARGS}",
      errorRegEx: "./*?: egison:(\\d+):(\\d+):\r\n(.+\r\n)+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.egison.org',
      repo: 'https://github.com/egison/egison',
    },
    'Elan':{
      desc: "Functional, concise, type-safe, expressive, efficient",
      highlighting:"elan",
      ext: 'e',
      kor: '엘란',
      template:"elan",
      icon:'mdi-lead-pencil',
      args: '-c {FILENAME}.{EXT} && gcc -static {FILENAME}.o -L/opt/elan/lib -lerts -o {FILENAME} && ./{FILENAME}',
      command:'/opt/elan/bin/elancc {ARGS}',
      cli: null,
      errorRegEx: ".+? in file .+?\\.e, line (\\d+), (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/uho',
      repo: 'https://github.com/uho/Elan',
    },
    'elastiC':{
      desc: "Flexible, dynamic, extensible, modular, expressive",
      highlighting:"elastic",
      ext: 'ec',
      kor: '엘라스틱',
      template:"elastic",
      icon:'mdi-boxing-glove',
      command:'/opt/elastic/bin/ec {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "ERROR: \\(LINE: (\\d+), COLUMN: \\d+\\): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.elasticworld.org',
      repo: 'http://www.elasticworld.org/download.html',
    },
    'Electra':{
      desc: "Esolang, like an electrician, inspired by AsciiDots",
      highlighting:"electra",
      ext: 'ec',
      kor: '일렉트라',
      template:"electra",
      icon:'mdi-transmission-tower',
      command:'electra {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: "ryusatgat/esolang",
      homepage: 'https://esolangs.org/wiki/Electra',
      repo: 'https://github.com/DolphyWind/Electra-Lang',
    },
    'ELENA':{
      desc: "Functional, type-safe, immutable, declarative, reactive",
      highlighting:"elena",
      ext: 'l',
      kor: '엘레나',
      template:"elena",
      icon:'mdi-face-woman-outline',
      command:'mkelena {FILENAME} && elena-lc {ARGS} {FILENAME}.project && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?\\((\\d+):\\d+\\): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://elena-lang.github.io',
      repo: 'https://github.com/ELENA-LANG/elena-lang',
    },
    'Element':{
      desc: "Prototype-based, object-oriented, scripting, VM",
      highlighting:"element",
      ext: 'element',
      kor: '엘리먼트',
      template:"element",
      icon:'mdi-weather-windy',
      command:'element {ARGS} {FILENAME}.{EXT}',
      cli: "element",
      errorRegEx: ".+?\\((\\d+):\\d+\\): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/KaloyanKaludov',
      repo: 'https://github.com/KaloyanKaludov/Element',
    },
    'Elm':{
      desc: "Functional, Immutable, Reactive, Strongly-typed, Safe",
      highlighting:"elm",
      ext: 'elm',
      kor: '엘름',
      template:"elm",
      icon:'mdi-view-dashboard',
      args: "--optimize",
      command:'echo Y|elm init 2> /dev/null; elm make {ARGS} {FILENAME}.{EXT} && imshow index.html',
      cli: "elm repl",
      errorRegEx: "(\\d+)\\| .+?\r\n  .+?\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://elm-lang.org',
      repo: 'https://github.com/elm/compiler',
    },
    'Elixir':{
      desc: "Concurrent, functional, scalable, fault-tolerant, modern",
      highlighting:"elixir",
      ext: 'exs',
      kor: '엘릭서',
      template:"elixir",
      icon:'mdi-water-outline',
      command:'elixir {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "\\*\\* \\(\\w+\\) .+?:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://elixir-lang.org',
      repo: 'https://github.com/elixir-lang/elixir',
    },
    'EMacs Lisp':{
      desc: "Extensible, programmable, dynamic, flexible, Lisp-based",
      highlighting:"lisp",
      ext: 'exs',
      kor: '이맥스 리스프',
      template:"elisp",
      icon:'mdi-alpha-e-circle',
      args: "--no-site-file",
      command:'emacs {ARGS} --script {FILENAME}.{EXT}',
      cli: "emacs {ARGS} --execute '(ielm)'",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gnu.org/software/emacs',
      repo: 'https://www.gnu.org/software/emacs/download.html',
    },
    'Emerald':{
      desc: "Object-oriented, concurrent, modular, reflective, type-safe",
      highlighting:"emerald",
      ext: 'm',
      kor: '에메랄드',
      template:"emerald",
      icon:'mdi-hexagon-outline',
      command:'export EMERALDROOT=/opt/emerald\nec {FILENAME}.{EXT} && emx {ARGS} {FILENAME}.x',
      cli: null,
      errorRegEx: '".+?\\.m", line (\\d+): (.+)',
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.emeraldprogramminglanguage.org',
      repo: 'https://github.com/emeraldlang/emerald',
    },
    'Emo':{
      desc: "Concise, expressive, visual, dynamic, playful",
      highlighting:"emo",
      ext: 'emo',
      kor: '이모',
      template:"emo",
      icon:'mdi-emoticon-wink-outline',
      command:"emo {ARGS} {FILENAME}.{EXT}",
      cli: 'emo',
      errorRegEx: "\\[line (\\d+)\\] (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/PsiACE',
      repo: 'https://github.com/moria-world/emo',
    },
    'EmojiCode':{
      desc: "Visual, expressive, playful, emoji-based, simple",
      ext: 'emojic',
      kor: '이모지코드',
      template:"emojicode",
      icon:'mdi-emoticon',
      args: '-S /opt/emojicode/packages',
      command:"/opt/emojicode/emojicodec {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: 'emo',
      errorRegEx: ".+?:(\\d+):\\d+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.emojicode.org',
      repo: 'https://github.com/emojicode/emojicode',
    },
    'Emscripten':{
      desc: "Compiler, WebAssembly, C/C++, portable, efficient",
      highlighting:"cpp",
      ext: 'cc',
      kor: '웹어셈블리(C++)',
      template:"wasm_c",
      icon:'mdi-alpha-w-box-outline',
      command:"source /opt/emsdk/emsdk_env.sh 2> /dev/null\nemcc {ARGS} {FILENAME}.{EXT} -o {FILENAME}.html -s WASM=0 -s SINGLE_FILE=1 && imshow {FILENAME}.html",
      cli: null,
      errorRegEx: ".+?:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://emscripten.org',
      repo: 'https://github.com/emscripten-core/emscripten',
    },
    'Emu':{
      desc: "The EMbeddable Utility Language, Clean, fast, flexible",
      highlighting:"emu",
      ext: 'emu',
      kor: '에뮤',
      template:"emu",
      icon:'mdi-code-block-tags',
      command:'emu {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: null,  // not supported
      keyBindings: null,
      homepage: 'https://sourceforge.net/projects/emulang',
      repo: 'https://sourceforge.net/projects/emulang/files',
    },
    'Erlang':{
      desc: "Concurrent, fault-tolerant, functional, distributed, scalable",
      highlighting:"erlang",
      ext: 'erl',
      kor: '얼랭',
      template:"erlang",
      icon:'mdi-alpha-e-circle-outline',
      command:'escript {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?:(\\d+):\\d+: (.*)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_E),
      dockerImage: "ryusatgat/erlang",
      homepage: 'https://www.erlang.org',
      repo: 'https://github.com/erlang/otp',
    },
    'Esterel':{
      desc: "Concurrent, deterministic, real-time, reactive, formal",
      highlighting:"esterel",
      ext: 'strl',
      kor: '에스떼헬',
      template:"esterel",
      icon:'mdi-led-outline',
      args: '--verilog {FILENAME}.{EXT} && iverilog {FILENAME}.top.v {FILENAME}.v -o {FILENAME} && ./{FILENAME}',
      command:'/opt/esterel/bin/cec {ARGS}',
      cli: null,
      errorRegEx: "line (\\d+):(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www-sop.inria.fr/meije/esterel/esterel-eng.html',
      repo: 'https://www-sop.inria.fr/meije/esterel/getting-esterel.html',
    },
    'Etalk':{
      desc: "A simple object-oriented language",
      highlighting:"etalk",
      ext: 'e',
      kor: '이톡',
      template:"etalk",
      icon:'mdi-account-switch',
      args: null,
      command:'etalk {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ">>> .+? <<<\r\n>>> in line (\\d+) <<<",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/dbetz',
      repo: 'https://github.com/dbetz/etalk',
    },
    'Euphoria':{
      desc: "Simple, procedural, portable, high-level, efficient",
      highlighting:"euphoria",
      ext: 'ex',
      kor: '유포리아',
      template:"euphoria",
      icon:'mdi-account-heart-outline',
      args: "-batch",
      command:'eui {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "\\w+?\\.ex:(\\d+)\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://openeuphoria.org',
      repo: 'https://github.com/OpenEuphoria/euphoria',
    },
    'Execline':{
      desc: "scripting, shell, interpreter",
      highlighting:"execline",
      ext: 'sh',
      kor: 'Exec라인',
      template:"execline",
      icon:'mdi-script-text-play-outline',
      args: null,
      command:'execlineb {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://skarnet.org/software/execline',
      repo: 'https://github.com/skarnet/execline',
    },
    'Expect':{
      desc: "Testing, scripting, interactive, automation, flexible",
      highlighting:"expect",
      ext: 'exp',
      kor: '익스펙트',
      template:"expect",
      icon:'mdi-arrow-decision-auto',
      args: null,
      command:'expect {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: 'file ".+?\\.exp" line (\\d+)(.*)',
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sourceforge.net/projects/expect',
      repo: 'https://sourceforge.net/projects/expect/files',
    },
    'Factor':{
      desc: "Stack-based, concatenative, functional, extensible, expressive",
      highlighting:"factor",
      ext: 'factor',
      kor: '팩터',
      template:"factor",
      icon:'mdi-google-downasaur',
      command:"factor {ARGS} {FILENAME}.{EXT}",
      cli: "factor {ARGS}",
      defaultFilename: 'Main',
      errorRegEx: "(\\d+): \\w+: .+?\r\n.+?\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://factorcode.org',
      repo: 'https://github.com/factor/factor',
    },
    'Faeyne':{
      desc: "Functions are everything you need EXCEPTION",
      highlighting:"faeyne",
      ext: 'fay',
      kor: '페인',
      template:"faeyne",
      icon:'mdi-function',
      command:"faeyne {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\r\n.+?:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://github.com/nevakrien',
      repo: 'https://github.com/nevakrien/Faeyne_lang',
    },
    'Fake':{
      desc: "Lightweight embedded scripting language",
      highlighting:"fake",
      ext: 'fk',
      kor: '페이크',
      template:"fake",
      icon:'mdi-auto-fix',
      command:"fake {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.fk:(\\d+)\\) (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/fake',
      homepage: 'https://github.com/esrrhs',
      repo: 'https://github.com/esrrhs/fake',
    },
    'Falcon':{
      desc: "Dynamic, extensible, object-oriented, lightweight, expressive",
      highlighting:"falcon",
      ext: 'fal',
      kor: '팔콘',
      template:"falcon",
      icon:'mdi-alpha-f-circle',
      command:"falcon {ARGS} {FILENAME}.{EXT}",
      cli: "falcon -i {ARGS}",
      defaultFilename: 'Main',
      errorRegEx: ".+?:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.falconpl.org',
      repo: 'https://github.com/EricLBuehler/Falcon-Programming-Language',
    },
    'False':{
      desc: "Esoteric, obfuscated, tiny implementation",
      highlighting: 'false',
      ext: 'f',
      kor: '폴스',
      template:"false",
      icon:'mdi-alpha-f',
      command: "dfalse {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*?(\\d+):\\d+: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/esolang",
      homepage: 'https://esolangs.org/wiki/FALSE',
      repo: 'https://github.com/udonyang/dfalse',
    },
    'Fantom':{
      desc: "Cross-platform, object-oriented, modular, flexible, statically-typed",
      highlighting:"fantom",
      ext: 'fan',
      kor: '팬텀',
      template:"fantom",
      icon:'mdi-drupal',
      command:"fan {ARGS} {FILENAME}.{EXT}",
      cli: "fansh {ARGS}",
      defaultFilename: 'Main',
      errorRegEx: ".+?\\((\\d+),\\d+\\): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://fantom-lang.org',
      repo: 'https://github.com/fantom-lang/fantom',
    },
    'Fanx':{
      desc: "Full-stack, object oriented, static typed, JVM",
      highlighting: 'fanx',
      ext: 'fanx',
      kor: '팽스',
      template:"fanx",
      icon:'mdi-ghost-outline',
      command: "/opt/fanx/bin/fan {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "",
      keyBindings: null,
      dockerImage: "ryusatgat/jvm",
      homepage: 'http://fanx.dev',
      repo: 'https://github.com/fanx-dev/fanx',
    },
    'FatScript':{
      desc: "Lightweight, interpreted, minimalist Syntax, robust type",
      highlighting:"fatscript",
      ext: 'fat',
      kor: '팻스크립트',
      template:"fatscript",
      icon:'mdi-pig-variant-outline',
      command:"fry {ARGS} {FILENAME}.{EXT}",
      cli: "fry {ARGS}",
      errorRegEx: ".+?\\.fat:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://fatscript.org',
      repo: 'https://gitlab.com/fatscript/fry',
    },
    'Fe':{
      desc: "Concise, functional, type-safe, expressive, efficient",
      highlighting:"fe",
      ext: 'fe',
      kor: 'Fe',
      template:"fe",
      icon:'mdi-code-parentheses-box',
      command:"fe {ARGS} {FILENAME}.{EXT}",
      cli: 'fe',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/rxi',
      repo: 'https://github.com/rxi/fe',
    },
    'Felix':{
      desc: "Concurrent, modular, type-safe, efficient, flexible",
      highlighting:"felix",
      ext: 'flx',
      kor: '펠릭스',
      template:"felix",
      icon:'mdi-developer-board',
      command:"/opt/felix/bin/flx {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.flx: line (\\d+), (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://felix-lang.github.io/felix',
      repo: 'https://github.com/felix-lang/felix',
    },
    'Fennel':{
      desc: "Lisp-like, functional, macro-based, lightweight, embedded",
      highlighting:"lisp",
      ext: 'fnl',
      kor: '페널',
      template:"fennel",
      icon:'mdi-chart-donut',
      command:"fennel {ARGS} {FILENAME}.{EXT}",
      cli: "fennel {ARGS}",
      errorRegEx: ".+?\\.fnl:(\\d+)\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://fennel-lang.org',
      repo: 'https://github.com/bakpakin/Fennel',
    },
    'Feral':{
      desc: "Lightweight, dynamic, flexible, minimalistic, scripting",
      highlighting:"feral",
      ext: 'fer',
      kor: '페럴',
      template:"feral",
      icon:'mdi-drama-masks',
      command:"/opt/feral/bin/feral {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+\\.fer (\\d+)\\[\\d+\\]: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://feral-lang.github.io/Book',
      repo: 'https://github.com/Feral-Lang/Feral',
    },
    'Ferite':{
      desc: "Dynamic, flexible, reflective, object-oriented, extensible",
      highlighting:"ferite",
      ext: 'fe',
      kor: '페라이트',
      template:"ferite",
      icon:'mdi-set-none',
      command:"ferite {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Error: .+?:(\\d+) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/darkrock/ferite',
      repo: 'https://github.com/darkrock/ferite',
    },
    'Fexl':{
      desc: "Functional, expressive, type-safe, concise, modular",
      highlighting:"fexl",
      ext: 'fxl',
      kor: '펙슬',
      template:"fexl",
      icon:'mdi-alpha-f-box-outline',
      command:"fexl {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+ on line (\\d+) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://loom.cc',
      repo: 'https://github.com/chkoreff/Fexl',
    },
    'Ficus':{
      desc: "Functional, extensible, type-safe, expressive, concurrent",
      highlighting:"ficus",
      ext: 'fx',
      kor: '파이쿠스',
      template:"ficus",
      icon:'mdi-tree-outline',
      args:'-run',
      command:"FICUS_PATH=/opt/ficus /opt/ficus/bin/ficus {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.fx:(\\d+):\\d+: error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/vpisarev',
      repo: 'https://github.com/vpisarev/ficus',
    },
    'Filagree':{
      desc: "Declarative, concise, expressive, typed, modular",
      highlighting:"filagree",
      ext: 'fg',
      kor: '필러그리',
      template:"filagree",
      icon:'mdi-focus-field',
      command:"filagree {ARGS} {FILENAME}.{EXT}",
      cli: "filagree",
      errorRegEx: "\\d+ - (?:.+\r\n)?.+?\\.fg,? line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/ys1382',
      repo: 'https://github.com/ys1382/filagree',
    },
/*
    'Filament':{
      desc: "Hardware description language (HDL) that uses a type system to specify",
      highlighting:"filament",
      ext: 'fil',
      kor: '필라멘트',
      template:"filament",
      icon:'mdi-lightbulb-variant-outline',
      command:"filament {ARGS} {FILENAME}.{EXT}",
      cli: "filament",
      errorRegEx: "",
      keyBindings: null,
      dockerImage: '',
      homepage: '',
      repo: 'https://github.com/filamentphp/filament',
    },
*/
    'Finch':{
      desc: "Simple bytecode interpreted, purely object-oriented, prototype-based, dynamically-typed",
      highlighting:"finch",
      ext: 'fin',
      kor: '핀치',
      template:"finch",
      icon:'mdi-bird',
      command:"finch {ARGS} {FILENAME}.{EXT}",
      cli: 'finch {ARGS}',
      errorRegEx: "",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://finch.stuffwithstuff.com',
      repo: 'https://github.com/munificent/finch',
    },
    'Flax':{
      desc: "Functional, type-safe, concise, modular, efficient",
      highlighting:"flax",
      ext: 'flx',
      kor: '플랙스',
      template:"flax",
      icon:'mdi-cosine-wave',
      command:"/opt/flax/bin/flaxc {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: "/opt/flax/bin/flaxc -repl {ARGS}",
      errorRegEx: ".+?: .+?\r\nat: .+?\\.flx:(\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/flax-lang',
      repo: 'https://github.com/flax-lang/flax',
    },
    'Fleng':{
      desc: "descended from Prolog, minimal, low-level",
      highlighting:"fleng",
      ext: 'ghc',
      kor: '플렝',
      template:"fleng",
      icon:'mdi-circle-double',
      command:"fleng -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      errorRegEx: ".+?\\.ghc:(\\d+)\\) (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://www.call-with-current-continuation.org/fleng/fleng.html',
      repo: 'https://gitlab.com/b2495/fleng',
    },
    'Flix':{
      desc: "Functional, logical, constraint-based, declarative, type-safe",
      highlighting:"flix",
      ext: 'flix',
      kor: '플릭스',
      template:"flix",
      icon:'mdi-cosine-wave',
      command:"java -jar /opt/flix/flix.jar {ARGS} {FILENAME}.{EXT}",
      cli: "java -jar /opt/flix/flix.jar",
      errorRegEx: ".+\\(line (\\d+), column \\d+\\):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://flix.dev',
      repo: 'https://github.com/flix/flix',
    },
    'Focal':{
      desc: "Educational, interactive, simple, procedural, teaching",
      highlighting:"focal",
      ext: 'foc',
      kor: '포컬',
      template:"focal",
      icon:'mdi-focus-field-horizontal',
      command:"focal {ARGS} {FILENAME}.{EXT}",
      cli: "focal {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/FOCAL_(programming_language)',
      repo: 'https://github.com/AndrewSav/focal-69',
    },
    'Foma':{
      desc: "Compiler, similar to the Xerox xfst interface",
      highlighting: 'foma',
      ext: 'foma',
      kor: '포마',
      template:"foma",
      icon:'mdi-car-back',
      args: '-f {FILENAME}.{EXT}',
      command: 'foma {ARGS}',
      cli: 'foma',
      errorRegEx: '.+? on line (\\d+). (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/ubuntu1404",
      homepage: 'https://code.google.com/archive/p/foma',
      repo: 'https://code.google.com/archive/p/foma/source/default/source',
    },
    'Forte':{
      desc: "Esoteric, similar to BASIC",
      highlighting:"vb",
      ext: 'fo',
      kor: '포터',
      template:"forter",
      icon:'mdi-fingerprint',
      command:"forter {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Line (\\d+), column \\d+:\r\n(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ruby",
      homepage: 'https://esolangs.org/wiki/Forte',
      repo: 'https://github.com/judofyr/forter',
    },
    'Forth':{
      desc: "Stack-based, concise, extensible, low-level, postfix",
      highlighting:"forth",
      ext: 'fth',
      kor: '포스',
      template:"forth",
      icon:'mdi-dice-4-outline',
      command:"gforth {ARGS} {FILENAME}.{EXT} -e bye",
      cli: "gforth {ARGS}",
      errorRegEx: ".+?:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://gforth.org/',
      repo: 'https://www.complang.tuwien.ac.at/forth/gforth/Snapshots/current',
    },
    'Fortran':{
      desc: "Numerical, efficient, legacy, array-based, procedural",
      highlighting:"fortran",
      ext: 'f90',
      kor: '포트란',
      template:"fortran",
      icon:'mdi-language-fortran',
      command:"gfortran {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?:(\\d+):\\d+:.+?\r\n\r\n +\\d+ .+?\r\n.+?\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://fortran-lang.org/',
      repo: 'https://gcc.gnu.org/wiki/GitMirror',
    },
    'fox-lang':{
      desc: "Functional, Concise, Multiparadigm, Type-safe, Concurrent",
      highlighting:"fox",
      ext: 'fox',
      kor: '폭스랭',
      template:"fox",
      icon:'mdi-firefox',
      command:"fox {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+\r\n.+?\\.fox\\((\\d+)\\)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/x768',
      repo: 'https://github.com/x768/fox-lang',
    },
    'Foxely':{
      desc: "Syntax, paradigm, efficiency, flexibility, use-case",
      highlighting:"foxely",
      ext: 'fox',
      kor: '폭슬리',
      template:"foxely",
      icon:'mdi-tailwind',
      command:"foxely {ARGS} {FILENAME}.{EXT}",
      cli: 'foxely',
      errorRegEx: "\\[line (\\d+)\\] (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/Foxely',
      repo: 'https://github.com/Foxely/Foxely',
    },
    'Free':{
      desc: "No memory constraints, SMPL",
      highlighting:"free",
      ext: 'fr',
      kor: '프리',
      template:"free",
      icon:'mdi-crop-free',
      command:"fr {ARGS} {FILENAME}.{EXT} {FILENAME}.c && gcc -o {FILENAME} {FILENAME}.c && ./{FILENAME}",
      cli: "frege {ARGS}",
      defaultFilename: 'Main',
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/adam-mcdaniel',
      repo: 'https://github.com/adam-mcdaniel/free',
    },
    'Frege':{
      desc: "Haskell-inspired, statically-typed, functional language",
      highlighting:"frege",
      ext: 'fr',
      kor: '프레게',
      template:"frege",
      icon:'mdi-coffee',
      command:"frege {ARGS} {FILENAME}.{EXT} && run_frege {FILENAME}",
      cli: "frege {ARGS}",
      defaultFilename: 'Main',
      errorRegEx: "E .+?\\.fr:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/Frege/frege/wiki/_pages',
      repo: 'https://github.com/Frege/frege',
    },
    'Frink':{
      desc: "Mathematical, Unit-aware, Scripting, Precise, Conversion",
      highlighting:"frink",
      ext: 'frink',
      kor: '프링크',
      template:"frink",
      icon:'mdi-emoticon-neutral-outline',
      command:"frink {ARGS} {FILENAME}.{EXT}",
      cli: "frink {ARGS}",
      errorRegEx: ".+?: file:.+?, line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://frinklang.org',
      repo: 'https://frinklang.org/#DownloadingFrink',
    },
    'F# - mono':{
      desc: "Functional, statically-typed, .NET language",
      highlighting:"fsharp",
      ext: 'fsx',
      kor: 'F Sharp - fsharpi',
      template:"fsmono",
      icon:'mdi-alpha-f',
      args: '--nologo',
      command:"fsharpc {ARGS} {FILENAME}.{EXT} && mono ./{FILENAME}.exe",
      cli: 'fsharpi',
      errorRegEx: ".*?\\((\\d+),\\d+\\): error (.*)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_F),
      dockerImage: '',
      homepage: 'https://www.mono-project.com',
      repo: 'https://github.com/mono/mono',
    },
    'F# - .NET Core':{
      desc: "Functional, statically-typed, .NET language",
      highlighting:"fsharp",
      ext: 'fs',
      kor: 'F Sharp - dotnet',
      template:"fsharp",
      icon:'mdi-alpha-f',
      command:'([ -d {FILENAME}_F ] || dotnet new console -lang "F#" -o {FILENAME}_F) && mv -f {FILENAME}.{EXT} {FILENAME}_F/Program.{EXT} && dotnet run {ARGS} --project {FILENAME}_F',
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+?\\((\\d+),\\d+\\): error .+?: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ms",
      homepage: 'https://dotnet.microsoft.com/en-us/languages/fsharp',
      repo: 'https://github.com/dotnet/fsharp',
    },
/*
    'F*':{
      desc: "Functional, statically-typed, .NET language",
      highlighting:"fstar",
      ext: 'fst',
      kor: 'F 스타 - F Star',
      template:"fstar",
      icon:'mdi-flare',
      args: '--odir . --codegen OCaml --include /opt/fstar/lib/fstar --extract {FILENAME} --silent',
      command:'fstar {ARGS} {FILENAME}.{EXT}',
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+?\\((\\d+),\\d+\\): error .+?: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: '',
      repo: 'https://github.com/FStarLang/FStar',
    },
*/
    'FunL':{
      desc: "Functional, Lazy, Strongly-typed, Educational, Type-inference",
      highlighting:"funl",
      ext: 'fnl',
      kor: '펀엘',
      template:"funl",
      icon:'mdi-emoticon-lol-outline',
      command:"funla {ARGS} {FILENAME}.{EXT}",
      cli: "funla -repl {ARGS}",
      errorRegEx: ".*?rror: .+?ine[: ](\\d+)[: ](.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://programmingfunl.wordpress.com',
      repo: 'https://github.com/anssihalmeaho/funl',
    },
    'Futhark':{
      desc: "Functional, Array-based, High-performance, Parallel, Data-centric",
      highlighting:"futhark",
      ext: 'fut',
      kor: '푸타르크',
      template:"futhark",
      icon:'mdi-zodiac-libra',
      args:"c",
      command:"futhark {ARGS} {FILENAME}.{EXT} && read -p '입력값: ' i && (echo $i | ./{FILENAME})",
      cli: "futhark repl",
      errorRegEx: "Error at .+?\\.fut:(\\d+):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://futhark-lang.org',
      repo: 'https://github.com/diku-dk/futhark',
    },
    'Fuzuli':{
      desc: "JVM implementation, based on LISP, Algol family, ",
      highlighting:"fuzuli",
      ext: 'fzl',
      kor: '퓌줄리',
      template:"fuzuli",
      icon:'mdi-abjad-arabic',
      args: null,
      command:"fuzuli {ARGS} {FILENAME}.{EXT}",
      cli: "fuzuli --repl",
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/jvm",
      homepage: 'http://www.fuzuliproject.org',
      repo: 'https://github.com/jbytecode/fuzuli',
    },
    'Gambas':{
      desc: "Visual, object-oriented, BASIC-like language",
      highlighting:"vb",
      ext: 'bas',
      kor: '감바스',
      template:'gambas',
      icon:'mdi-arm-flex-outline',
      command:'gbs3 {ARGS} {FILENAME}.{EXT}',
      errorRegEx: ".+?:(\\d+):\\d+: \\w+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://gambas.sourceforge.net',
      repo: 'https://gitlab.com/gambas/gambas',
    },
    'GAP':{
      desc: "Algebraic, Symbolic, Mathematical, Computational, Group-theory",
      highlighting:"gap",
      ext: 'g',
      kor: '갭',
      template:"gap",
      icon:'mdi-cards-diamond-outline',
      args: '-q -b --nointeract',
      command:"gap {ARGS} {FILENAME}.{EXT}",
      cli: "gap",
      errorRegEx: ".+? error: .+?\\.g:(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gap-system.org',
      repo: 'https://github.com/gap-system/gap',
    },
    'Gecho':{
      desc: "Stack-based, simple",
      highlighting:"gecho",
      ext: 'gecho',
      kor: '게코',
      template:"gecho",
      icon:'mdi-shark',
      args: 'run',
      command:"gecho -f {FILENAME}.{EXT}",
      cli: "gecho",
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://tekknolagi.lighthouseapp.com/projects/81045-gecho/tickets',
      repo: 'https://github.com/tekknolagi/gecho',
    },
    'GEL':{
      desc: "Scripting, Simple, Educational, Lightweight, Versatile",
      highlighting:"gel",
      ext: 'gel',
      kor: 'GEL - Genius Mathematics',
      template:"gel",
      icon:'mdi-matrix',
      command:"genius {ARGS} {FILENAME}.{EXT}",
      cli: "genius",
      errorRegEx: ".+?\\.gel:(\\d+): (ERROR:.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://gitlab.gnome.org/GNOME/genius',
      repo: 'https://github.com/GNOME/genius',
    },
    'GeneralScript':{
      desc: "Lightweight general purpose scripting, scheme like syntax",
      highlighting:"generalscript",
      ext: 'gscript',
      kor: '제너럴스크립트',
      template:"generalscript",
      icon:'mdi-script',
      command:"generalscript {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Compile error at line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://sourceforge.net/projects/gscript',
      repo: 'https://sourceforge.net/projects/gscript/files',
    },
    'Genie':{
      desc: "Object-oriented, Python-like, High-level, GNOME, Dynamic",
      highlighting:"genie",
      ext: 'gs',
      kor: '지니',
      template:"genie",
      icon:'mdi-oil-lamp',
      command:"valac {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?:(\\d+).\\d+-\\d+\\.\\d+:(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://live.gnome.org/Vala',
      repo: 'https://github.com/vlad0337187/Genie',
    },
    'Gentee':{
      desc: "Scripting, object-oriented, data processing language",
      highlighting:"gentee",
      ext: 'g',
      kor: '젠티',
      template:"gentee",
      icon:'mdi-contain',
      command:"gentee {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "ERROR: .+? \\[(\\d+):\\d+\\] (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://docs.gentee.org',
      repo: 'https://github.com/gentee/gentee',
    },
    'Genyris':{
      desc: "Declarative, Database-focused, Data-centric, Query-based, High-level",
      highlighting:"genyris",
      ext: 'g',
      kor: '제니리스',
      template:"genyris",
      icon:'mdi-creation',
      command:"genyris {ARGS} {FILENAME}.{EXT}",
      cli: "genyris {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.genyris.org',
      repo: 'https://github.com/birchb1024/genyris',
    },
    'Gwion':{
      desc: "Declarative, Data-centric, Rule-based, Pattern-matching, Expressive",
      highlighting:"gwion",
      ext: 'gw',
      kor: '귀온',
      template:"gwion",
      icon:'mdi-music',
      args: '-p /opt/gwion/lib',
      command:"/opt/gwion/bin/gwion {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.gw.*?:(\\d+):\\d+:(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://gwion.github.io/Gwion',
      repo: 'https://github.com/Gwion/Gwion',
    },
    'Glance':{
      desc: "Visual syntax for the programming language Haskell",
      highlighting:"haskell",
      ext: 'hs',
      kor: '글랜스',
      template:"haskell",
      icon:'mdi-language-haskell',
      args: '640',
      command:"glance-exe {FILENAME}.{EXT} {FILENAME}.svg {ARGS} && imshow {FILENAME}.svg",
      cli: null,
      errorRegEx: 'glance-exe: .+?\\.hs\\] \\((\\d+):\\d+\\): (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/glance",
      homepage: 'https://www.youtube.com/channel/UCs2gsWfcy83Yqk873WkPfeg',
      repo: 'https://github.com/rgleichman/glance',
    },
    'Gleam':{
      desc: "Type-safe, highly concurrent, fault tolerant Erlang runtime, modern",
      highlighting:"gleam",
      ext: 'gleam',
      kor: '글림',
      template:"gleam",
      icon:'mdi-lightbulb-on-10',
      args: 'run',
      command:"gleam new {FILENAME} 2>/dev/null; mv {FILENAME}.{EXT} {FILENAME}/src && cd {FILENAME} && gleam {ARGS}; cd ..",
      cli: "gleam new repl_gleam 2>/dev/null; cd repl_gleam && gleam shell; cd ..",
      errorRegEx: ".+?error.+?\r\n.+?\\.gleam:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/erlang",
      homepage: 'https://gleam.run',
      repo: 'https://github.com/gleam-lang/gleam',
    },
    'Gluon':{
      desc: "Machine-learning, High-level, Neural networks, Tensor-based, Flexible",
      highlighting:"gluon",
      ext: 'glu',
      kor: '글루온',
      template:"gluon",
      icon:'mdi-eyedropper-variant',
      args: '--color never',
      command:"gluon {ARGS} {FILENAME}.{EXT}",
      cli: "gluon -i {ARGS}",
      errorRegEx: "error: .+\r\n(?:.+\r\n)+?  ┌─ .+?:(\\d+):(\\d)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://gluon-lang.org',
      repo: 'https://github.com/gluon-lang/gluon',
    },
    'Gnuplot':{
      desc: "Graphing, plotting, data visualization tool",
      highlighting:"gnuplot",
      ext: 'plt',
      kor: '그누플롯',
      template:"gnuplot",
      icon:'mdi-chart-box-outline',
      args: '-e "set terminal svg enhanced background rgb \'white\' size 640,480; set lmargin 0;set rmargin 0;set tmargin 0;set bmargin 0;set output \'{FILENAME}.svg\'"',
      command:"gnuplot {ARGS} {FILENAME}.{EXT} && ([[ ! -s {FILENAME}.svg ]] || imshow {FILENAME}.svg)",
      cli: "gnuplot {ARGS}",
      errorRegEx: ".+? line (\\d+): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.gnuplot.info',
      repo: 'https://sourceforge.net/projects/gnuplot/files',
    },
    'Go':{
      desc: "Concurrent, statically-typed, systems language",
      highlighting:"go",
      ext: 'go',
      kor: '고',
      template:"go",
      icon:'mdi-language-go',
      command:"go build {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+:(\\d+):\\d+: (.*)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_G),
      dockerImage: "ryusatgat/go",
      homepage: 'https://go.dev',
      repo: 'https://github.com/golang/go',
    },
    'Goal':{
      desc: "Embeddable array programming language with a bytecode interpreter, written in Go",
      highlighting:"goal",
      ext: 'goal',
      kor: '골',
      template:"goal",
      icon:'mdi-soccer',
      command:"goal {FILENAME}.{EXT}",
      cli: 'goal',
      errorRegEx: ".+?\\.goal:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/goal",
      homepage: 'https://anaseto.codeberg.page/goal-docs',
      repo: 'https://codeberg.org/anaseto/goal',
    },
    'Goaldi':{
      desc: "General-purpose, modern, familiar to Icon",
      highlighting:"goaldi",
      ext: 'gd',
      kor: '골디',
      template:"goaldi",
      icon:'mdi-soccer',
      command:"goaldi {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "At .+?\\.gd:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/proebsting/goaldi/blob/master/doc/intro.adoc',
      repo: 'https://github.com/proebsting/goaldi',
    },
    'Goat':{
      desc: "Esoteric, Minimalistic, Turing-complete, Obfuscated, Creative",
      highlighting:"goat",
      ext: 'goat',
      kor: '고트',
      template:"goat",
      icon:'mdi-hexagon-multiple-outline',
      args: '--lib=/opt/goat/lib',
      command:"/opt/goat/goat {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/goat/goat {ARGS}",
      errorRegEx: null,
      dockerImage: '',
      homepage: 'https://github.com/kniazkov',
      repo: 'https://github.com/kniazkov/goat',
    },
    'Goby':{
      desc: "Concurrent, Lightweight, Functional, High-performance, Minimal",
      highlighting:"goby",
      ext: 'gb',
      kor: '고비',
      template:"goby",
      icon:'mdi-go-kart',
      command:"export GOBY_ROOT=/opt/goby\n/opt/goby/goby {ARGS} {FILENAME}.{EXT}",
      cli: "GOBY_ROOT=/opt/goby /opt/goby/goby -i",
      errorRegEx: "(?:.+\r\nfrom .+?\\.gb:|.+? Line: )(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/goby-lang',
      repo: 'https://github.com/goby-lang/goby',
    },
    'GolfScript':{
      desc: "Concise, stack-based, scripting language",
      highlighting:"golfscript",
      ext: 'gs',
      kor: '골프스크립트',
      template:"golfscript",
      icon:'mdi-golf-tee',
      command: 'golfscript {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.golfscript.com',
      repo: 'https://github.com/darrenks/golfscript',
    },
    'Golo':{
      desc: "Dynamic, modular, JVM-based language",
      highlighting:"golo",
      ext: 'golo',
      kor: '골로',
      template:"golo",
      icon:'mdi-alpha-g-circle-outline',
      args: 'golo --files {FILENAME}.{EXT}',
      command:"golo {ARGS}",
      cli: null,
      errorRegEx: "\\[.*?error.*?\\] .+? at {line=(\\d+), column=\\d+}(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://golo-lang.org',
      repo: 'https://github.com/eclipse-archived/golo-lang',
    },
    'Gosu':{
      desc: "Object-oriented, Java-compatible, Static-typed, JVM-based, Flexible",
      highlighting:"gosu",
      ext: 'gsp',
      kor: '고수',
      template:"gosu",
      icon:'mdi-alpha-g-circle',
      command: 'gosu {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+? \\[line:(\\d+) col:(\\d+)\\] in",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://gosu-lang.github.io',
      repo: 'https://github.com/gosu-lang/gosu-lang',
    },
    'GPP':{
      desc: "General-purpose preprocessor, customizable, suitable, lighter, flexible",
      highlighting:"gpp",
      ext: 'pp',
      kor: 'General Purpose Preprocessor',
      template:"gpp",
      icon:'mdi-transfer-right',
      args: '+c // "\\n"',
      command:"gpp {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://logological.org/gpp',
      repo: 'https://github.com/logological/gpp',
    },
    'GPython':{
      desc: "Re-implementation, part port of the Python 3.4 interpreter in Go",
      highlighting:"python",
      ext: 'py',
      kor: 'G파이썬',
      template:"gpython",
      icon:'mdi-language-python',
      command:"gpython {ARGS} {FILENAME}.{EXT}",
      cli: 'gpython {ARGS}',
      errorRegEx: ".+?\\.py\", line (\\d+)(?:.*?\r\n)+?(.*?Error: .*)",
      keyBindings: null,
      dockerImage: "ryusatgat/python",
      homepage: 'https://github.com/go-python',
      repo: 'https://github.com/go-python/gpython',
    },
    'Grace':{
      desc: "Educational, Object-oriented, Simple, High-level, Human-friendly",
      highlighting:"grace",
      ext: 'grace',
      kor: '그레이스',
      template:"grace",
      icon:'mdi-weather-sunset',
      command:"GRACE_MODULE_PATH=/opt/grace/modules /opt/grace/mgc {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.grace\\[(\\d+):\\d+\\]: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/gracelang',
      repo: 'https://github.com/gracelang/minigrace',
    },
    'Graphviz':{
      desc: "Graph visualization, diagram generation tool",
      highlighting:"graphviz",
      ext: 'dot',
      kor: '그래프비즈',
      template:"graphviz",
      icon:'mdi-format-vertical-align-bottom',
      args: "-Tsvg",
      command:"dot {ARGS} -o {FILENAME}.svg {FILENAME}.{EXT} && imshow {FILENAME}.svg",
      cli: null,
      errorRegEx: "Error: .+?: .+ in line (\\d+) near .*",
      keyBindings: null,
      dockerImage: 'ryusatgat/glance',
      homepage: 'https://graphviz.org',
      repo: 'https://gitlab.com/graphviz/graphviz',
    },
    'Gravity':{
      desc: "Scripting, Dynamic, User-friendly, Game-oriented, Lightweight",
      highlighting:"gravity",
      ext: 'gravity',
      kor: '그래비티',
      template:"gravity",
      icon:'mdi-checkbox-blank-circle',
      args: "-q",
      command:"gravity {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? ERROR .+? \\((\\d+),\\d+\\): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gravity-lang.org',
      repo: 'https://github.com/marcobambini/gravity',
    },
    'Gren':{
      desc: "Functional, managed side-effects, strong static typed, simple",
      highlighting:"gren",
      ext: 'gren',
      kor: '그렌',
      template:"gren",
      icon:'mdi-duck',
      defaultFilename: "Main",
      args: "",
      command:"gren init --yes 2> /dev/null; gren make --output={FILENAME}.html ./{FILENAME}.{EXT} && imshow {FILENAME}.html",
      cli: "gren repl",
      errorRegEx: "(\\d+)\\| (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://gren-lang.org',
      repo: 'https://github.com/gren-lang/compiler',
    },
    'Gri':{
      desc: "Minimalistic, Scripting, Lightweight, Educational, Data-focused",
      highlighting:"gri",
      ext: 'gri',
      kor: '그리',
      template:"gri",
      icon:'mdi-chart-timeline',
      args: "{FILENAME}.{EXT} && [ -f '{FILENAME}.ps' ] && gs -dBATCH -dNOPAUSE -sDEVICE=png16m -sOutputFile={FILENAME}.png {FILENAME}.ps && imshow {FILENAME}.png",
      command:"/opt/gri/bin/gri {ARGS}",
      cli: "/opt/gri/bin/gri",
      errorRegEx: ".+\r\n.+\\.gri:(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sourceforge.net/projects/gri',
      repo: 'https://sourceforge.net/projects/gri/files',
    },
    'Groovy':{
      desc: "Dynamic, JVM-based, Scripting, Concise, Agile",
      highlighting:"groovy",
      ext: 'groovy',
      kor: '그루비',
      template:"groovy",
      icon:'mdi-star-outline',
      command:"groovy {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?: (\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/jvm",
      homepage: 'https://groovy-lang.org',
      repo: 'https://github.com/apache/groovy',
    },
    'GSC':{
      desc: "Embeddable scripting language in C",
      highlighting:"gsc",
      ext: 'gsc',
      kor: 'generator-scripting-language',
      template:"gsc",
      icon:'mdi-script',
      args: null,
      command:"gsc {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://r1chard.nl/gsc',
      repo: 'https://github.com/riicchhaarrd/cgsc',
    },
    'GSL':{
      desc: "Mathematical, C-based, Numerical, High-performance, Library",
      highlighting:"gsl",
      ext: 'gsl',
      kor: 'generator-scripting-language',
      template:"gsl",
      icon:'mdi-alpha-g-box',
      args: '-q',
      command:"gsl -q {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\(.+?\\.gsl (\\d+)\\)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/fjardon',
      repo: 'https://github.com/fjardon/gsl',
    },
    'Guile':{
      desc: "Extensible, Scheme-based, Embeddable, Scripting, Flexible",
      highlighting:"lisp",
      ext: 'scm',
      kor: '가일 (3.0)',
      template:"guile",
      icon:'mdi-alpha-g',
      args: '--no-auto-compile',
      command:"guile {ARGS} {FILENAME}.{EXT}",
      cli: "guile {ARGS}",
      errorRegEx: "(?:.+?: )?.+?:(\\d+):\\d: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gnu.org/s/guile',
      repo: 'https://savannah.gnu.org/git/?group=guile',
    },
    'Gura':{
      desc: "Iterator-oriented, implicit mapping, object oriented",
      highlighting:"gura",
      ext: 'gura',
      kor: '구라',
      template:"gura",
      icon:'mdi-reiterate',
      args: '-I /opt/gura/module',
      command:"gura {ARGS} {FILENAME}.{EXT}",
      cli: 'gura {ARGS}',
      errorRegEx: ".+?\\.gura:(\\d+): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://www.gura-lang.org',
      repo: 'https://github.com/gura-lang/gura',
    },
    'GW-BASIC':{
      desc: "Legacy, BASIC-like, Simple, Interactive, DOS-based",
      highlighting:"vb",
      ext: 'bas',
      kor: 'GW-베이식 - dos 16bit',
      template:"gwbasic",
      icon:'mdi-console-line',
      args: null,
      command:"unix2dos -q {FILENAME}.{EXT} && emu2 /opt/dos/gwbasic.exe < {FILENAME}.{EXT}",
      cli: "emu2 /opt/dos/gwbasic.exe",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/GW-BASIC',
      repo: 'https://github.com/microsoft/GW-BASIC',
    },
    'H2':{
      desc: "Java-based, Lightweight, Embedded, SQL-compatible, Fast",
      highlighting:"mysql",
      ext: 'sql',
      kor: 'H2',
      template:"h2",
      icon:'mdi-alpha-h-circle',
      command:"/opt/h2/bin/h2exec.sh {FILENAME}.{EXT} {ARGS}",
      cli: "/opt/h2/bin/h2exec.sh",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.h2database.com',
      repo: 'https://github.com/h2database/h2database',
    },
    'Hare':{
      desc: "Fast, safe, concurrent, systems, minimal, qbe",
      highlighting:"hare",
      ext: 'ha',
      kor: '해어',
      template:"hare",
      icon:'mdi-rabbit',
      args: 'run',
      command:"hare {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.ha:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://harelang.org',
      repo: 'https://sr.ht/~sircmpwn/hare',
    },
    'Haskell(ghc)':{
      desc: "Purely-functional, Strongly-typed, Lazy, Immutable, Mathematical",
      highlighting:"haskell",
      ext: 'hs',
      kor: '하스켈 - ghc',
      template:"haskell",
      icon:'mdi-language-haskell',
      args: '-v0',
      command:"ghc {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: "ghci",
      errorRegEx: ".+:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/haskell",
      homepage: 'https://www.haskell.org/ghc',
      repo: 'https://github.com/ghc/ghc',
    },
    'Haskell(hugs)':{
      desc: "Purely-functional, Strongly-typed, Lazy, Immutable, Mathematical",
      highlighting:"haskell",
      ext: 'hs',
      kor: '하스켈 - hugs',
      template:"hugs",
      icon:'mdi-language-haskell',
      command:"runhugs {ARGS} {FILENAME}.{EXT}",
      cli: "hugs",
      errorRegEx: ".+:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.haskell.org/hugs',
      repo: 'https://github.com/haskell-implementations/hugs',
    },
    'Hack':{
      desc: "PHP-based, Static-typed, Performance-oriented, Type-safe, Scalable",
      highlighting:"hack",
      ext: 'hack',
      kor: '핵',
      template:"hack",
      icon:'mdi-facebook',
      command:"hhvm -m run {ARGS} {FILENAME}.{EXT}",
      cli: "hhvm -m debug",
      errorRegEx: ".+? error: .+?\\.hack on line (\\d+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ubuntu2004",
      homepage: 'https://hacklang.org',
      repo: 'https://github.com/facebook/hhvm',
    },
    'Have':{
      desc: "Minimalistic, Educational, Functional, Concise, Experimental",
      highlighting:"go",
      ext: 'hav',
      kor: '해브',
      template:"have",
      icon:'mdi-dog-service',
      args: "run",
      command:"GOPATH=~ have {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "ERROR: .+?:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://havelang.org',
      repo: 'https://github.com/vrok/have',
    },
    'Haxe':{
      desc: "Cross-platform, Statically-typed, High-level, Versatile, Flexible",
      highlighting:"haxe",
      ext: 'hx',
      kor: '핵스',
      template:"haxe",
      icon:'mdi-axe',
      args: "--interp",
      command:"haxe {ARGS} --main {FILENAME}",
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+?:(\\d+): .+? : (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/haxe',
      homepage: 'https://haxe.org',
      repo: 'https://github.com/HaxeFoundation/haxe',
    },
    'Hedgehog':{
      desc: "Testing, Property-based, Haskell-based, Automated, Functional",
      highlighting:"hedgehog",
      ext: 'hg',
      kor: '헤지혹',
      template:"hedgehog",
      icon:'mdi-select-inverse',
      command:"hg {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.hg:(\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/yangtau',
      repo: 'https://github.com/yangtau/hedgehog',
    },
    'Hell':{
      desc: "Shell scripting language that is a tiny dialect of Haskell",
      highlighting:"hell",
      ext: 'hell',
      kor: '헬',
      template:"hell",
      icon:'mdi-emoticon-devil-outline',
      command:"hell {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,  // not supported
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://chrisdone.github.io/hell',
      repo: 'https://github.com/chrisdone/hell',
    },
    'Hermes':{
      desc: "JavaScript engine, Lightweight, Fast, React Native, Optimized",
      highlighting:"hermes",
      ext: 'he',
      kor: '헤르메스',
      template:"hermes",
      icon:'mdi-shoe-formal',
      command:"hermes {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\[Line (\\d+)\\] (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Hermes_(programming_language)',
      repo: 'https://github.com/sebbekarlsson/hermes',
    },
    'Hexiscript':{
      desc: "Scripting, Lightweight, Functional, Minimalistic, Flexible",
      highlighting:"hexi",
      ext: 'hexi',
      kor: '헥시스크립트',
      template:"hexi",
      icon:'mdi-script-text-outline',
      command:"hexi {ARGS} {FILENAME}.{EXT}",
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/Rion96/hexiscript',
      repo: 'https://github.com/Rion96',
    },
    'HLA':{
      desc: "High-level assembly, portable, and systems programming",
      highlighting:"hla",
      ext: 'hla',
      kor: 'HLA: 고수준어셈블리',
      template:"hla",
      icon:'mdi-decimal',
      args: "-i:/opt/hla/include -lib:/opt/hla/hlalib",
      command:"hla {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: "Error in .+?\\.hla\" at line (\\d+) .+\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.plantation-productions.com/Webster/HighLevelAsm',
      repo: 'https://www.plantation-productions.com/Webster/HighLevelAsm/LInuxDownload.html',
    },
    'Hook':{
      desc: "Imperative, cross-platform, dynamically typed, scripting",
      highlighting:"hook",
      ext: 'hk',
      kor: '후크',
      template:"hook",
      icon:'mdi-hook',
      args: null,
      command:"hook {ARGS} {FILENAME}.{EXT}",
      errorRegEx: ".+?\r\n  at .+?\\.hk:(\\d+).*",
      keyBindings: null,
      dockerImage: "ryusatgat/hook",
      homepage: 'https://github.com/hook-lang',
      repo: 'https://github.com/hook-lang/hook',
    },
    'Hope':{
      desc: "Declarative, high-level, and functional programming",
      highlighting:"hope",
      ext: 'hop',
      kor: '호프',
      template:"hope",
      icon:'mdi-weather-partly-cloudy',
      command:"/opt/hope/bin/hope {ARGS} -f {FILENAME}.{EXT}",
      cli: "/opt/hope/bin/hope {ARGS}",
      errorRegEx: "line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/dmbaturin',
      repo: 'https://github.com/dmbaturin/hope',
    },
    'Horse64':{
      desc: "64-bit, low-level, and systems-oriented language",
      highlighting:"horse64",
      ext: 'h64',
      kor: '호스64',
      template:"horse64",
      icon:'mdi-horseshoe',
      args: 'run',
      command:"horsec {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.h64:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://codeberg.org/Horse64/core.horse64.org',
      repo: 'https://github.com/horse64/core.horse64.org',
    },
    'HQ9+':{
      desc: "Esoteric, Turing-complete, Minimalistic, Concise, Humor-oriented",
      highlighting:null,
      ext: 'hq',
      kor: 'HQ9+',
      template:"hq9+",
      icon:'mdi-alpha-h',
      command:"hq9+c {FILENAME}.{EXT} {FILENAME} && ./{FILENAME}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://esolangs.org/wiki/HQ9%2B',
      repo: 'https://github.com/mmphosis/hq9',
    },
    'Huginn':{
      desc: "Automation, Ruby-based, Flexible, Event-driven, Web-focused",
      highlighting:"huginn",
      ext: 'hgn',
      kor: '후긴',
      template:"huginn",
      icon:'mdi-lightning-bolt',
      args: "--no-color",
      command:"LD_LIBRARY_PATH=/opt/huginn/lib huginn {ARGS} {FILENAME}.{EXT}",
      cli: "LD_LIBRARY_PATH=/opt/huginn/lib huginn {ARGS}",
      errorRegEx: ".+\\.hgn:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://huginn.org',
      repo: 'https://github.com/AmokHuginnsson/huginn',
    },
    'Huo':{
      desc: "Minimalistic, Functional, Educational, Concise, Simple",
      highlighting:"huo",
      ext: 'huo',
      kor: '휴오',
      template:"huo",
      icon:'mdi-code-parentheses-box',
      command:"/opt/huo/bin/huo {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/huo/bin/huo",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/HuoLanguage',
      repo: 'https://github.com/HuoLanguage/huo',
    },
    'Hush':{
      desc: "Shell, based on Lua, written by Rust",
      highlighting:"hush",
      ext: 'hsh',
      kor: '허쉬',
      template:"hush",
      icon:'mdi-emoticon-neutral-outline',
      args: null,
      command:"hush {ARGS} {FILENAME}.{EXT}",
      errorRegEx: ".+?\\(line (\\d+), column \\d+\\)(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://hush-shell.github.io',
      repo: 'https://github.com/hush-shell/hush',
    },
    'Hy':{
      desc: "Python-based, Lisp-like, functional, macros, interoperable",
      highlighting:"hy",
      ext: 'hy',
      kor: '히',
      template:"hy",
      icon:'mdi-jellyfish-outline',
      command:"hy {ARGS} {FILENAME}.{EXT}",
      cli: "hy",
      errorRegEx: ".+?\\.hy\", line (\\d+), .+\r\n(.+\r\n.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://hylang.org',
      repo: 'https://github.com/hylang/hy',
    },
    'Hybris':{
      desc: "Object oriented scripting language with dynamic typing, which is a language that does not require explicit declaration of the type of a variable",
      highlighting:"hybris",
      ext: 'hy',
      kor: '하이브리스',
      template:"hybris",
      icon:'mdi-cards-spade',
      command:"hybris {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\[LINE (\\d+)\\] (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/hybris',
      homepage: 'http://www.hybris-lang.org',
      repo: 'https://github.com/evilsocket/hybris',
    },
    'Hylo':{
      desc: "mutable value semantics, generic, high-level, swift-based",
      highlighting:"hylo",
      ext: 'hylo',
      kor: '하일로',
      template:"hylo",
      icon:'mdi-water',
      command:"hc {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      errorRegEx: ".+?\\.hylo\", line (\\d+), .+\r\n(.+\r\n.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/swift",
      homepage: 'https://www.hylo-lang.org',
      repo: 'https://github.com/hylo-lang/hylo',
    },
    'I':{
      desc: "Concise, Minimalistic, Procedural, Turing-complete, Abstract",
      highlighting:"i",
      ext: 'i',
      kor: 'I',
      template:"i",
      icon:'mdi-alpha-i',
      command:"/opt/i/I < {ARGS} {FILENAME}.{EXT}",
      cli: '/opt/i/I',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/mlochbaum/ILanguage/blob/master/doc/introduction.md',
      repo: 'https://github.com/mlochbaum/ILanguage',
    },
    'ICI':{
      desc: "Interactive, dynamic, and extensible interpreter",
      highlighting:"ici",
      ext: 'ici',
      kor: 'ICI',
      template:"ici",
      icon:'mdi-ice-pop',
      command:"ici {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.ici, (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/ici-language',
      repo: 'https://github.com/ici-language/ici',
    },
    'Idris':{
      desc: "Dependently-typed, functional, and proof-assistant",
      highlighting:"idris",
      ext: 'idr',
      kor: '이드리스',
      template:"idris",
      icon:'mdi-grass',
      command:'/opt/idris/bin/idris {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: "/opt/idris/bin/idris",
      errorRegEx: ".+\\.idr:(\\d+):\\d+(-\\d+)?:\r\n(  \\|.*\r\n)+.*?$",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.idris-lang.org',
      repo: 'https://github.com/idris-hackers',
    },
    'Idris2':{
      desc: "Dependent types, Functional, Strongly-typed, Proofs, Expressive",
      highlighting:"idris",
      ext: 'idr',
      kor: '이드리스2',
      template:"idris2",
      icon:'mdi-grass',
      args: '-x {FILENAME} --no-color',
      command:'/opt/idris2/bin/idris2 {ARGS} {FILENAME}.{EXT}',
      cli: '/opt/idris2/bin/idris2',
      errorRegEx: "Error: .+\r\n\r\n.+?:(\\d+):\\d+(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://idris-lang.org',
      repo: 'https://github.com/idris-lang/Idris2',
    },
    'Icon':{
      desc: "Concise, Pattern-matching, High-level, Declarative, Symbolic",
      highlighting:"icon",
      ext: 'icn',
      kor: '아이콘',
      template:"icon",
      icon:'mdi-alpha-i-circle-outline',
      command:'icont {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+?; Line (\\d+) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www2.cs.arizona.edu/icon',
      repo: 'https://github.com/gtownsend/icon',
    },
    'IDL':{
      desc: "Interface definition, Language-neutral, Serialization, Specification, RPC",
      highlighting:"idl",
      ext: 'pro',
      kor: '대화형데이터언어(GDL)',
      template:"idl",
      icon:'mdi-chart-bar-stacked',
      args: "-quiet",
      //command:'([ -f /tmp/xvfb.pid ] || (/etc/init.d/xvfb start && sleep 2)) && DISPLAY=:0 gdl {ARGS} {FILENAME}.{EXT}',
      command: 'echo -e "\\$rm -f main.png\\n.COMPILE {FILENAME}.{EXT}\\n{FILENAME}\\n\\$[ -f main.png ] && imshow main.png" | gdl {ARGS}',
      cli: "gdl {ARGS}",
      errorRegEx: "% .+?: .+?\r\n.+?: .+?, Line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/IDL_(programming_language)',
      repo: 'https://github.com/gnudatalanguage/gdl',
    },
    'Inform':{
      desc: "Interactive fiction, Natural language, Narrative, Authoring, Game-oriented",
      highlighting:"inform",
      ext: 'inf',
      kor: '인폼 - inform 6.36',
      template:"inform",
      icon:'mdi-card-text-outline',
      command: 'inform {ARGS} {FILENAME}.{EXT} && frotz {FILENAME}.z5',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Inform',
      repo: 'https://github.com/ganelson/inform',
    },
    'Ink':{
      desc: "Interactive fiction, Scripting, Narrative-focused, Lightweight, Flexible",
      highlighting:"ink",
      ext: 'ink',
      kor: '잉크',
      template:"ink",
      icon:'mdi-fountain-pen-tip',
      command: 'ink {ARGS} {FILENAME}.{EXT}',
      cli: 'ink -repl',
      errorRegEx: ".+? \\[(\\d+):\\d+\\]( in .+?\\.ink)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://dotink.co',
      repo: 'https://github.com/thesephist/ink',
    },
    'Inko':{
      desc: "Move semantics, static typing, type-safe concurrency, efficient error handling",
      highlighting:"inko",
      ext: 'inko',
      kor: '인코',
      template:"inko",
      icon:'mdi-asterisk-circle-outline',
      args: 'run',
      command: 'inko {ARGS} {FILENAME}.{EXT}',
      errorRegEx: ".+?\\.inko:(\\d+):\\d+ (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/inko",
      homepage: 'https://inko-lang.org',
      repo: 'https://github.com/inko-lang/inko',
    },
    'INTERCAL':{
      desc: "Esoteric, Minimalistic, Obfuscated, Turing-complete, Humorous",
      highlighting:"intercal",
      ext: 'i',
      kor: '인터칼',
      template:"intercal",
      icon:'mdi-gate-and',
      command: 'ick {ARGS} {FILENAME}.{EXT} && ./{FILENAME}',
      cli: null,
      errorRegEx: "ON THE WAY TO (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/INTERCAL',
      repo: 'http://thyrsus.com/gitweb/?p=intercal.git',
    },
    'Interfuse':{
      desc: "inspired on C, modern, LLVM",
      highlighting:"interfuse",
      ext: 'fuse',
      kor: '인터퓨즈',
      template:"interfuse",
      icon:'mdi-fuse',
      command: 'interfuse {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+? at (\\d+):\\d+(-\\d+)?: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://interfuselang.com',
      repo: 'https://github.com/RiverDave/InterfuseLang',
    },
    'Io':{
      desc: "Prototype-based, Object-oriented, Lightweight, Dynamic, Reflective",
      highlighting:"io",
      ext: 'io',
      kor: '아이오',
      template:"io",
      icon:'mdi-gate-not',
      command: 'io {ARGS} {FILENAME}.{EXT}',
      cli: "io {ARGS}",
      errorRegEx: "  Exception: .+?\r\n  -+?\r\n.+(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://iolanguage.org',
      repo: 'https://github.com/IoLanguage/io',
    },
    'Ioke':{
      desc: "Object-oriented, Prototype-based, Minimalistic, Dynamic, Reflective",
      highlighting:"ioke",
      ext: 'ik',
      kor: '아이오케',
      template:"ioke",
      icon:'mdi-weather-hurricane',
      command: 'ioke {ARGS} {FILENAME}.{EXT}',
      cli: "ioke {ARGS}",
      errorRegEx: ".+?\\.ik:(\\d+):\\d+(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://ioke.org',
      repo: 'https://github.com/olabini/ioke',
    },
    'Iphigeneia':{
      desc: "Declarative, Rule-based, Data-centric, Scripting, Flexible",
      highlighting:"iphi",
      ext: 'iphi',
      kor: '이피게네이아',
      template:"iphi",
      icon:'mdi-flower',
      command: 'iphi {ARGS} {FILENAME}.{EXT}',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://catseye.tc/node/Iphigeneia',
      repo: 'https://github.com/catseye/Iphigeneia',
    },
    'Ivy':{
      desc: "Extensible, dynamically typed, late binding, stand-alone, scripting",
      highlighting:"ivy",
      ext: 'i',
      kor: '아이비',
      template:"ivy",
      icon:'mdi-leaf-maple',
      command:"ivy {ARGS} {FILENAME}.{EXT}",
      errorRegEx: ".+? (\\d+): Error: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://microsoft.github.io/ivy/language.html',
      repo: 'https://github.com/jhallen/ivy-lang',
    },
    'J':{
      desc: "Concise, Minimalistic, Functional, Turing-complete, Experimental",
      highlighting:"j",
      ext: 'j',
      kor: 'J언어',
      template:"j",
      icon:'mdi-alpha-j-box',
      command:"jconsole {ARGS} < {FILENAME}.{EXT}",
      cli: "jconsole",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.jsoftware.com',
      repo: 'https://github.com/jsoftware/jsource',
    },
    'J*':{
      desc: "Array-oriented, Concise, Functional, High-performance, Mathematical",
      highlighting:"jstar",
      ext: 'jsr',
      kor: 'J스타',
      template:"jstar",
      icon:'mdi-alpha-j-circle',
      command:"/opt/jstar/bin/jstar {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/jstar/bin/jstar",
      errorRegEx: ".+?\\[line[: ](\\d+)\\].+\r\n(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://bamless.github.io/jstar/demo',
      repo: 'https://github.com/bamless/jstar',
    },
    'Jaksel':{
      desc: "Modern, easy to learn, using Indonesia-slang",
      highlighting:"jaksel",
      ext: 'jaksel',
      kor: '작셀',
      template:"jaksel",
      icon:'mdi-island-variant',
      args: null,
      command: 'jaksel {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: null,  // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://www.jsdelivr.com/package/npm/jaksel-language',
      repo: 'https://github.com/RioChndr/jaksel-language',
    },
    'Jakt':{
      desc: "Memory-safe, transpiles to C++",
      highlighting:"jakt",
      ext: 'jakt',
      kor: '잭트',
      template:"jakt",
      icon:'mdi-pistol',
      args: '-r',
      command: 'jakt {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: "Error: .+?\r\n.+?\\.jakt:(\\d+):\\d+.*",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/SerenityOS',
      repo: 'https://github.com/SerenityOS/jakt',
    },
    'Jancy':{
      desc: "High-level, Embeddable, Scripting, Systems-focused, Cross-platform",
      highlighting:"jancy",
      ext: 'jnc',
      kor: '잰시',
      template:"jancy",
      icon:'mdi-mushroom-outline',
      command:"jancy {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.jnc\\((\\d+),\\d+\\): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://jancy.org',
      repo: 'https://github.com/vovkos/jancy',
    },
    'Janet':{
      desc: "Lispy, Functional, Lightweight, Embeddable, Concise",
      highlighting:"janet",
      ext: 'janet',
      kor: '자넷',
      template:"janet",
      icon:'mdi-face-woman',
      command:"janet {ARGS} {FILENAME}.{EXT}",
      cli: "janet {ARGS}",
      errorRegEx: ".+?\\.janet:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://janet-lang.org',
      repo: 'https://github.com/janet-lang/janet',
    },
    'Jasmin':{
      desc: "Assembly-like, Bytecode, Low-level, Java-focused, Compact",
      highlighting:"jasmin",
      ext: 'j',
      kor: '자스민 - Java Assembler',
      template:"jasmin",
      icon:'mdi-coffee-to-go',
      command:"jasmin {ARGS} {FILENAME}.{EXT} && java -cp . {FILENAME}",
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+?\\.j:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/jasmin-lang/jasmin/wiki',
      repo: 'https://github.com/jasmin-lang/jasmin',
    },
    'Jinx':{
      desc: "Lightweight embeddable scripting language, written in modern C++",
      highlighting:"jinx",
      ext: 'jinx',
      kor: '징크스',
      template:"jinx",
      icon:'mdi-magic-staff',
      command:"jinx {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Error at line (\\d+), column \\d+: (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://jamesboer.github.io/Jinx',
      repo: 'https://github.com/JamesBoer/Jinx',
    },
    'Joao':{
      desc: "Minimalistic, Educational, Functional, Simple, Lightweight",
      highlighting:"joao",
      ext: 'jao',
      kor: '주앙',
      template:"joao",
      icon:'mdi-soccer',
      command:"joao {ARGS} {FILENAME}.{EXT}",
      cli: "joao",
      errorRegEx: "LINE: (\\d+),\\d+ (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://altoids1.github.io/Joao',
      repo: 'https://github.com/Altoids1/Joao',
    },
    'JohnsonScript':{
      desc: "Dynamic, Scripting, Lightweight, Interpreted, Flexible",
      highlighting:"johnsonscript",
      ext: 'john',
      kor: '존슨스크립트',
      template:"johnsonscript",
      icon:'mdi-sausage',
      command:"johnsonscript {FILENAME}.{EXT} {ARGS}",
      cli: null,
      errorRegEx: ".+? on line (\\d+)\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/amjohnson36',
      repo: 'https://github.com/amjohnson36/johnsonscript',
    },
    'Jolie':{
      desc: "Service-oriented, Concurrent, Declarative, Integration-focused, Messaging",
      highlighting:"jolie",
      ext: 'jolie',
      kor: '졸리',
      template:"jolie",
      icon:'mdi-seed-outline',
      command:"export JOLIE_HOME=/opt/jolie\n/opt/jolie/bin/jolie {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.jolie-lang.org',
      repo: 'https://github.com/jolie',
    },
    'Joy':{
      desc: "Concise, Functional, Stack-based, Turing-complete, Symbolic",
      highlighting:"joy",
      ext: 'joy',
      kor: '조이',
      template:"joy",
      icon:'mdi-seed-outline',
      command:"/opt/joy/joy {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://wodan58.github.io',
      repo: 'https://github.com/Wodan58/Joy',
    },
    'Jsish':{
      desc: "JavaScript-based, Lightweight, Embedded, Scripting, Flexible",
      highlighting:"javascript1",
      ext: 'jsi',
      kor: '제이시',
      template:"jsish",
      icon:'mdi-coffee-to-go-outline',
      command:"jsish {ARGS} {FILENAME}.{EXT}",
      cli: "jsish {ARGS}",
      errorRegEx: ".+?:(\\d+): \\w+: (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://jsish.org',
      repo: 'https://github.com/pcmacdon/jsish',
    },
    'JsonNet':{
      desc: "Data-centric, Configuration, JSON-based, Lightweight, Integration",
      highlighting:"hcl",
      ext: 'jsonnet',
      kor: '제이슨넷',
      template:"jsonnet",
      icon:'mdi-code-json',
      command:"jsonnet {ARGS} {FILENAME}.{EXT}",
      cli: "jsonnet {ARGS}",
      errorRegEx: ".+?\\.jsonnet:(\\d+):\\d+(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://jsonnet.org',
      repo: 'https://github.com/google/jsonnet',
    },
    'JSP':{
      desc: "Web-based, Java-driven, Server-side, Dynamic, Template",
      highlighting:"jsp",
      ext: 'jsp',
      kor: 'JSP',
      template:"jsp",
      icon:'mdi-alpha-j-box-outline',
      command:"mv -f {FILENAME}.{EXT} $JETTY_BASE/webapps/ROOT\nps -ef | grep start.jar | grep -v grep > /dev/null || (echo 'Starting JSP Server...' && (java -jar $JETTY_HOME/start.jar jetty.base=$JETTY_BASE 2> /dev/null &))\ncurl -4 -s --retry-connrefused --retry 10 --retry-delay 1 http://localhost:8080/{FILENAME}.{EXT} > {FILENAME}.html && imshow {FILENAME}.html",
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Jakarta_Server_Pages',
      repo: 'https://github.com/jetty/jetty.project',
    },
    'Jq':{
      desc: "Command-line, JSON-processing, Lightweight, Functional, Filter",
      highlighting:"jq",
      ext: 'jq',
      kor: 'Jq',
      template:"jq",
      icon:'mdi-code-json',
      args: "-n -f {FILENAME}.{EXT}",
      command:"jq {ARGS}",
      cli: null,
      errorRegEx: "jq: error: .+, line (\\d+):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://jqlang.github.io/jq',
      repo: 'https://github.com/jqlang/jq',
    },
    'Julia':{
      desc: "High-performance, Dynamic, Numerical, Functional, Multiple dispatch",
      highlighting:"julia",
      ext: 'jl',
      kor: '줄리아',
      template:"julia",
      icon:'mdi-google-circles-communities',
      command:"julia {ARGS} {FILENAME}.{EXT}",
      cli: "julia",
      errorRegEx: "in expression .+?:(\\d+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://julialang.org',
      repo: 'https://github.com/JuliaLang/julia',
    },
    'Juvix':{
      desc: "Static typing, strict semantics, designed for blockchain Anoma",
      highlighting:"juvix",
      ext: 'juvix',
      kor: '주빅스',
      template:"juvix",
      icon:'mdi-pig-variant-outline',
      args: 'compile native',
      command:"juvix {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: "^(\\d+) \\| .+?\r\n.+?\r\n(.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/clang",
      homepage: 'https://docs.juvix.org',
      repo: 'https://github.com/anoma/juvix',
    },
    'Jx9':{
      desc: "Embeddable scripting engine that implements a Turing complete based on JSON",
      highlighting:"jx9",
      ext: 'jx9',
      kor: 'Jx9',
      template:"jx9",
      icon:'mdi-open-source-initiative',
      command:"jx9 {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: '(\\d+) Error: (.+)',
      dockerImage: "ryusatgat/etc",
      homepage: 'https://jx9.symisc.net',
      repo: 'https://jx9.symisc.net/downloads.html',
    },
    'Jython':{
      desc: "Python-based, JVM-compatible, Dynamic, Interpreted, Cross-platform",
      highlighting:"python",
      ext: 'py',
      kor: '자이썬',
      template:"jython",
      icon:'mdi-language-java',
      command:"jython {ARGS} {FILENAME}.{EXT}",
      cli: 'jython {ARGS}',
      errorRegEx: ".*?, line (\\d+).*[\r\n]+(?:.*[\r\n]+)?(?:.*[\r\n]+)?(.*Error: .*)",
      dockerImage: '',
      homepage: 'https://www.jython.org',
      repo: 'https://github.com/jython/jython',
    },
    'K (kona)':{
      desc: "Array-based, Concise, Functional, High-performance, Interactive",
      highlighting:"kona",
      ext: 'k',
      kor: '코나',
      template:"kona",
      icon:'mdi-alpha-k',
      command:"k {ARGS} {FILENAME}.{EXT}",
      cli: "k {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/kevinlawler/kona/wiki',
      repo: 'https://github.com/kevinlawler/kona',
    },
    'Kagsa':{
      desc: "Easy to learn, practical, flexible syntax, object-oriented",
      highlighting:"kagsa",
      ext: 'kg',
      kor: '캑사',
      template:"kagsa",
      icon:'mdi-bird',
      command:"kagsa {ARGS} {FILENAME}.{EXT}",
      cli: "kagsa {ARGS}",
      errorRegEx: '.*error.+?, line (\\d+)\\)',
      keyBindings: null,
      dockerImage: "ryusatgat/python",
      homepage: 'http://www.kagsa.org',
      repo: 'https://github.com/kagsa/kagsa',
    },
    'KataScript':{
      desc: "Simple, scripting, easily embedded",
      highlighting:"katascript",
      ext: 'ks',
      kor: '카타스크립트',
      template:"katascript",
      icon:'mdi-bird',
      command:"KataScript {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: 'Error at line (\\d+) at \\d+: (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://brwhale.github.io/KataScript',
      repo: 'https://github.com/brwhale/KataScript',
    },
    'Kenaf':{
      desc: "Cross-platform, Lightweight, C-based, Scripting, Simple",
      highlighting:"kenaf",
      ext: 'kn',
      kor: '케나프',
      template:"kenaf",
      icon:'mdi-fleur-de-lis',
      command:"kenaf {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/edmundmk',
      repo: 'https://github.com/edmundmk/kenaf',
    },
    'Ketos':{
      desc: "Lisp dialect, scripting and extension, written in the Rust",
      highlighting:"lisp",
      ext: 'ketos',
      kor: '케토스',
      template:"ketos",
      icon:'mdi-code-parentheses',
      command:"ketos {ARGS} {FILENAME}.{EXT}",
      cli: 'ketos',
      errorRegEx: '.+?\\.ketos:(\\d+):\\d+:(.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/murarth/ketos/blob/master/docs/README.md',
      repo: 'https://github.com/murarth/ketos',
    },
    'Killa':{
      desc: "Lua-based, Scripting, Lightweight, Embeddable, Fast",
      highlighting:"killa",
      ext: 'kia',
      kor: '킬라',
      template:"killa",
      icon:'mdi-thumb-up-outline',
      command:"killa {ARGS} {FILENAME}.{EXT}",
      cli: "killa",
      errorRegEx: ".+?\\.kia:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://elrinconde-ex.blogspot.com/2012/09/killa-my-scripting-language-based-in.html',
      repo: 'https://github.com/ex/Killa',
    },
    'Kind':{
      desc: "Minimal, efficient, practical, rethink functional, modern",
      highlighting:"kind",
      ext: 'kind',
      kor: '카인드',
      template:"kind",
      icon:'mdi-emoticon-excited',
      args: '--run',
      command:"kind {FILENAME}.{EXT} && kind {FILENAME} {ARGS}",
      cli: "kind",
      defaultFilename: 'Main',
      errorRegEx: ".+?\\.kind:(\\d+):\\d+':\r\n(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://higherorderco.com',
      repo: 'https://github.com/HigherOrderCO/Kind',
    },
    'Kitten':{
      desc: "Statically typed, stack-based, functional, simplicity, speed, safety",
      highlighting:"kitten",
      ext: 'ktn',
      kor: '키튼',
      template:"kitten",
      icon:'mdi-cat',
      command:"kitten {ARGS} {FILENAME}.{EXT}",
      cli: "kitten",
      errorRegEx: ".+?\\.ktn:(\\d+)\\.\\d+-\\d+:(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://kittenlang.org',
      repo: 'https://github.com/evincarofautumn/kitten',
    },
    'Kinx':{
      desc: "Looks like JavaScript, feels like Ruby, and it is a script language fitting in C programmers",
      highlighting:"kinx",
      ext: 'kx',
      kor: '킹스',
      template:"kinx",
      icon:'mdi-jump-rope',
      args: null,
      command:"kinx {ARGS} {FILENAME}.{EXT}",
      cli: 'kinx --exec:repl',
      errorRegEx: "Error: .+? <.+?\\.kx>:(\\d+)",
      keyBindings: null,
      dockerImage: "ryusatgat/kinx",
      homepage: 'https://github.com/Kray-G',
      repo: 'https://github.com/Kray-G/kinx',
    },
    'Klaxon':{
      desc: "Minimal, modular, simple",
      highlighting:"klaxon",
      ext: 'klx',
      kor: '클랙슨',
      template:"klaxon",
      icon:'mdi-bullhorn-outline',
      command: 'klx -f {FILENAME}.{EXT} > {FILENAME}.asm && nasm -felf64 -o {FILENAME}.o {FILENAME}.asm && ld -o {FILENAME} {FILENAME}.o && ./{FILENAME}',
      errorRegEx: "",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/Jackojc',
      repo: 'https://github.com/Jackojc/klaxon',
    },
    'Klong':{
      desc: "like K, but without the syntactic ambiguity",
      highlighting:"klong",
      ext: 'kg',
      kor: '클롱',
      template:"klong",
      icon:'mdi-bullhorn-outline',
      command: 'kg {ARGS} {FILENAME}.{EXT}',
      errorRegEx: "",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://t3x.org/klong',
      repo: 'https://t3x.org/klong/klong20221212.tgz',
    },
    'Koka':{
      desc: "Functional, Effectful, Statically-typed, High-level, Research-oriented",
      highlighting:"koka",
      ext: 'kk',
      kor: '코카',
      template:"koka",
      icon:'mdi-bottle-soda-classic-outline',
      args: '--console=raw -v0',
      command:"/opt/koka/bin/koka {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/koka/bin/koka {ARGS}",
      errorRegEx: ".+?\\.kk\\((\\d+), \\d+\\): (error.+)(\r\n .+)*",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://koka-lang.github.io',
      repo: 'https://github.com/koka-lang/koka',
    },
    'Kos':{
      desc: "Concise, Scripting, Command-line, Automation, Linux-focused",
      highlighting:"kos",
      ext: 'kos',
      kor: '코스',
      template:"kos",
      icon:'mdi-laser-pointer',
      command:"/opt/kos/bin/kos {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/kos/bin/kos {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/kos-lang',
      repo: 'https://github.com/kos-lang/kos',
    },
    'Knight':{
      desc: "Minimalistic, Esoteric, Turing-complete, Obfuscated, Experimental",
      highlighting:"knight",
      ext: 'kn',
      kor: '나이트',
      template:"knight",
      icon:'mdi-chess-knight',
      args: '-f',
      command:"python3 /opt/knight/main.py {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/knight-lang',
      repo: 'https://github.com/knight-lang/knight-lang',
    },
    'Kotlin':{
      desc: "Modern, Statically-typed, JVM-compatible, Concise, Interoperable",
      highlighting:"kotlin",
      ext: 'kt',
      kor: '코틀린',
      template:"kotlin",
      icon:'mdi-language-kotlin',
      args: '-include-runtime',
      command:"kotlinc {FILENAME}.{EXT} {ARGS} -d {FILENAME}.jar && java -jar {FILENAME}.jar",
      cli: "kotlin",
      errorRegEx: ".+?:(\\d+):\\d+: .+: (.*)",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_K),
      dockerImage: "ryusatgat/jvm",
      homepage: 'https://kotlinlang.org',
      repo: 'https://github.com/JetBrains/kotlin',
    },
    'Kotlin Script':{
      desc: "Dynamic, Scriptable, Kotlin-based, Interpreted, Flexible",
      highlighting:"kotlin",
      ext: 'kts',
      kor: '코틀린스크립트',
      template:"kotlinscript",
      icon:'mdi-language-kotlin',
      command:"kotlinc -script {FILENAME}.{EXT} {ARGS}",
      cli: "kotlin",
      errorRegEx: ".+?:(\\d+):\\d+: .+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://kotlinlang.org/docs/custom-script-deps-tutorial.html',
      repo: 'https://github.com/JetBrains/kotlin',
    },
    'kscript':{
      desc: "Kotlin-based, Scripting, Lightweight, Interpreted, Simple",
      highlighting:"kscript",
      ext: 'ks',
      kor: '케이스크립트',
      template:"kscript",
      icon:'mdi-alpha-k-box',
      command:"/opt/kscript/bin/ks {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/kscript/bin/ks {ARGS}",
      errorRegEx: ".+\r\n.+\r\n.+\\.ks\\' \\(line (\\d+), (.+?\\):)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://kscript.org',
      repo: 'https://github.com/ChemicalDevelopment/kscript',
    },
    'Lake':{
      desc: "Replace C but sweeter, simple and small, fast compilation",
      highlighting:"lake",
      ext: 'lk',
      kor: '레이크',
      template:"lake",
      icon:'mdi-waves',
      command:"lakec {ARGS} {FILENAME}.{EXT} -o {FILENAME} && ./{FILENAME}",
      cli: null,
      errorRegEx: '.+?\\.lk:(\\d+):\\d+: error: (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://git.sr.ht/~lieks/lakec-old',
      repo: 'https://github.com/min4builder/lakec',
    },
    'Language 84':{
      desc: "Self-hosting compiler, functional, designed with basic type theory",
      highlighting:"l84",
      ext: '84',
      kor: '랭귀지 84',
      template:"l84",
      icon:'mdi-numeric-8-box-multiple-outline',
      command:"l84 {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: '.+?\\.84:(\\d+): (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/l84",
      homepage: 'http://norstrulde.org/language84',
      repo: 'http://norstrulde.org/language84/browse/language84-0.8',
    },
    'Lark':{
      desc: "Lxperiment in designing a homoiconic, syntax inspired by SmallTalk",
      highlighting:"lark",
      ext: 'lark',
      kor: '라크',
      template:"lark",
      icon:'mdi-bird',
      command:"lark {ARGS} {FILENAME}.{EXT}",
      cli: "ln -sf /opt/lark/base && lark",
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/jvm",
      homepage: 'https://github.com/munificent',
      repo: 'https://github.com/munificent/lark',
    },
    'LaTeX':{
      desc: "Document preparation, Typesetting, High-quality, Markup, Customizable",
      highlighting:"tex",
      ext: 'tex',
      kor: '레이텍',
      template:"latex",
      icon:'mdi-newspaper-variant-multiple-outline',
      args: "-output-format=pdf",
      command:"latex {ARGS} {FILENAME}.{EXT} && imshow {FILENAME}.pdf",
      cli: "latex {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.latex-project.org',
      repo: 'https://github.com/latex3/latex3',
    },
    'Latro':{
      desc: "Statically-typed, Functional, Concurrent, High-performance, Modern",
      highlighting:"latro",
      ext: 'l',
      kor: '라트로',
      template:"latro",
      icon:'mdi-hexagram-outline',
      args:'/opt/latro/lib/Core.l',
      command:"latroi {ARGS} {FILENAME}.{EXT}",
      cli: "latroi -i",
      errorRegEx: ".+?\\.l:(\\d+):\\d+:? (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/Zoetermeer',
      repo: 'https://github.com/Zoetermeer/latro',
    },
    'LAuREL':{
      desc: "Real, functional",
      highlighting:"laurel",
      ext: 'g',
      kor: '로렐',
      template:"laurel",
      icon:'mdi-language-typescript',
      command:"LAuREL {ARGS} {FILENAME}.{EXT}",
      cli: 'LAuREL',
      errorRegEx: "LAuREL: \\(line (\\d+), column \\d+\\):",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/dvbmgr',
      repo: 'https://github.com/dvbmgr/LAuREL',
    },
    'Leafscript':{
      desc: "Lightweight, written in Golang, interpreter",
      highlighting:"leafscript",
      ext: 'lfs',
      kor: '리프스크립트',
      template:"leafscript",
      icon:'mdi-leaf',
      args: '-r',
      command:"leafscript {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/odddollar',
      repo: 'https://github.com/odddollar/Leafscript',
    },
    'Lean':{
      desc: "Proof assistant, Functional, Type theory, Mathematical, Interactive",
      highlighting:"lean",
      ext: 'lean',
      kor: '린',
      template:"lean",
      icon:'mdi-water-minus-outline',
      args: "--run",
      command:"lean {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.lean:(\\d+):\\d+: error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.lean-lang.org',
      repo: 'https://github.com/leanprover/lean4',
    },
    'LeekScript':{
      desc: "Minimalistic, Scripting, Lightweight, Simple, Educational",
      highlighting:"leekscript",
      ext: 'leek',
      kor: '릭스크립트',
      template:"leekscript",
      icon:'mdi-leek',
      command:"leekscript {ARGS} {FILENAME}.{EXT}",
      cli: "leekscript",
      errorRegEx: ".*\r\n.+?\\.leek:(\\d+):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://leekwars.com',
      repo: 'https://github.com/leek-wars/leekscript',
    },
    'Lemon':{
      desc: "Parser generator with flexible syntax",
      highlighting:"lemon",
      ext: 'lm',
      kor: '레몬',
      template:"lemon",
      icon:'mdi-set-left',
      command:"lemon {ARGS} {FILENAME}.{EXT}",
      cli: "lemon",
      errorRegEx: ".+?\\.lm:(\\d+):\\d+: error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.lemon-lang.org',
      repo: 'https://github.com/lemon-lang/lemon',
    },
    'Levi':{
      desc: "Dynamic, Functional, Scripting, Lightweight, Concise",
      highlighting:"levi",
      ext: 'lvi',
      kor: '레비',
      template:"levi",
      icon:'mdi-television-classic',
      command:"levi {ARGS} {FILENAME}.{EXT}",
      cli: "levi",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/mm-project',
      repo: 'https://github.com/mm-project/levi_scripting_language',
    },
    'LDPL':{
      desc: "Natural-language, High-level, Readable, Simple, Procedural",
      highlighting:"ldpl",
      ext: 'ldpl',
      kor: 'LDPL',
      template:"ldpl",
      icon:'mdi-baby-face-outline',
      args: "-n",
      command:"ldpl {ARGS} {FILENAME}.{EXT} -o={FILENAME} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?: .+? \\(.+?:(\\d+)(.*)?\\).*",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.ldpl-lang.org',
      repo: 'https://github.com/Lartu/LDPL',
    },
    'Libra':{
      desc: "Lazy Interpreter of Binary Relational Algebra",
      highlighting:"libra",
      ext: '♎️',
      kor: '리브라',
      template:"libra",
      icon:'mdi-zodiac-libra',
      command:"libra {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.♎️:(\\d+):\\d+ (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/rzbin',
      repo: 'https://github.com/rzbin/libra',
    },
    'LightningScript':{
      desc: "Modern syntax, uncompromising performance, first-class embedding support",
      highlighting:"lightning",
      ext: 'li',
      kor: '라이트닝',
      template:"lightning",
      icon:'mdi-lightning-bolt',
      command:"li {ARGS} {FILENAME}.{EXT}",
      cli: 'li',
      errorRegEx: ".+?\\.li:(\\d+)\\] (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://liscript.org',
      repo: 'https://github.com/li-script/lightning',
    },
    'Lil (Decker)':{
      desc: "Cross platform, HW accelerated 2d/3d graphics engine, native apps and games",
      highlighting:"lilt",
      ext: 'lil',
      kor: '릴',
      template:"lilt",
      icon:'mdi-square-small',
      command:"lilt {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\((\\d+):\\d+\\) (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://beyondloom.com/decker/lil.html',
      repo: 'https://github.com/JohnEarnest/Decker',
    },
    'Lil (Little)':{
      desc: "Little Interpreted Language",
      highlighting:"lil",
      ext: 'lil',
      kor: '릴',
      template:"lil",
      icon:'mdi-square-small',
      command:"lil {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://www.ultimate.com/phil/lil',
      repo: 'https://github.com/wsxiaoys/lil',
    },
    'Lily':{
      desc: "Functional, Concise, Statically-typed, High-level, Pattern-matching",
      highlighting:"lily",
      ext: 'lily',
      kor: '릴리',
      template:"lily",
      icon:'mdi-flower-poppy',
      command:"lily {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\w+?: .+\r\n.+?:(\\d+):(.*)?",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://lily-lang.org',
      repo: 'https://gitlab.com/FascinatedBox/lily',
    },
    'Limbo':{
      desc: "Concurrent, type-safe, systems programming language",
      highlighting:"limbo",
      ext: 'b',
      kor: '림보',
      template: 'limbo',
      icon:'mdi-spider-thread',
      args: '-I /opt/inferno/module -o ~/{FILENAME}.dis {FILENAME}.{EXT} && /opt/inferno/bin/emu -c1 -r/opt/inferno ext/{FILENAME}.dis',
      command:"/opt/inferno/bin/limbo {ARGS}",
      cli: null,
      errorRegEx: ".+?\\.b:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Limbo_(programming_language)',
      repo: 'https://github.com/inferno-os/inferno-os',
    },
    'LiquidSoap':{
      desc: "Audio and video stream generators, flexible, extensible",
      highlighting:"liquidsoap",
      ext: 'squid',
      kor: '리퀴드소웁',
      template: 'liquidsoap',
      icon:'mdi-water-pump',
      command: 'liquidsoap {ARGS} {FILENAME}.{EXT}',
      cli: 'liquidsoap --interactive',
      errorRegEx: ".+?\\.b:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://www.liquidsoap.info',
      repo: 'https://github.com/savonet/liquidsoap',
    },
    'Lisaac':{
      desc: "Object-oriented, Functional, High-level, Dynamic, Extensible",
      highlighting:"lisaac",
      ext: 'li',
      kor: '리삭',
      template:"lisaac",
      icon:'mdi-bullseye',
      args: '-q -gcc -Wno-implicit-function-declaration',
      command:"lisaac {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://lisaac.org',
      repo: 'https://github.com/ontologiae/Lisaac',
    },
    'Lit':{
      desc: "dynamicaly-typed, inspired by highly-hackable Lua and familiar C-styled JavaScipt",
      highlighting:"lit",
      ext: 'lit',
      kor: '릿',
      template:"lit",
      icon:'mdi-emoticon-lol-outline',
      command:"lit {ARGS} {FILENAME}.{EXT}",
      cli: "lit {ARGS}",
      errorRegEx: "",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://egordorichev.github.io/lit-wiki/docs/getting_started',
      repo: 'https://github.com/egordorichev/lit',
    },
    'Little':{
      desc: "Minimalist, educational, small-scale language",
      highlighting:"little",
      ext: 'l',
      kor: '리틀',
      template:"little",
      icon:'mdi-bottle-soda-outline',
      command:"L {ARGS} {FILENAME}.{EXT}",
      cli: "L {ARGS}",
      errorRegEx: ".+\\.l:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.little-lang.org',
      repo: 'https://github.com/bitkeeper-scm/little-lang',
    },
    'LittleLang':{
      desc: "Educational, Minimalistic, Interpreted, Scripting, Simple",
      highlighting:"littlelang",
      ext: 'll',
      kor: '리틀랭',
      template:"littlelang",
      icon:'mdi-bullet',
      command:"littlelang {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+ (\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/benhoyt',
      repo: 'https://github.com/benhoyt/littlelang',
    },
    'LiveScript':{
      desc: "JavaScript-like, functional, transpiled language",
      highlighting:"livescript",
      ext: 'ls',
      kor: '라이브스크립트',
      template:"livescript",
      icon:'mdi-checkerboard',
      command:"lsc {ARGS} {FILENAME}.{EXT}",
      cli: "lsc {ARGS}",
      errorRegEx: "\\w+: .+? line (\\d+)(: .+)?",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://livescript.net',
      repo: 'https://github.com/gkz/LiveScript',
    },
    'LK':{
      desc: "Concise, Functional, Minimalistic, Lightweight, Research-oriented",
      highlighting:"lk",
      ext: 'lk',
      kor: 'LK',
      template:"lk",
      icon:'mdi-alpha-l-circle-outline',
      command:"lk {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "^(\\d+): (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://sam.nrel.gov/lk-script.html',
      repo: 'https://github.com/NREL/lk',
    },
    'LLVM-IR':{
      desc: "Intermediate representation for compiler design",
      highlighting:"llvm",
      ext: 'll',
      kor: 'LLVM-IR',
      template:"llvm",
      icon:'mdi-middleware-outline',
      args: "-Wno-override-module",
      command:"clang -o {FILENAME} {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: "null",
      errorRegEx: ".+?\\.ll:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://llvm.org/docs/LangRef.html',
      repo: 'https://github.com/llvm/llvm-project',
    },
    'Lobster':{
      desc: "Static-typed, Functional, Lightweight, Concurrent, High-performance",
      highlighting:"lobster",
      ext: 'lobster',
      kor: '랍스터',
      template:"lobster",
      icon:'mdi-fountain',
      args: '--import /opt/lobster/modules',
      command:"/opt/lobster/bin/lobster {FILENAME}.{EXT} {ARGS}",
      cli: null,
      errorRegEx: ".+?\\.lobster\\((\\d+)\\): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://strlen.com/lobster',
      repo: 'https://github.com/aardappel/lobster',
    },
    'Logo':{
      desc: "Educational, procedural, turtle graphics language",
      highlighting:"logo",
      ext: 'logo',
      kor: '로고',
      template:"logo",
      icon:'mdi-turtle',
      command:"ucblogo < {ARGS} {FILENAME}.{EXT}",
      cli: "ucblogo {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Logo_(programming_language)',
      repo: 'https://github.com/jrincayc/ucblogo-code',
    },
    'LOLCODE':{
      desc: "Esoteric, Minimalistic, Humor-oriented, English-like, Turing-complete",
      highlighting:"lolcode",
      ext: 'lol',
      kor: '롤코드',
      template:"lolcode",
      icon:'mdi-sword',
      command:"lci {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+\\.lol:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.lolcode.org',
      repo: 'https://github.com/justinmeza/lci',
    },
    'Loli':{
      desc: "Minimalistic, Concise, Educational, Experimental, Functional",
      highlighting:"loli",
      ext: 'li',
      kor: '롤리',
      template:"loli",
      icon:'mdi-candycane',
      command:"/opt/loli/loli {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/loli/loli",
      errorRegEx: ".+\r\n    from .+?\\.li:(\\d+)(:.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/kappactf',
      repo: 'https://github.com/kappactf/loli',
    },
    'Lox':{
      desc: "Simple, interpreted, dynamically-typed language",
      highlighting:"lox",
      ext: 'lox',
      kor: '록스',
      template:"lox",
      icon:'mdi-compass-outline',
      command:"loxi {ARGS} {FILENAME}.{EXT}",
      cli: "loxi {ARGS}",
      errorRegEx: "\\[line (\\d+)\\] (Error.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://benhoyt.com/writings/loxlox',
      repo: 'https://github.com/benhoyt/loxlox',
    },
    'Loxido':{
      desc: "Based on the clox reference, Rust implementation",
      highlighting:"lox",
      ext: 'lox',
      kor: '록시도',
      template:"loxido",
      icon:'mdi-fuel-cell',
      command:"loxido {ARGS} {FILENAME}.{EXT}",
      cli: "loxido {ARGS}",
      errorRegEx: "\\[line (\\d+)\\] Error(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/ceronman',
      repo: 'https://github.com/ceronman/loxido',
    },
    'Lua':{
      desc: "Lightweight, embeddable, dynamic scripting language",
      highlighting:"lua",
      ext: 'lua',
      kor: '루아',
      template:"lua",
      icon:'mdi-language-lua',
      command:"lua {ARGS} {FILENAME}.{EXT}",
      cli: "lua {ARGS}",
      errorRegEx: "lua.+?\\.lua:(\\d+): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/lua",
      homepage: 'https://www.lua.org',
      repo: 'https://github.com/lua/lua',
    },
    'LuaJIT':{
      desc: "Just-In-Time (JIT) compiler for the Lua",
      highlighting:"lua",
      ext: 'lua',
      kor: '루아짓',
      template:"luajit",
      icon:'mdi-language-lua',
      command:"luajit {ARGS} {FILENAME}.{EXT}",
      cli: "luajit {ARGS}",
      errorRegEx: "lua.+?\\.lua:(\\d+): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/lua",
      homepage: 'http://luajit.org',
      repo: 'https://github.com/LuaJIT/LuaJIT',
    },
    'Luau':{
      desc: "Fast, small, safe, gradually typed, embeddable, scripting, derived from Lua",
      highlighting:"lua",
      ext: 'lua',
      kor: '루아우',
      template:"luau",
      icon:'mdi-language-lua',
      command:"luau {ARGS} {FILENAME}.{EXT}",
      cli: "luau {ARGS}",
      errorRegEx: ".+?\\.lua:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/lua",
      homepage: 'https://luau.org',
      repo: 'https://github.com/luau-lang/luau',
    },
    'Luci':{
      desc: "Declarative, Data-centric, Scripting, Lightweight, Simple",
      highlighting:"luci",
      ext: 'luci',
      kor: '루시',
      template:"luci",
      icon:'mdi-alpha-l',
      command:"luci {ARGS} {FILENAME}.{EXT}",
      cli: "luci",
      errorRegEx: ".+? line #(\\d+), (col #\\d+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/naegelejd',
      repo: 'https://github.com/naegelejd/luci',
    },
    'Lumi':{
      desc: "Functional, High-level, Concise, Type-safe, Educational",
      highlighting:"lumi",
      ext: '5.lm',
      kor: '루미',
      template:"lumi",
      icon:'mdi-gender-female',
      command:"lumi {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+\\.lm\\[(\\d+)\\](.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://lumi-lang.readthedocs.io/en/latest',
      repo: 'https://github.com/meircif/lumi-lang',
    },
    'Luminique':{
      desc: "High-level, Bytecode, garbage collection, dynamic typing",
      highlighting:"luminique",
      ext: 'lmq',
      kor: '루미닉',
      template:"luminique",
      icon:'mdi-size-l',
      command:"luminique {ARGS} {FILENAME}.{EXT}",
      cli: "luminique",
      errorRegEx: ".+?\\.lmq:(\\d+) in script:(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://github.com/davidoskiii',
      repo: 'https://github.com/davidoskiii/Luminique',
    },
    'Lush':{
      desc: "Lisp-like syntax, object-oriented, weakly-typed, interpreted",
      highlighting:"lush",
      ext: 'lsh',
      kor: '러시',
      template:"lush",
      icon:'mdi-ellipse-outline',
      command:"lush {ARGS} {FILENAME}.{EXT}",
      cli: "lush {ARGS}",
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/lush",
      homepage: 'https://lush.sourceforge.net',
      repo: 'https://sourceforge.net/projects/lush/files',
    },
    'Luxury':{
      desc: "High-level, Object-oriented, Dynamic, Elegant, Expressive",
      highlighting:"luxury",
      ext: 'lux',
      kor: '럭셔리',
      template:"luxury",
      icon:'mdi-watch-variant',
      command:"luxury {ARGS} {FILENAME}.{EXT} {FILENAME}.s && gcc -static -o {FILENAME} {FILENAME}.s && ./{FILENAME}",
      cli: null,
      errorRegEx: " +(\\d+) \\| (.+\r\n.*\r\n.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/strawberryhacker',
      repo: 'https://github.com/strawberryhacker/luxury',
    },
    'M4':{
      desc: "Macro processor, text processing tool",
      highlighting:"m4",
      ext: 'm4',
      kor: 'M4',
      template:"m4",
      icon:'mdi-alpha-m-box-outline',
      command:"m4 {ARGS} {FILENAME}.{EXT}",
      cli: "m4 {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gnu.org/software/m4',
      repo: 'https://ftp.gnu.org/gnu/m4',
    },
    'Magpie':{
      desc: "Small, dynamically-typed, runs on the JVM",
      highlighting:"magpie",
      ext: 'mag',
      kor: '맥파이',
      template: 'magpie',
      icon:'mdi-bird',
      command:"magpie {ARGS} {FILENAME}.{EXT}",
      cli: 'magpie {ARGS}',
      errorRegEx: ".+?\\.mag \\(line (\\d+), col \\d+-\\d+\\)\\)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://magpie-lang.org',
      repo: 'https://github.com/munificent/magpie',
    },
    'Make':{
      desc: "Build automation, Simple, Declarative, Configuration, Cross-platform",
      highlighting:"make",
      ext: 'makefile',
      kor: '메이크 - gnumake',
      template:"make",
      icon:'mdi-order-alphabetical-ascending',
      command:"make {ARGS} -f {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.makefile:(\\d+): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gnu.org/software/make',
      repo: 'https://ftp.gnu.org/gnu/make',
    },
    'Malbolge':{
      desc: "Esoteric, Obfuscated, Turing-complete, Complex, Minimalistic",
      highlighting:null,
      ext: 'mlb',
      kor: '말레볼제',
      template:"malbolge",
      icon:'mdi-emoticon-devil',
      command:"malbolge {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://esolangs.org/wiki/Malbolge',
      repo: 'https://sange.fi/esoteric/orphaned/malbolge',
    },
    'Maml':{
      desc: "Interpreter and a compiler for the Monkey Programming Language",
      highlighting: "maml",
      ext: 'ape',
      kor: '마믈',
      template: 'maml',
      icon: 'mdi-panda',
      args: '-e "`cat {FILENAME}.{EXT}`"',
      command: 'maml {ARGS}',
      isCompiler:false,
      cli: 'maml -r',
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://github.com/k-kahora',
      repo: 'https://github.com/k-kahora/Maml',
    },
    'Mari':{
      desc: "Declarative, Data-centric, High-level, Flexible, Configurable",
      highlighting:"mari",
      ext: 'mr',
      kor: '마리',
      template:"mari",
      icon:'mdi-globe-light',
      args: '-o {FILENAME}',
      command:"mari {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.mr:(\\d+):\\d+ (.+)\r\n(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/heiytor',
      repo: 'https://github.com/heiytor/mari-programming-language',
    },
    'Maroon':{
      desc: "Functional, simple",
      highlighting: "maroon",
      ext: 'm',
      kor: '마룬',
      template: 'maroon',
      icon: 'mdi-treasure-chest-outline',
      command: 'maroon {ARGS} {FILENAME}.{EXT}',
      isCompiler:false,
      cli: null,
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://github.com/adam-mcdaniel',
      repo: 'https://github.com/adam-mcdaniel/maroon-lang',
    },
    'MASM 4.0':{
      desc: "Assembly language for x86 processors",
      highlighting:"tasm",
      ext: 'asm',
      kor: '매크로어셈블러 4.0 - dos 16bit',
      template:"masm40",
      icon:'mdi-hexadecimal',
      command:"unix2dos -q {FILENAME}.{EXT} && emu2 /opt/dos/masm40/MASM.EXE {ARGS} {FILENAME}.{EXT} {FILENAME}.obj NUL NUL && (echo | emu2 /opt/dos/masm40/LINK.EXE {ARGS} {FILENAME}.obj) > /dev/null && emu2 {FILENAME}.exe",
      cli: null,
      errorRegEx: ".+\\.asm\\((\\d+)\\) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Microsoft_Macro_Assembler',
      repo: 'https://winworldpc.com/product/macro-assembler/4x',
    },
/*  'MAsm 5.10':{
      desc: "Assembly language for x86 processors",
      highlighting:"tasm",
      ext: 'asm',
      kor: '매크로어셈블러 5.1',
      template:"masm51",
      icon:'mdi-hexadecimal',
      command:"emu2 /opt/dos/masm51/MASM.EXE {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+\\.asm\\((\\d+)\\) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.masm32.com',
      repo: '',
    },
*/
    'Maude':{
      desc: "Declarative, Rule-based, Rewriting, High-level, Formal",
      highlighting:"maude",
      ext: 'maude',
      kor: '모드',
      template:"maude",
      icon:'mdi-image-frame',
      args: "-no-banner",
      command:"/opt/maude/maude {ARGS} < {FILENAME}.{EXT}",
      cli: "/opt/maude/maude",
      errorRegEx: ".+?, line (\\d+)(.*?): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://maude.cs.illinois.edu',
      repo: 'https://github.com/maude-lang/Maude',
    },
    'Maxc':{
      desc: "Concise, C-like, Lightweight, High-level, Embeddable",
      highlighting:"maxc",
      ext: 'mxc',
      kor: 'Maxc',
      template:"maxc",
      icon:'mdi-code-less-than-or-equal',
      command:'maxc {ARGS} {FILENAME}.{EXT}',
      cli: 'maxc',
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/k-mrm',
      repo: 'https://github.com/k-mrm/maxc',
    },
    'Maxima':{
      desc: "Symbolic computation, mathematical analysis system",
      highlighting:"maxima",
      ext: 'mac',
      kor: '맥시마',
      template:"maxima",
      icon:'mdi-rhombus-split-outline',
      args: "--very-quiet",
      command:"maxima {ARGS} < {FILENAME}.{EXT}",
      cli: "maxima {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://maxima.sourceforge.io',
      repo: 'https://sourceforge.net/p/maxima/code/ci/master/tree',
    },
    'Melang':{
      desc: "Script language of time-sharing scheduling coroutine in single thread or multi-thread",
      highlighting:"melang",
      ext: 'm',
      kor: '멜론',
      template:"melang",
      icon:'mdi-fruit-watermelon',
      command:"melang {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\(at line (\\d+):(.*)",
      keyBindings: null,
      dockerImage: 'ryusatgat/melang',
      homepage: 'http://melang.org',
      repo: 'https://github.com/Water-Melon/Melon',
    },
    'Melon':{
      desc: "Functional, Lightweight, Scripting, Concise, Educational",
      highlighting:"melon",
      ext: 'ms',
      kor: '멜론',
      template:"melon",
      icon:'mdi-fruit-watermelon',
      command:"/opt/melon/bin/melon {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\(at line (\\d+):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://doc.melonc.io',
      repo: 'https://github.com/Water-Melon/Melon',
    },
    'MeowScript':{
      desc: "Small interpreted, easy extendable",
      highlighting:"meowscript",
      ext: 'mws',
      kor: '야옹스크립트',
      template:"meowscript",
      icon:'mdi-cat',
      command:"meow-script {ARGS} {FILENAME}.{EXT}",
      cli: 'meow-script -s',
      errorRegEx: "Error in line (\\d+):\r\n(.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://codeberg.org/LabRicecat/meowscript',
      repo: 'https://github.com/LabRicecat/MeowScript',
    },
    'Mercury':{
      desc: "Logic programming, strong typing, declarative",
      highlighting:"mercury",
      ext: 'm',
      kor: '머큐리',
      template:"mercury",
      icon:'mdi-decagram',
      command:"mmc {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.m:(\\d+): (.*)",
      keyBindings: null,
      dockerImage: 'ryusatgat/mercury',
      homepage: 'https://www.mercurylang.org',
      repo: 'https://github.com/Mercury-Language/mercury',
    },
    'Min':{
      desc: "Small, practical, concatenative",
      highlighting:"min",
      ext: 'min',
      kor: '민',
      template:"min",
      icon:'mdi-rhombus',
      command:"min {ARGS} {FILENAME}.{EXT}",
      cli: "min {ARGS}",
      errorRegEx: ".+?\\.min\\((\\d+),\\d+\\) (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://min-lang.org',
      repo: 'https://github.com/h3rald/min',
    },
    'MiniLang':{
      desc: "Modern, compiled, procedural, strongly typed, type and memory safe",
      highlighting:"minilang",
      ext: 'ml',
      kor: '미니랭',
      template:"minilang",
      icon:'mdi-mini-sd',
      command:"minilang {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: '.+?\\.ml:(\\d+):\\d+: (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/minilang",
      homepage: 'https://github.com/NICUP14/MiniLang/blob/main/QUICKSTART.md',
      repo: 'https://github.com/NICUP14/MiniLang',
    },
    'MiniLua':{
      desc: "Contained in a single header to be bundled in C/C++ applications with ease",
      highlighting:"lua",
      ext: 'lua',
      kor: '미니루아',
      template:"minilua",
      icon:'mdi-language-lua',
      command:"minilua {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/lua",
      homepage: 'https://github.com/edubart',
      repo: 'https://github.com/edubart/minilua',
    },
    'Miniscript':{
      desc: "Lightweight, Scripting, Embedded, Concise, Dynamic",
      highlighting:"miniscript",
      ext: 'ms',
      kor: '미니스크립트',
      template:"miniscript",
      icon:'mdi-panda',
      command:"miniscript {ARGS} {FILENAME}.{EXT}",
      cli: "miniscript {ARGS}",
      errorRegEx: ".+?: .+?\\[line (\\d+)\\](.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://miniscript.org',
      repo: 'https://github.com/JoeStrout/miniscript',
    },
    'MiniZinc':{
      desc: "Constraint-solving, High-level, Declarative, Optimization, Expressive",
      highlighting:"minizinc",
      ext: 'mzn',
      kor: '미니징크',
      template:"minizinc",
      icon:'mdi-rectangle-outline',
      command:"/opt/minizinc/bin/minizinc {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.mzn:(\\d+)\\..+\r\n(.+)?",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.minizinc.org',
      repo: 'https://github.com/MiniZinc',
    },
    'Minus':{
      desc: "Concise, functional, logic programming language",
      highlighting:"minus",
      ext: 'ms',
      kor: '마이너스',
      template:"minus",
      icon:'mdi-minus',
      command:"iminus {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.golfscript.com/minus',
      repo: 'https://www.golfscript.com/minus/implementations.html',
    },
    'Mirah':{
      desc: "Ruby-like, JVM-compatible, Statically-typed, High-performance, Concise",
      highlighting:"mirah",
      ext: 'mirah',
      kor: '미라',
      template:"mirah",
      icon:'mdi-alpha-m-box',
      command:"/opt/mirah/bin/mirah {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://mirah.org',
      repo: 'https://github.com/mirah/mirah',
    },
    'Miranda':{
      desc: "Purely-functional, Lazy, Statically-typed, Declarative, Mathematical",
      highlighting:"miranda",
      ext: 'm',
      kor: '미란다',
      template:"miranda",
      icon:'mdi-human-female',
      args:'-lib /opt/miranda/lib',
      command:"/opt/miranda/bin/mira {ARGS} -exec {FILENAME}.{EXT}",
      cli: "/opt/miranda/bin/mira {ARGS}",
      errorRegEx: ".+ error.+?\r\nerror.+?line (\\d+)( of file \".+?\\.m\")",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.cs.kent.ac.uk/people/staff/dat/miranda',
      repo: 'https://www.cs.kent.ac.uk/people/staff/dat/miranda/downloads',
    },
    'Mirth':{
      desc: "Integration-focused, Java-based, Lightweight, Messaging, Server-side",
      highlighting:"mirth",
      ext: 'mth',
      kor: '머스',
      template:"mirth",
      icon:'mdi-alpha-m-box',
      command:"mkdir -p bin src\nln -sf /opt/mirth/src/* src\nmv {FILENAME}.{EXT} src && mirth {ARGS} {FILENAME}.{EXT} && make bin/{FILENAME} && bin/{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.mth:(\\d+):\\d+: error:(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/mirth-lang',
      repo: 'https://github.com/mirth-lang/mirth',
    },
    'Modula-2':{
      desc: "Structured, Modular, Strongly-typed, Procedural, Pascal-like",
      highlighting:"m3",
      ext: 'mod',
      kor: '모듈라-2 - gm2',
      template:"m2",
      icon:'mdi-view-module-outline',
      command:'gm2 {ARGS} -o {FILENAME} {FILENAME}.{EXT} /usr/lib/x86_64-linux-gnu/libm2iso.so.15 && ./{FILENAME}',
      cli: null,
      errorRegEx: ".+\\.mod:(\\d+):\\d+:(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.modula2.org',
      repo: 'https://www.nongnu.org/gm2/download.html',
    },
    'Modula-3':{
      desc: "Object-oriented, Modular, Type-safe, Concurrent, High-level",
      highlighting:"m3",
      ext: 'm3',
      kor: '모듈라-3 - cm3',
      template:"m3",
      icon:'mdi-view-module-outline',
      args: "-silent",
      command:'echo -e \'import("libm3")\\nimplementation("{FILENAME}")\\nprogram("{FILENAME}")\' > m3makefile && cm3 {ARGS} && AMD64_LINUX/{FILENAME}',
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+?, line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.modula3.org',
      repo: 'https://github.com/modula3/cm3',
    },
    'Mojo':{
      desc: "High-performance, Python-like, Statically-typed, Systems-focused, Modern",
      highlighting:"mojo",
      ext: 'mojo',
      kor: '모조',
      template:"mojo",
      icon:'mdi-fire',
      command:'mojo {ARGS} {FILENAME}.{EXT}',
      cli: 'mojo',
      defaultFilename: 'main',
      errorRegEx: ".*?\\.mojo:(\\d+):\\d+: error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.modular.com/mojo',
      repo: 'https://github.com/modularml/mojo',
    },
    'MongoDB':{
      desc: "NoSQL, Document-oriented, Scalable, Flexible, High-performance",
      highlighting:"javascript1",
      ext: 'bson',
      kor: '몽고DB',
      template:"mongodb",
      icon:'mdi-leaf',
      command:"ps -ef | grep mongod | grep -v grep > /dev/null || (echo 'Starting MongoDB...' && (sudo mongod {ARGS} -f /etc/mongodb.conf --fork > /dev/null))\nmongo --quiet < {FILENAME}.{EXT}",
      cli: "ps -ef | grep mongod | grep -v grep > /dev/null || (echo 'Starting MongoDB...' && (sudo mongod {ARGS} -f /etc/mongodb.conf --fork > /dev/null))\nmongo --quiet",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.mongodb.com',
      repo: 'https://github.com/mongodb/mongo',
    },
    'Monkey':{
      desc: "Dynamic, Scripting, Lightweight, Minimalistic, Interpreted",
      highlighting:"monkey",
      ext: 'mnk',
      kor: '몽키 - cmonkey',
      template:"monkey",
      icon:'mdi-robber',
      command:"/opt/cmonkey/bin/monkey {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/cmonkey/bin/monkey",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/abhinav-upadhyay',
      repo: 'https://github.com/abhinav-upadhyay/cmonkey',
    },
    'Moo':{
      desc: "Esoteric, stack-based, golf-like",
      highlighting:null,
      ext: 'moo',
      kor: '무',
      template:"moo",
      icon:'mdi-weather-night',
      command: "stst {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: "ryusatgat/esolang",
      homepage: 'https://github.com/moratorium08',
      repo: 'https://github.com/moratorium08/moo',
    },
    'MoonScript':{
      desc: "Ruby-like, Transpiled, Concise, Scripting, Lua-based",
      highlighting:"moonscript",
      ext: 'moon',
      kor: '문스크립트',
      template:"moonscript",
      icon:'mdi-moon-waning-crescent',
      command: "moon {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?: .+?:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://moonscript.org',
      repo: 'https://github.com/leafo/moonscript',
    },
    'Motion':{
      desc: "Clean, dynamically typed",
      highlighting: "motion",
      ext: 'mtn',
      kor: '모션',
      template: 'motion',
      icon: 'mdi-motion',
      args: '-r {FILENAME}.{EXT}',
      command: 'motion {ARGS}',
      cli: 'motion',
      errorRegEx: ".+?line (\\d+)\\] \\[.+",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://github.com/MotionLang/motion/blob/main/docs/Getting_Started/Installation.md',
      repo: 'https://github.com/MotionLang/motion',
    },
    'Mouse':{
      desc: "interpreter, described by Peter Grogono in 1979",
      highlighting:'mouse',
      ext: 'm79',
      kor: '무',
      template:"mouse",
      icon:'mdi-mouse',
      command: "mouse {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: 'Line : (\\d+), Pos : \\d+',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://archive.org/details/byte-magazine-1979-07-rescan/page/n199/mode/2up',
      repo: 'https://github.com/Honneamise/MOUSE',
    },
    'mruby':{
      desc: "Lightweight implementation of the Ruby",
      highlighting:"ruby",
      ext: 'rb',
      kor: 'm루비',
      template:"mruby",
      icon:'mdi-language-ruby',
      command:"mruby {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.rb:(\\d+): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/ruby",
      homepage: 'https://mruby.org',
      repo: 'https://github.com/mruby/mruby',      
    },
    'Mu':{
      desc: "Statically-typed, functional, minimalist language",
      highlighting:"mu",
      ext: 'mu',
      kor: '뮤',
      template:"mu",
      icon:'mdi-alpha-m',
      command: "mux {ARGS} {FILENAME}.{EXT}",
      cli: "mux",
      errorRegEx: "error: .+?on line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://mu-script.org',
      repo: 'https://github.com/mu-script/mu',
    },
    'MUMPS':{
      desc: "Database-focused, procedural, hierarchical language",
      highlighting:"mumps",
      ext: 'mps',
      kor: 'MUMPS',
      template:"mumps",
      icon:'mdi-pot',
      command: "mumps {ARGS} {FILENAME}.{EXT}",
      cli: "mumps {ARGS}",
      errorRegEx: "\\*\\*\\* .+ line (\\d+):(\r\n.*\r\n\\*\\*\\* .+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.cs.uni.edu/~okane',
      repo: 'https://threadsafebooks.com/source/MUMPS-MDH',
    },
    'Mun':{
      desc: "Embeddable, scripting, statically typed, cross compilation",
      highlighting:"mun",
      ext: 'mun',
      kor: '문',
      template:"mun",
      icon:'mdi-cog',
      command:"mun new {FILENAME} 2> /dev/null; cp -f {FILENAME}.{EXT} {FILENAME}/src/mod.mun && cd {FILENAME} && (mun build && mun start target/mod.munlib); cd ..",
      errorRegEx: 'error: .+?\r\n --> .+?\\.mun:(\\d+):\\d+',
      keyBindings: null,
      dockerImage: "ryusatgat/mun",
      homepage: 'https://mun-lang.org',
      repo: 'https://github.com/mun-lang/mun',
    },
    'Muon':{
      desc: "Concurrent, high-performance, functional language",
      highlighting:"muon",
      ext: 'mu',
      kor: '뮤온',
      template:"muon",
      icon:'mdi-palm-tree',
      args:'/opt/muon/lib/core.mu',
      command: "/opt/muon/bin/mu {ARGS} {FILENAME}.{EXT} --output-file {FILENAME}.c && make {FILENAME} && ./{FILENAME}",
      cli: "/opt/muon/bin/mu {ARGS}",
      errorRegEx: ".+\r\n-> .+?\\.mu:(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/nickmqb',
      repo: 'https://github.com/nickmqb/muon',
    },
    'Myrddin':{
      desc: "Minimalist, functional, systems programming language",
      highlighting:"myrddin",
      ext: 'myr',
      kor: '머딘',
      template:"myrddin",
      icon:'mdi-shield-cross-outline',
      command:"PATH=$PATH:/opt/myrddin/bin mbld {ARGS} -b {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+\\.myr:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://myrlang.org',
      repo: 'https://github.com/oridb/mc',
    },
    'MY-BASIC':{
      desc: "Simple, procedural, lightweight scripting language",
      highlighting:"mybasic",
      ext: 'bas',
      kor: '마이베이식',
      template:"mybasic",
      icon:'mdi-lightbulb-on-outline',
      command:"mybasic {ARGS} {FILENAME}.{EXT}",
      cli: "mybasic {ARGS}",
      errorRegEx: "Error:\r\n.+?Ln (\\d+), Col \\d+\r\n.+?\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://paladin-t.github.io/my_basic',
      repo: 'https://github.com/paladin-t/my_basic',
    },
    'MySQL(mariadb)':{
      desc: "Relational database management system",
      highlighting:"mysql",
      ext: 'sql',
      kor: '마이SQL - mariadb',
      template:"mysql",
      icon:'mdi-database-search',
      args: '-D ryugod',
      command:"ps -ef | grep mysqld | grep -v grep > /dev/null || sudo service mysql start\nmysql {ARGS} -H < {FILENAME}.{EXT} > {FILENAME}.html && imshow {FILENAME}.html",
      cli: "ps -ef | grep mysqld | grep -v grep > /dev/null || sudo service mysql start\nmysql {ARGS}",
      errorRegEx: ".+? at line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://mariadb.org',
      repo: 'https://github.com/MariaDB',
    },
    'Mythryl':{
      desc: "Functional, strongly-typed, high-performance language",
      highlighting:"mythryl",
      ext: 'mythryl',
      kor: '미스릴',
      template:"mythryl",
      icon:'mdi-sword-cross',
      command:"chmod a+x {FILENAME}.{EXT} && ./{FILENAME}.{EXT}",
      cli: "/opt/mythryl/bin/mythryld",
      errorRegEx: ".+?:(\\d+).*? Error:(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://mythryl.org',
      repo: 'https://github.com/mythryl/mythryl',
    },
    'Nanoquery':{
      desc: "Query language, concise, expressive syntax",
      highlighting:"nanoquery",
      ext: 'nano',
      kor: '나노쿼리',
      template:"nanoquery",
      icon:'mdi-gesture',
      command:"nq {ARGS} {FILENAME}.{EXT}",
      cli: "nq {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://cygnus-x.net/design/nq',
      repo: '',
    },
    'Nasal':{
      desc: "Not another scripting language, small, functional",
      highlighting:"nasal",
      ext: 'nas',
      kor: '네이즐',
      template:"nasal",
      icon:'mdi-triangle-outline',
      command:"nasal {ARGS} {FILENAME}.{EXT}",
      errorRegEx: '.+?\r\n.+?\\.nas, line (\\d+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://web.archive.org/web/20140714101212/http://plausible.org/nasal',
      repo: '',
    },
    'Nature':{
      desc: "Modern, compiler, typed, null safety, generics, union types",
      highlighting:"nature",
      ext: 'n',
      kor: '네이쳐',
      template:"nature",
      icon:'mdi-ufo-outline',
      command:"nature build {ARGS} {FILENAME}.{EXT} && ./main",
      errorRegEx: '.+?\\.n:(\\d+):\\d+: (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://nature-lang.org',
      repo: 'https://github.com/nature-lang/nature',
    },
    'Nectar':{
      desc: "Object-orentied, procedural, comprises a combination of both high-level and low-level language",
      highlighting:"nectar",
      ext: 'nec',
      kor: '넥타르',
      template:"nectar",
      icon:'mdi-bee-flower',
      command:"([ -f {FILENAME} ] || nectar create {FILENAME}) && mv -f {FILENAME}.{EXT} {FILENAME}/src && \\\nnectar build {FILENAME} && nectar run {FILENAME}",
      defaultFilename: 'main_proj',
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/tasosxak',
      repo: 'https://github.com/tasosxak/nectar-lang',
    },
    'Nelua':{
      desc: "Efficient, statically-typed, lightweight language",
      highlighting:"lua",
      ext: 'nelua',
      kor: '넬루아',
      template:"nelua",
      icon:'mdi-earth',
      args: '--no-color',
      command:"nelua {ARGS} {FILENAME}.{EXT}",
      cli: "nelua-lua {ARGS}",
      errorRegEx: ".+?\\.nelua:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://nelua.io',
      repo: 'https://github.com/edubart/nelua-lang',
    },
    'Neko':{
      desc: "Lightweight, interpreted, dynamic language",
      highlighting:"neko",
      ext: 'neko',
      kor: '네코',
      template:"neko",
      icon:'mdi-robot',
      command:"nekoc {ARGS} {FILENAME}.{EXT} && neko {FILENAME}.n",
      cli: null,
      errorRegEx: ".+?\\.neko\\((\\d+)\\): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://nekovm.org',
      repo: 'https://github.com/HaxeFoundation/neko',
    },
    'NetRexx':{
      desc: "Scripting language, easy integration, IBM",
      highlighting:"rexx",
      ext: 'nrx',
      kor: '넷렉스',
      template:"netrexx",
      icon:'mdi-cards',
      args: '-verbose0 -exec',
      command:"nrc {ARGS} {FILENAME}.{EXT}",
      defaultFilename: 'Main',
      cli: null,
      errorRegEx: " (\\d+) \\+\\+\\+ .+\r\n( +?\\+\\+\\+ .+\r\n)+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.netrexx.org',
      repo: 'https://github.com/RexxLA/NetRexx',
    },
    'Nemerle':{
      desc: "Statically-typed, hybrid, multi-paradigm language",
      highlighting:"nemerle",
      ext: 'n',
      kor: '네머를',
      template:'nemerle',
      icon:'mdi-dot-net',
      command:"mono /opt/nemerle/ncc.exe -o {FILENAME} {ARGS} {FILENAME}.{EXT} && MONO_PATH=/opt/nemerle mono {FILENAME}.exe",
      cli: "mono /opt/nemerle/nemish.exe",
      errorRegEx: ".+?\\.n:(\\d+):\\d+:\\d+:\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ubuntu1404",
      homepage: 'http://nemerle.org',
      repo: 'http://nemerle.org/Downloads',
    },
    'Never':{
      desc: "Esoteric, Minimalistic, Obfuscated, Turing-complete, Experimental",
      highlighting:"never",
      ext: 'nev',
      kor: '네버',
      template:"never",
      icon:'mdi-directions-fork',
      command:"/opt/never/bin/never {ARGS} -f {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.nev:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://never-lang.readthedocs.io',
      repo: 'https://github.com/never-lang/never',
    },
    'NewLisp':{
      desc: "Minimalist, functional, Lisp-like language",
      highlighting:"lisp",
      ext: 'lsp',
      kor: '뉴리스프',
      template:"newlisp",
      icon:'mdi-beehive-outline',
      command:"newlisp {ARGS} {FILENAME}.{EXT}",
      cli: "newlisp {ARGS}",
      errorRegEx: ".+?\\((\\d), \\d\\) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.newlisp.org',
      repo: 'https://www.newlisp.org/downloads',
    },
    'NewtonScript':{
      desc: "Object-oriented, dynamic, scripting language",
      highlighting:"newtonscript",
      ext: 'lsp',
      kor: '뉴턴스크립트 - NEWT/0',
      template:"newtonscript",
      icon:'mdi-food-apple',
      command:"/opt/newt0/bin/newt {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\((\\d), \\d\\) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://newtonscript.org',
      repo: 'https://github.com/MatthiasWM/NEWT64',
    },
    'Next':{
      desc: "Concurrent, object-oriented, functional language",
      highlighting:"next",
      ext: 'n',
      kor: '넥스트',
      template:"next",
      icon:'mdi-page-next-outline',
      command:"next {ARGS} {FILENAME}.{EXT}",
      cli: "next",
      errorRegEx: ".+?\\.n:(\\d+)> (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/iamsubhranil',
      repo: 'https://github.com/iamsubhranil/Next',
    },
    'NGS':{
      desc: "Next Generation Shell",
      highlighting:"ngs",
      ext: 'ngs',
      kor: 'NGS',
      template:"ngs",
      icon:'mdi-cloud-arrow-right',
      command:"ngs {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.ngs:(\\d+):\\d+ - \\d+:\\d+",
      keyBindings: null,
      dockerImage: 'ryusatgat/ngs',
      homepage: 'https://ngs-lang.org',
      repo: 'https://github.com/ngs-lang/ngs',
    },
    'Nial':{
      desc: "Array programming, functional, concise language",
      highlighting:"nial",
      ext: 'ndf',
      kor: '나이얼',
      template:"nial",
      icon:'mdi-ship-wheel',
      command:"nial64 {ARGS} -defs {FILENAME}.{EXT}",
      cli: "echo 'type \"bye\" to quit' && nial64 -i {ARGS}",
      errorRegEx: ".+?\\((\\d), \\d\\) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.nial-array-language.org',
      repo: 'https://github.com/PlanetAPL/nial',
    },
    'Nibbles':{
      desc: "Educational, functional, minimalistic language",
      highlighting:"nibbles",
      ext: 'nbl',
      kor: '니블즈',
      template:"nibbles",
      icon:'mdi-shaker-outline',
      command:"nibbles -hs {ARGS} {FILENAME}.{EXT} && ghc -i/opt/nibbles out.hs -o {FILENAME} && ./{FILENAME}",
      cli: "nibbles {ARGS}",
      errorRegEx: "nibbles: .+?: .*\r\nat line: (\\d+), char: (\\d+):",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.golfscript.com/nibbles',
      repo: 'https://github.com/darrenks/nibbles',
    },
    'Nice':{
      desc: "Object-oriented, statically-typed, extensible language",
      highlighting:"nice",
      ext: 'nice',
      kor: '나이스',
      template:"nice",
      icon:'mdi-coffee-maker',
      args: '-a {FILENAME}.jar',
      command:"alias java=/usr/lib/jvm/java-8-openjdk-amd64/bin/java\nmkdir -p {FILENAME}_nice && mv -f {FILENAME}.{EXT} {FILENAME}_nice && /opt/nice/bin/nicec {ARGS} {FILENAME}_nice && java -jar {FILENAME}.jar",
      cli: null,
      errorRegEx: ".+?\\.nice: line (\\d+),.+?\\d+:\r\n(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://nice.sourceforge.net',
      repo: 'https://nice.sourceforge.net/install.html',
    },
    'Nickle':{
      desc: "High-level, numerical, scripting language",
      highlighting:"nickle",
      ext: 'n5',
      kor: '니클',
      template:"nickle",
      icon:'mdi-alpha-n-circle-outline',
      command:"nickle {ARGS} {FILENAME}.{EXT}",
      cli: "echo 'type \"bye\" to quit' && nial64 -i {ARGS}",
      errorRegEx: ".+?\\.n5:(\\d+): .+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://nickel-lang.org',
      repo: 'https://github.com/tweag/nickel',
    },
    'Nim':{
      desc: "Statically-typed, compiled, high-performance language",
      highlighting:"nim",
      ext: 'nim',
      kor: '님',
      template:"nim",
      icon:'mdi-crown-outline',
      args: '--verbosity:0',
      command:"nim c -r {ARGS} {FILENAME}.{EXT}",
      cli: "lua",
      errorRegEx: ".+?\\((\\d), \\d\\) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://nim-lang.org',
      repo: 'https://github.com/nim-lang/Nim',
    },
    'Nit':{
      desc: "Object-oriented, statically-typed, safe language",
      highlighting:"nit",
      ext: 'nit',
      kor: '닛',
      template:"nit",
      icon:'mdi-bug',
      command:"nit {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.nit:(\\d+),\\d+.+?: Error:(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://nitlanguage.org',
      repo: 'https://github.com/nitlang/nit',
    },
    'Nmet':{
      desc: "General purpose, statically-typed, compiledObject-oriented",
      highlighting:"nmet",
      ext: 'nmt',
      kor: '멧',
      template:"nmet",
      icon:'mdi-hexagon',
      command:"/opt/nmet/nmet {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".*?\\[.+?\\.nmt:(\\d+):\\d+\\].*? (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://mahanfr.ir/Nmet',
      repo: 'https://github.com/mahanfr/Nmet',
    },
    'Noja':{
      desc: "Very high level language, main inspirations was CPython",
      highlighting:"noja",
      ext: 'noja',
      kor: '노자',
      template:"noja",
      icon:'mdi-island-variant',
      command:"noja {ARGS} {FILENAME}.{EXT}",
      cli: "noja",
      errorRegEx: '.+?\\.noja:(\\d+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/cozis',
      repo: 'https://github.com/cozis/Noja',
    },
    'Noumenon':{
      desc: "Statically-typed, functional, mathematical focus",
      highlighting:"noumenon",
      ext: 'nm',
      kor: '누메논',
      template:"noumenon",
      icon:'mdi-chair-school',
      command:"noumenon {ARGS} {FILENAME}.{EXT}",
      cli: "noumenon",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/twied',
      repo: 'https://github.com/twied/noumenon',
    },
    'Novus':{
      desc: "High-level, concurrent, statically-typed language",
      highlighting:"novus",
      ext: 'ns',
      kor: '노부스',
      template:"novus",
      icon:'mdi-alpha-n-box-outline',
      args:'--no-color',
      command:"/opt/novus/bin/novc {ARGS} {FILENAME}.{EXT} && /opt/novus/bin/novrt {FILENAME}.nx",
      cli: null,
      errorRegEx: ".+?\\.ns:(\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/BastianBlokland',
      repo: 'https://github.com/BastianBlokland/novus',
    },
    'Nuua':{
      desc: "Concurrent, functional, statically-typed language",
      highlighting:"nuua",
      ext: 'nu',
      kor: '누아',
      template:"nuua",
      icon:'mdi-triforce',
      command:"nuua {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://nuua.io',
      repo: 'https://github.com/nuua-io/Nuua',
    },
    'Nyx':{
      desc: "Statically-typed, functional, strong type inference",
      highlighting:"nyx",
      ext: 'nyx',
      kor: '닉스',
      template:"nyx",
      icon:'mdi-bottle-wine-outline',
      command:"nyx {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?Error: .+? at line (\\d+), (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://github.com/kelthuzadx',
      repo: 'https://github.com/kelthuzadx/nyx',
    },
    'Oak':{
      desc: "Precursor to Java, object-oriented",
      highlighting:"oak",
      ext: 'ok',
      kor: '오크',
      template:"oak",
      icon:'mdi-saw-blade',
      args: ' -c c',
      command:"oak {ARGS} {FILENAME}.{EXT} && ./main",
      cli: null,
      errorRegEx: "(\\d+) \\| (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://crates.io/crates/oakc',
      repo: 'https://github.com/adam-mcdaniel/oakc',
    },
    'Oberon':{
      desc: "Modular, procedural, lightweight, strongly-typed",
      highlighting:"oberon",
      ext: 'm',
      kor: '오베론 - Oxford Oberon-2',
      template:"oberon",
      icon:'mdi-chess-king',
      command:"/opt/oberon/bin/obc {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.m\\\", line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://oberon.org',
      repo: 'https://github.com/zaskar9/oberon-lang',
    },
    'Objeck':{
      desc: "Object-oriented, virtual machine, garbage collection",
      highlighting:"objeck",
      ext: 'obs',
      kor: '오브젝크',
      template:"objeck",
      icon:'mdi-snowflake-variant',
      command:"OBJECK_LIB_PATH=/opt/objeck-lang/lib obc {ARGS} -src {FILENAME}.{EXT} && obr ./{FILENAME}.obe",
      cli: null,
      errorRegEx: ".+?:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://objeck.org',
      repo: 'https://github.com/objeck/objeck-lang',
    },
    'Objective-C':{
      desc: "Object-oriented, C-based, dynamic typing",
      highlighting:"objective-c",
      ext: 'm',
      kor: '오브젝티브-C',
      template:"objc",
      icon:'mdi-language-c',
      command:"gcc {ARGS} -fdiagnostics-color=never `gnustep-config --objc-flags` -o {FILENAME} {FILENAME}.{EXT} `gnustep-config --base-libs` && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.m:(\\d+):\\d+: error: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Objective-C',
      repo: 'https://gcc.gnu.org/git.html',
    },
    'OCaml':{
      desc: "Functional, statically-typed, type inference",
      highlighting:"ocaml",
      ext: 'ml',
      kor: 'OCaml',
      template:"ocaml",
      icon:'mdi-chart-line',
      command:"ocamlc {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: "ocaml",
      errorRegEx: "(\\d+) \\| (.+?\r\n.+\r\n.+: .*)",
      keyBindings: null,
      dockerImage: "ryusatgat/ocaml",
      homepage: 'https://ocaml.org',
      repo: 'https://github.com/ocaml/ocaml',
    },
    'Octave':{
      desc: "Numerical computing, MATLAB-compatible syntax",
      highlighting:"octave",
      ext: 'm',
      kor: '옥타브(매트랩)',
      template:"octave",
      icon:'mdi-chart-bell-curve',
      command:"octave {ARGS} -q {FILENAME}.{EXT}",
      cli: "octave {ARGS}",
      errorRegEx: ".+? near line (\\d+) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://octave.org',
      repo: 'https://github.com/gnu-octave/octave',
    },
    'Odin':{
      desc: "Static typing, manual memory management",
      highlighting:"odin",
      ext: 'odin',
      kor: '오딘',
      template:"odin",
      icon:'mdi-ray-start-arrow',
      command:"odin build {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.odin\\((\\d+):\\d+\\) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://odin-lang.org/',
      repo: 'https://github.com/odin-lang/Odin',
    },
    'Oforth':{
      desc: "Kid-friendly coding tool",
      highlighting:"oforth",
      ext: 'of',
      kor: '오포스',
      template:"oforth",
      icon:'mdi-alpha-o-circle-outline',
      command:"OFORTH_PATH=/opt/oforth oforth {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.oforth.com',
      repo: 'https://github.com/FranckBensusan/Oforth',
    },
    'Ooc':{
      desc: "Object-oriented, C-like, Lightweight, High-performance, Minimalistic",
      highlighting:"ooc",
      ext: 'ooc',
      kor: 'ooc - rock',
      template:"ooc",
      icon:'mdi-atom-variant',
      args: "-r",
      command:"rock {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.ooc:(\\d+):\\d+ (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://ooc-lang.org',
      repo: 'https://github.com/ooc-lang/the-ooc-language',
    },
    'Opal':{
      desc: "Strongly-typed programming language",
      highlighting:"opal",
      ext: 'opal',
      kor: '오팔',
      template:"opal",
      icon:'mdi-diamond-outline',
      args: '-P /opt/opal --nocolor',
      command:"opal {ARGS} {FILENAME}.{EXT}",
      cli: "opal --repl {ARGS}",
      errorRegEx: ".+?\\.opal:(\\d+):\\d+:\r\n.+\r\n.+\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.cs.oberlin.edu/~jwalker/opal/spec/introduction.html',
      repo: 'https://github.com/thatsOven/opal-lang',
    },
    'OpenSCAD':{
      desc: "3D modeling and design software",
      highlighting:"scad",
      ext: 'scad',
      kor: '오픈S캐드',
      template:"openscad",
      icon:'mdi-cube-scan',
      args: "--autocenter --viewall",
      command:"xvfb-run openscad {ARGS} -o {FILENAME}.png {FILENAME}.{EXT} && imshow {FILENAME}.png",
      errorRegEx: "ERROR: .+?\\.scad\\\", line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://openscad.org',
      repo: 'https://github.com/openscad/openscad',
    },
    'OpenSpin':{
      desc: "Spin language compiler and tool",
      highlighting:"spin",
      ext: 'spin',
      kor: '오픈스핀 - Spin/PASM',
      template:"spin",
      icon:'mdi-format-rotate-90',
      args: '-L /opt/openspin/lib',
      command:"openspin {ARGS} {FILENAME}.{EXT}",
      errorRegEx: ".+?\\.spin\\((\\d+):\\d+\\) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://packages.guix.gnu.org/packages/openspin',
      repo: 'https://github.com/parallaxinc/OpenSpin',
    },
    'Oracle':{
      desc: "Relational database management system",
      highlighting:"mysql",
      ext: 'sql',
      kor: '오라클- Oracle',
      template:"oracle",
      icon:'mdi-alpha-o-box',
      args: 'ryugod/ryugod@172.17.0.1:1521/FREEPDB1',
      command:'echo -e "SET PAGESIZE 50000;\n`cat {FILENAME}.{EXT}`" | sqlplus -S -M "HTML ON TABLE \'BORDER="1"\'" {ARGS} > {FILENAME}.html && imshow {FILENAME}.html',
      cli: "sqlplus {ARGS}",
      errorRegEx: ".+? at line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.oracle.com',
      repo: 'https://container-registry.oracle.com/ords/f?p=113:10::::::',
    },
    'Orc':{
      desc: "Parallel execution and dataflow",
      highlighting:"orc",
      ext: 'orc',
      kor: '오크',
      template:"orc",
      icon:'mdi-tree',
      command:"orc {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.orc:(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://orc.csres.utexas.edu',
      repo: 'https://github.com/orc-lang/orc',
    },
    'Orion':{
      desc: "High level, purely functional, lightness, portable, LISP based",
      highlighting:"lisp",
      ext: 'orn',
      kor: '오리온',
      template:"orion",
      icon:'mdi-lambda',
      command:"orion {ARGS} {FILENAME}.{EXT}",
      cli: 'orion',
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/Wafelack',
      repo: 'https://github.com/Wafelack/orion',
    },
    'Otto':{
      desc: "JavaScript parser and interpreter written natively in Go",
      highlighting:"javascript1",
      ext: 'js',
      kor: '오또',
      template:"otto",
      icon:'mdi-language-javascript',
      command:"otto {ARGS} {FILENAME}.{EXT}",
      cli: "otto {ARGS}",
      errorRegEx: ".+?: Line (\\d+):\\d+ (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'http://godoc.org/github.com/robertkrimen/otto',
      repo: 'https://github.com/robertkrimen/otto',
    },
    'Otus Lisp':{
      desc: "Symbolic computation and AI tool",
      highlighting:"lisp",
      ext: 'lisp',
      kor: '오투스 리스프 - OL',
      template:"ol",
      icon:'mdi-code-parentheses',
      command:"ol {ARGS} {FILENAME}.{EXT}",
      cli: "ol {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://yuriy-chumak.github.io/ol',
      repo: 'https://github.com/yuriy-chumak/ol',
    },
    'ObjectScript':{
      desc: "Multi-paradigm Script",
      highlighting:"java",
      ext: 'os',
      kor: '오브젝트스크립트 - oscript',
      template:"oscript",
      icon:'mdi-cube-send',
      command:"/opt/oscript/bin/oscript {ARGS} {FILENAME}.os",
      cli: null,
      errorRegEx: "(?:.*?: .+\r\n  at .+?\\.os:|Error parsing .+?\\.os, .+? at line )(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://objectscript.sourceforge.net',
      repo: 'https://sourceforge.net/projects/objectscript/files',
    },
    'Oz':{
      desc: "Multiparadigm programming and constraint solving",
      highlighting:"oz",
      ext: 'oz',
      kor: '오즈 - mozart',
      template:"oz",
      icon:'mdi-wizard-hat',
      args: '-c',
      command:"ozc {ARGS} -o {FILENAME}.ozf {FILENAME}.{EXT} && ozengine ./{FILENAME}.ozf",
      cli: null,
      errorRegEx: "(?:%\\*.+\r\n)+?%\\*\\* .+? \\\".+?\\\", line (\\d+), column \\d+(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://mozart2.org',
      repo: 'https://github.com/mozart/mozart2',
    },
    'P':{
      desc: "Concise, Experimental, Turing-complete, Minimalistic, Functional",
      highlighting:"p",
      ext: 'p',
      kor: 'P',
      template:"p",
      icon:'mdi-alpha-p-circle',
      args: 'compile',
      command:"~/.dotnet/tools/p {ARGS} -pn {FILENAME} -pf {FILENAME}.{EXT} -o {FILENAME} && {FILENAME}/CSharp/net?.0/{FILENAME}",
      cli: null,
      errorRegEx: "\\[.+?\\.p\\] .+?: line (\\d+):\\d+ (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ms",
      homepage: 'https://p-org.github.io/P',
      repo: 'https://github.com/p-org/P',
    },
    'P++':{
      desc: "Extended C++ for parallel programming",
      highlighting:"ppp",
      ext: 'p++',
      kor: 'P++',
      template:"ppp",
      icon:'mdi-alpha-p',
      command:"P_SOURCE_PATH=/opt/ppp/lib /opt/ppp/p++ {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.p\\+\\+\\], line ~(\\d+)>\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/tumtumtum',
      repo: 'https://github.com/tumtumtum/pplusplus',
    },
    'Pagan':{
      desc: "Programming language for automated reasoning",
      highlighting:"pagan",
      ext: 'pgn',
      kor: '페이건',
      template:"pagan",
      icon:'mdi-account-star-outline',
      command:"pagan {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/prwoodbury',
      repo: 'https://github.com/prwoodbury/pagan',
    },
    'Par':{
      desc: "Parallel computing and programming system",
      highlighting:"par",
      ext: 'par',
      kor: '파',
      template:"par",
      icon:'mdi-golf',
      command:"par {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+:\r\n\r\n(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://par-lang.org',
      repo: 'https://github.com/karthikv/par',
    },
    'PARI/GP':{
      desc: "Mathematical computation and algebra system",
      highlighting:"gp",
      ext: 'gp',
      kor: 'PARI/GP',
      template:"gp",
      icon:'mdi-math-integral',
      args: '-q',
      command:"gp {ARGS} < {FILENAME}.{EXT}",
      cli: "gp {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://pari.math.u-bordeaux.fr',
      repo: 'https://pari.math.u-bordeaux.fr/pub/pari/unix',
    },
    'ParaSail':{
      desc: "Concurrent programming language for safety",
      highlighting:"parasail",
      ext: 'psl',
      kor: '파라세일',
      template:"parasail",
      icon:'mdi-triforce',
      args: "-command {FILENAME}",
      command:"/opt/parasail/bin/interp.csh {FILENAME}.{EXT} {ARGS}",
      cli: "/opt/parasail/bin/interp.csh {FILENAME}.{EXT}",
      errorRegEx: ".+?\\.psl:(\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/ParaSail_(programming_language)',
      repo: 'https://github.com/parasail-lang/parasail',
    },
    'Parser3':{
      desc: "Data parsing and manipulation tool",
      highlighting:"parser3",
      ext: 'p',
      kor: '파서3',
      template:"parser3",
      icon:'mdi-zodiac-leo',
      args: null,
      command:"/opt/parser3/parser3.cgi {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.parser.ru/en',
      repo: 'https://github.com/artlebedev/parser3',
    },
    'Pascal':{
      desc: "Structured procedural programming language",
      highlighting:"pascal",
      ext: 'pas',
      kor: '파스칼 - fpc',
      template:"pascal",
      icon:'mdi-zodiac-leo',
      args: '-l- -v0',
      command:"fpc {ARGS} {FILENAME}.{EXT} 2> /dev/null && ./{FILENAME}",
      cli: null,
      errorRegEx: ".*?\\.pas\\((\\d+)(?:,\\d+)?\\) (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Pascal_(programming_language)',
      repo: 'https://github.com/fpc',
    },
    'Passerine':{
      desc: "Small, extensible, embeddable, highly expressive, light and fast",
      highlighting:"passerine",
      ext: 'pn',
      kor: '패서린',
      template:"passerine",
      icon:'mdi-bird',
      command:"aspen new {FILENAME} 2> /dev/null; cp -f {FILENAME}.{EXT} {FILENAME}/src/main.{EXT} && aspen run {FILENAME}",
      cli: 'aspen repl',
      errorRegEx: ".+?\\.pn:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://passerine.io',
      repo: 'https://github.com/vrtbl/passerine',
    },
    'Pawn':{
      desc: "Lightweight scripting language for game mods",
      highlighting:"pawn",
      ext: 'p',
      kor: '폰',
      template:"pawn",
      icon:'mdi-chess-pawn',
      command:"pawncc {FILENAME}.{EXT} && pawnrun ./{FILENAME};tput init",
      cli: null,
      errorRegEx: ".+?\\((\\d+)\\) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/pawn-lang',
      repo: 'https://github.com/pawn-lang/compiler',
    },
    'Pepper':{
      desc: "Visual programming environment for robots",
      highlighting:"pepper",
      ext: 'pr',
      kor: '페퍼',
      template:"pepper",
      icon:'mdi-chili-mild',
      command:"pepper {ARGS} {FILENAME}.{EXT}",
      cli: "pepper {ARGS}",
      errorRegEx: "(\\d+):\\d+: .+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/dannyvankooten',
      repo: 'https://github.com/dannyvankooten/pepper-lang',
    },
/* still, 32bit environment does not supported
    'Peridot':{
      desc: "Dynamically typed, interpreted, embeddable, fast, asynchronous",
      highlighting:"peridot",
      ext: 'pd',
      kor: ' 페리도트',
      template:"peridot",
      icon:'mdi-diamond-stone',
      command:"peridot {ARGS} {FILENAME}.{EXT}",
      cli: "peridot",
      errorRegEx: '',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: '',
      repo: 'https://github.com/peridot/peridot',
    },
*/
    'Perl':{
      desc: "Text processing, flexible, scripting language",
      highlighting:"perl",
      ext: 'pl',
      kor: '펄',
      template:"perl",
      icon:'mdi-image-filter-hdr',
      command:"perl {ARGS} {FILENAME}.{EXT}",
      cli: "perl {ARGS} -de1",
      errorRegEx: ".* line (\\d+)([,\\.].*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.perl.org',
      repo: 'https://github.com/Perl/perl5',
    },
    'PForth':{
      desc: "Portable ANS-like Forth written in ANSI 'C'",
      highlighting:"forth",
      ext: 'fth',
      kor: 'P포스',
      template:"pforth",
      icon:'mdi-dice-4-outline',
      args: '-q',
      command:"pforth {ARGS} {FILENAME}.{EXT}",
      cli: "pforth {ARGS}",
      errorRegEx: ".+?:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://www.softsynth.com/pforth',
      repo: 'https://github.com/philburk/pforth',
    },
    'Pharo':{
      desc: "Object-oriented programming environment",
      highlighting:"pharo",
      ext: 'st',
      kor: '페이로',
      template:"pharo",
      icon:'mdi-lighthouse-on',
      args: '--headless /opt/pharo/Pharo.image',
      command:"/opt/pharo/pharo {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? line (\\d+):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://pharo.org',
      repo: 'https://github.com/pharo-project/pharo',
    },
    'Phix':{
      desc: "Extended BASIC programming dialect",
      highlighting:"phix",
      ext: 'exw',
      kor: '픽스',
      template:"phix",
      icon:'mdi-alpha-p-circle',
      command:'echo -e "\\n" | p {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?:(\\d+)\r\n(.+\r\n.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/phix',
      homepage: 'http://phix.x10.mx',
      repo: 'https://github.com/petelomax/Phix',
    },
    'PIC':{
      desc: "Microcontroller programming environment",
      highlighting:"pic",
      ext: 'pic',
      kor: '픽 - gnupic',
      template:"pic",
      icon:'mdi-picture-in-picture-top-right-outline',
      args: '--output-format png > {FILENAME}.png && imshow {FILENAME}.png',
      command:"pic2plot {FILENAME}.{EXT} {ARGS}",
      cli: null,
      errorRegEx: ".+?\\.pic:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gnu.org/software/plotutils/manual/en/html_node/pic2plot-Introduction.html',
      repo: 'https://sourceforge.net/projects/plotutils/files',
    },
    'Picat':{
      desc: "Declarative, Logic programming, Constraint-solving, High-level, Flexible",
      highlighting:"picat",
      ext: 'pi',
      kor: '파이캣',
      template:"picat",
      icon:'mdi-cat',
      command:"picat {ARGS} {FILENAME}.{EXT}",
      cli: "picat {ARGS}",
      errorRegEx: ".+? ERROR .+? \\((\\d+)\\-\\d+\\) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://picat-lang.org',
      repo: 'https://github.com/rurban/picat-lang',
    },
    'PicoC':{
      desc: "Embedded, C-like, Lightweight, Interpreted, Simple",
      highlighting:"c",
      ext: 'c',
      kor: '피코C',
      template:"picoc",
      icon:'mdi-language-c',
      command:"picoc {ARGS} {FILENAME}.{EXT}",
      cli: "picoc -i {ARGS}",
      errorRegEx: ".+?\\.c:(\\d+):\\d+ (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://code.google.com/archive/p/picoc',
      repo: 'https://github.com/jpoirier/picoc',
    },
    'PicoLisp':{
      desc: "Minimalistic, Lisp-like, Dynamic, High-level, Symbolic",
      highlighting:"lisp",
        ext: 'lisp',
        kor: '피코리스프',
        template:"picolisp",
        icon:'mdi-chevron-right-box-outline',
        command:"picolisp {ARGS} {FILENAME}.{EXT}",
        cli: "picolisp {ARGS}",
        errorRegEx: "\\[.+?:(\\d+)\\] (.+)",
        keyBindings: null,
      dockerImage: '',
      homepage: 'https://picolisp.com',
      repo: 'https://github.com/picolisp/pil21',
      },
    'Pike':{
      desc: "Dynamic, Object-oriented, High-performance, C-like, Scripting",
      highlighting:"pike",
      ext: 'pike',
      kor: '파이크',
      template:"pike",
      icon:'mdi-saxophone',
      command:"pike {ARGS} {FILENAME}.{EXT}",
      cli: "pike {ARGS}",
      errorRegEx: ".+?:(\\d+):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://pike.lysator.liu.se',
      repo: 'https://github.com/pikelang/Pike',
    },
    'PILOT':{
      desc: "Educational, Procedural, Simple, Interactive, Lightweight",
      highlighting:"pilot",
      ext: 'p',
      kor: '파일럿 - psPILOT',
      template:"pilot",
      icon:'mdi-seat-recline-normal',
      command:"pwsh /opt/psPILOT/psPILOT.ps1 {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/PILOT',
      repo: 'https://github.com/FreeTrav/psPILOT',
    },
    'Pinecone':{
      desc: "Fast, concise, intuitive, general purpose, multi-paradigm, high performance",
      highlighting:"pinecone",
      ext: 'pn',
      kor: '파인콘',
      template:"pinecone",
      icon:'mdi-pine-tree-variant',
      command:"pinecone {ARGS} {FILENAME}.{EXT}",
      cli: 'pinecone',
      errorRegEx: "error in '.+?\\.pn' on line (\\d+):\r\n(.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://pinecone-lang.herokuapp.com',
      repo: 'https://github.com/wmww/Pinecone',
    },
    'Pkl':{
      desc: "Embeddable, configuration language, data templating and validation",
      highlighting:"pkl",
      ext: 'pk',
      kor: '피클',
      template:"pkl",
      icon:'mdi-apple',
      args: "eval",
      command:"pkl {ARGS} ./{FILENAME}.{EXT}",
      cli: 'pkl repl',
      errorRegEx: "(\\d+) \\| (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/pkl",
      homepage: 'https://pkl-lang.org',
      repo: 'https://github.com/apple/pkl',
    },
    'PL/0':{
      desc: "Intended as an educational, similar to but much simpler than Pascal",
      highlighting:"pl0",
      ext: 'pl0',
      kor: 'PL/0',
      template:"pl0",
      icon:'mdi-calculator-variant-outline',
      command:"pl0 {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Error\\((\\d+):\\d+\\): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://en.wikipedia.org/wiki/PL/0',
      repo: 'https://github.com/AkashSamlal/PL0-Compiler',
    },
    'PLC/ST':{
      desc: "Structured text, industrial automation language",
      highlighting:"st",
      ext: 'st',
      kor: 'PLC (Structured Text, Rusty)',
      template:"st",
      icon:'mdi-electric-switch',
      args: '--linker cc',
      command:"/opt/rusty/plc -o {FILENAME} {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".*?error\\[E\\d+].*?: .*\r\n.*\\.st:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://en.wikipedia.org/wiki/Structured_text',
      repo: 'https://github.com/PLC-lang/rusty',
    },
    'Plasma':{
      desc: "Combining the assurances of type safe, pure functional programming",
      highlighting:"plasma",
      ext: 'p',
      kor: '플라즈마',
      template:"plasma",
      icon:'mdi-fire',
      args: null,
      command:"plzc {ARGS} {FILENAME}.{EXT} && plzlnk -n {FILENAME} -o {FILENAME}.pz {FILENAME}.pzo && plzrun {FILENAME}.pz",
      cli: null,
      errorRegEx: ".+?\\.p:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/mercury",
      homepage: 'https://plasmalang.org',
      repo: 'https://github.com/PlasmaLang/plasma',
    },
    'Pluto':{
      desc: "Functional, Reactive, Julia-based, Interactive, Notebook",
      highlighting:"pluto",
      ext: 'pluto',
      kor: '플루토',
      template:"pluto",
      icon:'mdi-dots-horizontal-circle',
      args: '-W',
      command:"/opt/pluto/pluto {ARGS} {FILENAME}.{EXT}",
      cli: '/opt/pluto/pluto',
      errorRegEx: ".+?: .+? error: .+?\\.pluto:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://pluto-lang.org',
      repo: 'https://github.com/PlutoLang/Pluto',
    },
    'Pocketlang':{
      desc: "Lightweight, Embeddable, Scripting, Simple, Dynamic",
      highlighting:"pocketlang",
      ext: 'pk',
      kor: '포켓랭',
      template:"pocketlang",
      icon:'mdi-inbox-outline',
      command:"/opt/pocketlang/bin/pocket {ARGS} {FILENAME}.{EXT}",
      cli: '/opt/pocketlang/bin/pocket',
      errorRegEx: ".+\r\n.+?\\.pk\":(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://thakeenathees.github.io/pocketlang',
      repo: 'https://github.com/ThakeeNathees/pocketlang',
    },
    'Pocketpy':{
      desc: "Lightweight Python 3.x interpreter for game scripting",
      highlighting:"python",
      ext: 'py',
      kor: '포켓파이',
      template:"pocketpy",
      icon:'mdi-language-python',
      command:"pocketpy {ARGS} {FILENAME}.{EXT}",
      cli: 'pocketpy {ARGS}',
      errorRegEx: ".+?\\.py\", line (\\d+)(?:.*?\r\n)+?(.*?Error: .*)",
      keyBindings: null,
      dockerImage: "ryusatgat/python",
      homepage: 'https://pocketpy.dev',
      repo: 'https://github.com/pocketpy/pocketpy',
    },
    'Pony':{
      desc: "Object-oriented, Actor-based, Concurrent, Type-safe, High-performance",
      highlighting:"pony",
      ext: 'pony',
      kor: '포니',
      template:"pony",
      icon:'mdi-horseshoe',
      args: "--bin-name {FILENAME}",
      command:"ponyc {ARGS} < {FILENAME}.{EXT} && ./{FILENAME} 2>&1 | grep -v set_mempolicy",
      cli: null,
      errorRegEx: ".+?:(\\d+):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.ponylang.io',
      repo: 'https://github.com/ponylang/ponyc',
    },
    'Poly/ML':{
      desc: "Functional, Statically-typed, ML-based, Strongly-typed, High-level",
      highlighting:"sml",
      ext: 'sml',
      kor: '폴리',
      template:"polyml",
      icon:'mdi-function-variant',
      args: '-o {FILENAME}',
      command:"polyc {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.sml:(\\d+): error: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.polyml.org',
      repo: 'https://github.com/polyml/polyml',
    },
    'Poplog':{
      desc: "Multi-paradigm, AI-focused, Prolog-based, Lisp-based, Interactive",
      highlighting:"poplog",
      ext: 'p',
      kor: '팝로그 - Pop-11',
      template:"poplog",
      icon:'mdi-party-popper',
      command:"popc {ARGS} {FILENAME}.{EXT}",
      cli: "popc {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.cs.bham.ac.uk/research/projects/poplog/freepoplog.html',
      repo: 'https://github.com/hebisch/poplog',
    },
    'PostScript (GhotScript)':{
      desc: "Page description, Graphics-oriented, Procedural, Stack-based, Printable",
      highlighting:"postscript",
      ext: 'ps',
      kor: '포스트스크립트',
      template:"postscript",
      icon:'mdi-ghost',
      args: '-dBATCH -dNOPAUSE -sDEVICE=png16m',
      command:"gs {ARGS} -sOutputFile={FILENAME}.png {FILENAME}.{EXT} && imshow {FILENAME}.png",
      cli: "gs",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.ghostscript.com/',
      repo: 'https://www.ghostscript.com/releases/gsdnld.html',
    },
    'PostgreSQL':{
      desc: "Relational, SQL-based, Open-source, Extensible, High-performance",
      highlighting:"pgsql",
      ext: 'sql',
      kor: '포스트그레SQL',
      template:"pgsql",
      icon:'mdi-elephant',
      args: '-H',
      command:"ps -ef | grep postgresql | grep -v grep > /dev/null || (echo 'Starting postgresql...' && (sudo service postgresql start > /dev/null))\npsql {ARGS} -f {FILENAME}.{EXT} > {FILENAME}.html && imshow {FILENAME}.html",
      cli: "ps -ef | grep postgresql | grep -v grep > /dev/null || (echo 'Starting postgresql...' && (sudo service postgresql start > /dev/null))\npsql",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.postgresql.org',
      repo: 'https://www.postgresql.org/download',
    },
    'Potion':{
      desc: "Object-oriented, Functional, Lightweight, Minimalistic, Dynamic",
      highlighting:"potion",
      ext: 'potion',
      kor: '포션',
      template:"potion",
      icon:'mdi-bottle-tonic-plus-outline',
      command:"potion {ARGS} {FILENAME}.{EXT}",
      cli: "potion {ARGS}",
      errorRegEx: ".+?:(\\d+):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://groups.google.com/group/potion-lang',
      repo: 'https://github.com/perl11/potion',
    },
    'PowerShell':{
      desc: "Task automation, scripting, configuration management",
      highlighting:"powershell",
      ext: 'ps',
      kor: '파워셸',
      template:"powershell",
      icon:'mdi-powershell',
      command:"pwsh {ARGS} {FILENAME}.{EXT}",
      cli: "pwsh {ARGS}",
      errorRegEx: ".*?(\\d+) \\|(.*\r\n)(.*? \\|(.*\r\n))+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/PowerShell',
      repo: 'https://github.com/PowerShell/PowerShell',
    },
    'Praat':{
      desc: "Phonetics-focused, Scripting, Analytical, Data-driven, Specialized",
      highlighting:"praat",
      ext: 'praat',
      kor: '프라트',
      template:"praat",
      icon:'mdi-ear-hearing',
      args: '--run',
      command:"praat {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Error: .+\r\nScript line (\\d+) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.fon.hum.uva.nl/praat',
      repo: 'https://www.fon.hum.uva.nl/praat/download_linux.html',
    },
    'Pro*C':{
      desc: "Embedded SQL, C integration language",
      highlighting:"c",
      ext: 'pc',
      kor: '프로C',
      template:"proc",
      icon:'mdi-alpha-p-box',
      args: 'include=.',
      command:"proc {ARGS} {FILENAME}.{EXT} && gcc -I$ORACLE_HOME/sdk/include -L$ORACLE_HOME -lclntsh -o {FILENAME} {FILENAME}.c -lm -lclntsh && ./{FILENAME}",
      cli: null,
      errorRegEx: "Error at line (\\d+), .*",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Pro*C',
      repo: 'https://www.oracle.com/database/technologies/instant-client/precompiler-downloads.html',
    },
    'Processing':{
      desc: "Visual, interactive, artistic programming language",
      highlighting:"processing",
      ext: 'pde',
      kor: '프로세싱',
      template:"processing",
      icon:'mdi-format-paint',
      args: "--sketch=$PWD/{FILENAME} --run",
      command:"mkdir -p {FILENAME} && mv -f {FILENAME}.{EXT} {FILENAME} && xvfb-run processing-java {ARGS}",
      cli: null,
      defaultFilename: 'MainProc',
      errorRegEx: ".+:(\\d+):\\d+:\\d+:\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://processing.org',
      repo: 'https://github.com/processing/processing',
    },
    'Prolog GNU':{
      desc: "Logic programming, declarative, rule-based language",
      highlighting:"prolog",
      ext: 'pl',
      kor: '프롤로그 gplc',
      template:"prolog",
      icon:'mdi-alpha-p-circle-outline',
      command:"gplc {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: "gprolog",
      //errorRegEx: ".+:\r\n    .+ line (\\d+)(.*)",
      errorRegEx: ".+?\\.pl:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.gprolog.org',
      repo: 'https://sourceforge.net/projects/gprolog/files',
    },
    'Prolog SWI':{
      desc: "Logic programming, declarative, rule-based language",
      highlighting:"prolog",
      ext: 'pl',
      kor: '프롤로그 swipl',
      template:"swipl",
      icon:'mdi-alpha-p-circle-outline',
      command:"swipl {ARGS} {FILENAME}.{EXT}",
      cli: "swipl {ARGS}",
      //errorRegEx: ".+:\r\n    .+ line (\\d+)(.*)",
      errorRegEx: ".+?\\.pl:(\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.swi-prolog.org',
      repo: 'https://www.swi-prolog.org/download',
    },
    'PROMELA - Spin':{
      desc: "Model-checking, Concurrent, Formal, Declarative, Verification",
      highlighting:"promela",
      ext: 'pml',
      kor: '프로멜라 - 스핀',
      template:"promela",
      icon:'mdi-axis-z-rotate-clockwise',
      command:"spin {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*?: .*\r\n.+?-->.+?:(\\d+):(\\d+):",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://spinroot.com',
      repo: 'https://github.com/nimble-code/Spin',
    },
    'PROSE':{
      desc: "Pattern-based, Programming, Transformation, High-level, Tool-oriented",
      highlighting:"prose",
      ext: 'pal',
      kor: '프로즈',
      template:"prose",
      icon:'mdi-file-document-edit-outline',
      command:"/opt/prose/bin/prism {ARGS} {FILENAME}.{EXT} && /opt/prose/bin/prose {FILENAME}.pro",
      cli: null,
      errorRegEx: ".+?: .+?\\.pal line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sourceforge.net/projects/prose',
      repo: 'https://sourceforge.net/projects/prose/files',
    },
    'PSL':{
      desc: "Embeddable, scripting",
      highlighting:"psl",
      ext: 'psl',
      kor: 'PSL',
      template:"psl",
      icon:'mdi-script-text-play-outline',
      command:"PSL {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "error .+?\\.psl (\\d+),\\d+: (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://twitter.com/P9Silica',
      repo: 'https://github.com/Silica/PSL',
    },
    'Pug':{
      desc: "HTML templating, Concise, Dynamic, Lightweight, Easy-to-read",
      highlighting:"pug",
      ext: 'pug',
      kor: '퍼그',
      template:"pug",
      icon:'mdi-dog',
      command:"pug {ARGS} {FILENAME}.{EXT} && imshow {FILENAME}.html",
      cli: null,
      errorRegEx: ".+?: .+?:(\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://pugjs.org',
      repo: 'https://github.com/pugjs/pug',
    },
    'Pure':{
      desc: "Functional, Lazy, Statically-typed, Mathematical, High-level",
      highlighting:"pure",
      ext: 'pure',
      kor: '퓨어',
      template:"pure",
      icon:'mdi-water',
      command:"pure {ARGS} {FILENAME}.{EXT}",
      cli: "pure {ARGS}",
      errorRegEx: ".+?. line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://agraef.github.io/pure-lang',
      repo: 'https://github.com/agraef/pure-lang',
    },
    'Pupp':{
      desc: "Scripting, Lightweight, Concise, Minimalistic, Dynamic",
      highlighting:"pupp",
      ext: 'pup',
      kor: '퍼프',
      template:"pupp",
      icon:'mdi-home-outline',
      command:"pupp {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? at line: (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/marxn',
      repo: 'https://github.com/marxn/pupp',
    },
    'Puppet':{
      desc: "Configuration management, Declarative, Automation, Infrastructure, Scalable",
      highlighting:"puppet",
      ext: 'puppet',
      kor: '퍼핏',
      template:"puppet",
      icon:'mdi-dolly',
      args: "apply",
      command:"puppet {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\(file: .+?\\.puppet, line: (\\d+), (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://puppet.com',
      repo: 'https://github.com/puppetlabs/puppet',
    },
    'Pyret':{
      desc: "Educational, Functional, Declarative, High-level, Student-friendly",
      highlighting:"pyret",
      ext: 'arr',
      kor: '파이릿',
      template:"pyret",
      icon:'mdi-skull-crossbones',
      args: "-q -e none",
      command:"pyret {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?. line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://pyret.org',
      repo: 'https://github.com/brownplt/pyret-lang',
    },
    'Q':{
      desc: "Concise, array-oriented, query language",
      highlighting:"q",
      ext: 'q',
      kor: '큐 - qlang',
      template:"q",
      icon:'mdi-alpha-q-box',
      command:"q {ARGS} -s {FILENAME}.{EXT}",
      cli: "q {ARGS}",
      errorRegEx: "! File .+?\\.q, line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://q-lang.sourceforge.net',
      repo: 'https://q-lang.sourceforge.net/download.html',
    },
    'Qi':{
      desc: "Lightweight, fast, Chinese",
      highlighting:"qi",
      ext: 'qi',
      kor: '치',
      template:"qi",
      icon:'mdi-ideogram-cjk',
      command:"qi {ARGS} {FILENAME}.{EXT}",
      cli: "qi {ARGS}",
      errorRegEx: ".*?\r\n【行 (\\d+)】在 脚本",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://anonymousaaardvark.github.io/qi',
      repo: 'https://github.com/AnonymousAAArdvark/qi',
    },
    'QBE':{
      desc: "Compiler backend, user-friendly, performant",
      highlighting:"qbe",
      ext: 'qbe',
      kor: '큐비이',
      template:"qbe",
      icon:'mdi-cube-outline',
      command:"qbe {ARGS} -s {FILENAME}.{EXT}",
      cli: "qbe {ARGS}",
      errorRegEx: "",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://c9x.me/compile',
      repo: 'https://c9x.me/compile/code.html',
    },
    'Qore':{
      desc: "Dynamic, Scripting, Multi-paradigm, Cross-platform, Embedded",
      highlighting:"qore",
      ext: 'q',
      kor: '코어',
      template:"qore",
      icon:'mdi-alpha-q',
      command:"/opt/qore/bin/qore {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? at .+?\\.q:(\\d+)(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://qore.org',
      repo: 'https://github.com/qorelanguage/qore',
    },
    'QuickBASIC':{
      desc: "Simple, procedural, beginner-friendly language",
      highlighting:"vb",
      ext: 'bas',
      kor: '퀵베이식 - dos 16bit',
      template:"quickbasic",
      icon:'mdi-weather-windy',
      command: "unix2dos -q {FILENAME}.{EXT} && ln -sfT /opt/dos/qb45 qb45 && emu2 qb45/bc.exe {ARGS} {FILENAME}.{EXT} {FILENAME}.obj NUL -- 'PATH=C:\\qb45' && emu2 qb45/link.exe {ARGS} {FILENAME}.obj,{FILENAME}.exe,NUL,qb45\\\\brun45.lib,NUL && emu2 {FILENAME}.exe -- 'PATH=C:\\qb45'",
      cli: "ln -sfT /opt/dos/qb45 qb45 && emu2 qb45/qb.exe -- 'PATH=C:\\qb45'",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/QuickBASIC',
      repo: 'https://winworldpc.com/product/quickbasic/45',
    },
    'QuickJS':{
      desc: "Small and embeddable Javascript engine, fast interpreter",
      highlighting:"javascript1",
      ext: 'js',
      kor: '퀵JS',
      template:"quickjs",
      icon:'mdi-language-javascript',
      command:"qjs {ARGS} {FILENAME}.{EXT}",
      cli: "qjs {ARGS}",
      errorRegEx: ".+?\r\n +? at .+?\\.js:(\\d+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://bellard.org/quickjs',
      repo: 'https://winworldpc.com/product/quickbasic/45',
    },
    'Quirrel':{
      desc: "Based on Squirrel, inspired by Python, Lexical scoping",
      highlighting:"squirrel",
      ext: 'nut',
      kor: '퀴럴',
      template:"quirrel",
      icon:'mdi-nut',
      command:"sq {ARGS} {FILENAME}.{EXT}",
      cli: 'sq',
      errorRegEx: ".+? line = \\((\\d+)\\) column = \\(\\d+\\) : (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://quirrel.io',
      repo: 'https://github.com/GaijinEntertainment/quirrel',
    },
    'R':{
      desc: "Statistical computing, data analysis language",
      highlighting:"r",
      ext: 'R',
      template:"r",
      kor: 'R',
      icon:'mdi-language-r',
      command:"R {ARGS} --slave -q -f {FILENAME}.{EXT}",
      cli: 'R',
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_R),
      dockerImage: '',
      homepage: 'https://www.r-project.org',
      repo: 'https://cran.r-project.org/mirrors.html',
    },
    'Racket':{
      desc: "Functional, Lisp-based, Language-oriented, Macro-enabled, Educational",
      highlighting:"lisp",
      ext: 'rkt',
      kor: '래킷',
      template:"racket",
      icon:'mdi-lambda',
      command:"racket {ARGS} {FILENAME}.{EXT}",
      cli: "racket {ARGS}",
      errorRegEx: ".*:(\\d+):\\d+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://racket-lang.org',
      repo: 'https://github.com/racket/racket',
    },
    'Raku':{
      desc: "Expressive, multi-paradigm, dynamic language",
      highlighting:"raku",
      ext: 'raku',
      kor: '라쿠',
      template:"raku",
      icon:'mdi-ev-plug-tesla',
      command:"rakudo {ARGS} {FILENAME}.{EXT}",
      cli: "rakudo {ARGS}",
      errorRegEx: ".*?at (?:line )?(?:.+?:)?(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://raku.org',
      repo: 'https://github.com/rakudo/rakudo',
    },
    'Rapira':{
      desc: "Educational, Russian, Procedural, Simple, Interactive",
      highlighting:"rapira",
      ext: 'rap',
      kor: '라피라',
      template:"rapira",
      icon:'mdi-book-open-variant',
      command:"/opt/rapira/rapira {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\*\\*\\*Error .+\r\n.+?Line number: (\\d+)\r\n.+\r\n( +.+\r\n)*",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://code.google.com/archive/p/rerap',
      repo: 'https://github.com/freeduke33/rerap2',
    },
    'Rapture':{
      desc: "Concise, High-level, Functional, Lightweight, Turing-complete",
      highlighting:"rapira",
      ext: 'rap',
      kor: '랩처',
      template:"rapture",
      icon:'mdi-book-open-variant',
      command:"/opt/rapture/bin/rapture {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/rapture/bin/rapture",
      errorRegEx: "Error @ line (\\d+):\\d+\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.ironrealms.com/rapture/manual/files/Overview-txt.html',
      repo: 'https://github.com/mattmikolay/rapture',
    },
    'Ratfor':{
      desc: "Preprocessor, C-like, Macro-based, Structured, Legacy",
      highlighting:"fortran",
      ext: 'ratfor',
      kor: '랫포',
      template:"ratfor",
      icon:'mdi-mouse-variant',
      command:"ratfor {ARGS} {FILENAME}.{EXT} | tail +2 > {FILENAME}.f90 && gfortran -o {FILENAME} {FILENAME}.f90 && ./{FILENAME}",
      cli: "ratfor {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Ratfor',
      repo: 'https://github.com/slattarini/ratfor',
    },
    'Ravi':{
      desc: "Dialect of Lua with limited optional static typing and features",
      highlighting:"ravi",
      ext: 'ravi',
      kor: '라비',
      template:"ravi",
      icon:'mdi-weather-sunny',
      command:"ravi {ARGS} {FILENAME}.{EXT}",
      cli: "ravi {ARGS}",
      errorRegEx: 'ravi: .+?\\.ravi:(\\d+): (.+)',
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'http://ravilang.github.io',
      repo: 'https://github.com/dibyendumajumdar/ravi',
    },
    'Rebol':{
      desc: "Concise, Lightweight, Data-centric, Dynamic, Scripting",
      highlighting:"rebol",
      ext: 'r',
      kor: '리볼',
      template:"rebol",
      icon:'mdi-alpha-r-box',
      args: "--quiet",
      command:"rebol {ARGS} -s {FILENAME}.{EXT}",
      cli: "rebol {ARGS}",
      errorRegEx: "\\*\\* .+?: .+\r\n\\*\\* .+?\\(line (\\d+)\\) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.rebol.com',
      repo: 'https://github.com/moliad/rebol-lang',
    },
    'Red':{
      desc: "Cross-platform, High-level, Lightweight, Declarative, Functional",
      highlighting:"red",
      ext: 'red',
      kor: '레드',
      template:"red",
      icon:'mdi-alpha-r',
      command:"xvfb-run red {ARGS} {FILENAME}.{EXT}",
      cli: "xvfb-run red {ARGS}",
      errorRegEx: ".+?: \\(line (\\d+)\\)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.red-lang.org',
      repo: 'https://github.com/red/red',
    },
    'Redis':{
      desc: "In-memory, key-value store, database",
      highlighting:"redis",
      ext: 'redis',
      kor: '레디스',
      template:"redis",
      icon:'mdi-cube-outline',
      command:"ps -ef | grep redis-server | grep -v grep > /dev/null || (echo 'Starting redis...' && (sudo -u redis redis-server /etc/redis/redis.conf > /dev/null))\ncat {FILENAME}.{EXT} | redis-cli {ARGS}",
      cli: "ps -ef | grep redis-server | grep -v grep > /dev/null || (echo 'Starting redis...' && (sudo -u redis redis-server /etc/redis/redis.conf > /dev/null))\nredis-cli {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://redis.io',
      repo: 'https://github.com/redis/redis',
    },
    'REXX (Reginia)':{
      desc: "Scripting, Procedural, Easy-to-learn, IBM, Text-processing",
      highlighting:"rexx",
      ext: 'rex',
      kor: '렉스',
      template:"rexx",
      icon:'mdi-cards-spade',
      command:"rexx {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? \\\".+?\\\", line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://regina-rexx.sourceforge.io',
      repo: 'https://sourceforge.net/projects/regina-rexx/files',
    },
    'RhaiScript':{
      desc: "Embedded scripting, evaluation engine",
      highlighting:"rhaiscript",
      ext: 'rhai',
      kor: '라이스크립트',
      template:"rhaiscript",
      icon:'mdi-barley',
      command:"rhai-run {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "(\\d+): .*",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://crates.io/crates/rhai',
      repo: 'https://github.com/rhaiscript/rhai',
    },
    'RIGAL':{
      desc: "Declarative, Rule-based, Logic programming, High-level, Data-oriented",
      highlighting:"rigal",
      ext: 'rig',
      kor: '리갈',
      template:"rigal",
      icon:'mdi-bottle-wine',
      command:"rm -f {FILENAME}.rsc && /opt/rigal/bin/rc {ARGS} {FILENAME} && [ -f {FILENAME}.rsc ] && /opt/rigal/bin/ic {FILENAME}",
      cli: null,
      errorRegEx: " Error in file .+?\\.rig\r\n Line= +?(\\d+)\r\n (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://git.kylepdavis.com/KylePDavis/RIGAL',
      repo: 'http://git.kylepdavis.com/KylePDavis/RIGAL.git',
    },
    'ric-script':{
      desc: "Resembles Python and Javascript",
      highlighting:"ric",
      ext: 'ric',
      kor: 'RIC스크립트',
      template:"ric",
      icon:'mdi-script',
      command:"ric {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.ric:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://github.com/Ricardicus',
      repo: 'https://github.com/Ricardicus/ric-script',
    },
    'Ring':{
      desc: "High-level, general-purpose, scripting language",
      highlighting:"ring",
      ext: 'ring',
      kor: '링',
      template:"ring",
      icon:'mdi-ring',
      command:"ring {ARGS} {FILENAME}.{EXT}",
      cli: "ringrepl",
      errorRegEx: "(?:In )?Line \\(?(\\d+)\\)? (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://ring-lang.github.io',
      repo: 'https://github.com/ring-lang/ring',
    },
    'Rix':{
      desc: "Concise, Functional, Minimalistic, High-level, Experimental",
      highlighting:"rix",
      ext: 'rix',
      kor: '릭스',
      template:"rix",
      icon:'mdi-car-shift-pattern',
      args: '-q -o {FILENAME}',
      command:"export RIX_HOME=/opt/rix\nrixc {ARGS} {FILENAME}.{EXT} && sh {FILENAME}.sh 2> /dev/null && ./{FILENAME}.out",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/riolet',
      repo: 'https://github.com/riolet/rix',
    },
    'Rk':{
      desc: "Concise, Functional, Minimalistic, Turing-complete, Experimental",
      highlighting:"rk",
      ext: 'rk',
      kor: 'Rk',
      template:"rk",
      icon:'mdi-skate',
      command:"rk {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://rk.tryitonline.net',
      repo: 'https://github.com/aaronryank/rk-lang',
    },
    'Roc':{
      desc: "Fast, friendly, functional",
      highlighting:"roc",
      ext: 'roc',
      kor: '락',
      template:"roc",
      icon:'mdi-bird',
      args: 'dev',
      command:"roc {ARGS} {FILENAME}.{EXT}",
      cli: "roc repl",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: "ryusatgat/roc",
      homepage: 'https://www.roc-lang.org',
      repo: 'https://github.com/roc-lang/roc',
    },
    'Rockstar':{
      desc: "Esoteric, Minimalistic, Humor-oriented, Turing-complete, Syntax-driven",
      highlighting:"rockstar",
      ext: 'rock',
      kor: '락스타',
      template:"rockstar",
      icon:'mdi-microphone',
      command:"rockstar {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://codewithrockstar.com',
      repo: 'https://github.com/RockstarLang/rockstar',
    },
    'Roff':{
      desc: "Text-formatting, procedural, simple, macro-based, legacy",
      highlighting:"roff",
      ext: 'roff',
      kor: '로프 - groff/troff/nroff',
      template:"roff",
      icon:'mdi-bottle-tonic',
      args: '{FILENAME}.{EXT} -Tpdf > {FILENAME}.pdf && imshow {FILENAME}.pdf',
      command:"groff {ARGS}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gnu.org/software/groff',
      repo: 'https://ftp.gnu.org/gnu/groff',
    },
    'RPL/2':{
      desc: "Stack-based, procedural, numeric, high-level, concise",
      highlighting:"rpl",
      ext: 'rpl',
      kor: 'RPL/2',
      template:"rpl",
      icon:'mdi-code-tags',
      command:"rpl {ARGS} {FILENAME}.{EXT}",
      cli: "rpl -i",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.rpl2.net',
      repo: 'http://www.rpl2.net/telechargements.php',
    },
    'Rubi':{
      desc: "Concise, dynamic, object-oriented, modern, high-level",
      highlighting:"rubi",
      ext: 'rb',
      kor: '루비',
      template:"rubi",
      icon:'mdi-language-ruby',
      command:"rubi {ARGS} {FILENAME}.{EXT}",
      cli: "rubi",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/sysprog21',
      repo: 'https://github.com/sysprog21/rubi'
    },
    'Ruby':{
      desc: "Dynamic, object-oriented, expressive language",
      highlighting:"ruby",
      ext: 'rb',
      kor: '루비',
      template:"ruby",
      icon:'mdi-language-ruby',
      command:"ruby {ARGS} {FILENAME}.{EXT}",
      cli: "irb",
      errorRegEx: ".+?\\.rb:(\\d+): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/ruby",
      homepage: 'https://www.ruby-lang.org',
      repo: 'https://github.com/ruby/ruby',
    },
    'Rutger':{
      desc: "Functional, high-level, concise, expressive, modern",
      highlighting:"rutger",
      ext: 'rtg',
      kor: '럿거',
      template:"rutger",
      icon:'mdi-zodiac-taurus',
      command:"/opt/rutger/rutger {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/cairdcoinheringaahing',
      repo: 'https://github.com/cairdcoinheringaahing/Rutger',
    },
    'Rust':{
      desc: "Systems, safe, concurrent, performant, modern",
      highlighting:"rust",
      ext: 'rs',
      kor: '러스트',
      template:"rust",
      icon:'mdi-language-rust',
      command:"rustc {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?: .+?\r\n.+?:(\\d+):(.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/rust",
      homepage: 'https://www.rust-lang.org',
      repo: 'https://github.com/rust-lang/rust',
    },
    'RustPython':{
      desc: "Python-3 Interpreter written in Rust",
      highlighting:"python",
      ext: 'py',
      kor: '러스트파이썬',
      template:"rustpython",
      icon:'mdi-language-python',
      command:"rustpython {ARGS} {FILENAME}.{EXT}",
      cli: 'rustpython {ARGS}',
      errorRegEx: ".+?\\.py\", line (\\d+)(?:.*?\r\n)+?(.*?Error: .*)",
      keyBindings: null,
      dockerImage: "ryusatgat/rust",
      homepage: 'https://rustpython.github.io',
      repo: 'https://github.com/RustPython/RustPython',
    },
    'RustScript':{
      desc: "Demonstration of the 80/20 rule, based on ease of implementation",
      highlighting:"rustscript",
      ext: 'rsc',
      kor: '러스트스크립트',
      template:"rustscript",
      icon:'mdi-pin',
      command:"rustscript {ARGS} {FILENAME}.{EXT}",
      cli: 'rustscript',
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://mkhan45.github.io/RustScript2',
      repo: 'https://github.com/mkhan45/RustScript2',
    },
    'Rune':{
      desc: "embeddable, dynamic, for Rust",
      highlighting:"rune",
      ext: 'rn',
      kor: '룬',
      template:"rune",
      icon:'mdi-zodiac-aries',
      command:"rune run {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: '.+?\r\n.+?\\.rn:(\\d+):(\\d+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://rune-rs.github.io',
      repo: 'https://github.com/rune-rs/rune',
    },
    'S-Lang':{
      desc: "Scripting, lightweight, extensible, dynamic, embedded",
      highlighting:"slang",
      ext: 'slang',
      kor: 'S-랭',
      template:"slang",
      icon:'mdi-alpha-s',
      command:"slsh {ARGS} {FILENAME}.{EXT}",
      cli: "slsh {ARGS}",
      errorRegEx: ".+?\\.slang:(\\d+):(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.jedsoft.org/slang',
      repo: 'https://www.jedsoft.org/releases/slang',
    },
    'Sac':{
      desc: "Single-Assignment C, array programming language, high performance",
      highlighting:"sac",
      ext: 'sac',
      kor: '색',
      template:"sac",
      icon:'mdi-sigma',
      command:"sac2c {ARGS} {FILENAME}.{EXT} -o {FILENAME} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.sac:(\\d+):\\d+: error:\r\n(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/sac",
      homepage: 'https://www.sac-home.org',
      repo: 'https://gitlab.sac-home.org/sac-group/sac2c',
    },
    'Sacalon':{
      desc: "Optimal, maintainable, reliable, and efficient, rebranded from Hascal",
      highlighting:"sacalon",
      ext: 'sa',
      kor: '사칼론',
      template:"sacalon",
      icon:'mdi-fire',
      args: 'run',
      command:"/opt/sacalon/sacalon {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*?Error.*? : .+?:(\\d+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://sacalon.github.io',
      repo: 'https://github.com/sacalon/sacalon',
    },
    'Sage':{
      desc: "Portable, expressive, intuitive",
      highlighting:"sage",
      ext: 'sg',
      kor: '세이지',
      template:"sage",
      icon:'mdi-grass',
      args: '-t run',
      command:"sage {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? error: \\d+: at line (\\d+), .+",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://adam-mcdaniel.net/sage-website',
      repo: 'https://github.com/adam-mcdaniel/sage',
    },
    'Sass':{
      desc: "CSS-based, preprocessor, dynamic, modular, expressive",
      highlighting:"css",
      ext: 'sass',
      kor: 'Sass',
      template:"sass",
      icon:'mdi-sass',
      command:"sass {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.sass (\\d+):\\d+(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sass-lang.com',
      repo: 'https://github.com/sass/sass',
    },
    'Saturnus':{
      desc: "Lua targeted, easy-to-learn, fast compilation times, scripting",
      highlighting:"saturnus",
      ext: 'saturn',
      kor: '사투르누스',
      template:"saturnus",
      icon:'mdi-earth',
      command:"saturnus {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.sass (\\d+):\\d+(.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/sigmasoldi3r',
      repo: 'https://github.com/sigmasoldi3r/saturnus',
    },
    'Saffire':{
      desc: "Dynamic, object-oriented, concise, high-level, expressive",
      highlighting:"saffire",
      ext: 'sf',
      kor: '사파이어',
      template:"saffire",
      icon:'mdi-diamond',
      command:"/opt/saffire/bin/saffire {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/saffire/bin/saffire repl",
      errorRegEx: ".+\\.sf on line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.saffire-lang.org',
      repo: 'https://github.com/saffire/saffire',
    },
    'Sather':{
      desc: "Object-oriented, statically-typed, modular, efficient, concise",
      highlighting:"sather",
      ext: 'sa',
      kor: '새더',
      template:"sather",
      icon:'mdi-tower-fire',
      command:"SATHER_HOME=/opt/sather sacomp -o {FILENAME} {FILENAME}.{EXT} 2> build.log && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.sa:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.gnu.org/software/sather',
      repo: 'https://ftp.gnu.org/gnu/sather',
    },
    'Saurus':{
      desc: "Concise, high-level, expressive, modern, flexible",
      highlighting:"saurus",
      ext: 'su',
      kor: '사우루스',
      template:"saurus",
      icon:'mdi-bone',
      command:"saurus {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.su ?: ?(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/andreas-jonsson',
      repo: 'https://github.com/andreas-jonsson/saurus-dynamic',
    },
    'SBCL':{
      desc: "High-performance, dynamic, Lisp-based, compiled, extensible",
      highlighting:"lisp",
      ext: 'lisp',
      kor: '스틸뱅크커먼리스프(Steel Bank Common Lisp)',
      template:"sbcl",
      icon:'mdi-wheel-barrow',
      command:"sbcl {ARGS} --script {FILENAME}.{EXT}",
      cli: "sbcl {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.sbcl.org/',
      repo: 'https://sourceforge.net/projects/sbcl',
    },
    'Scala2':{
      desc: "Type-safe, functional, object-oriented, expressive, concise",
      highlighting:"scala",
      ext: 'scala',
      kor: '스칼라2',
      template:"scala",
      icon:'mdi-database',
      command:"scala {ARGS} {FILENAME}.{EXT}",
      cli: "scala {ARGS}",
      errorRegEx: ".+?:(\\d+): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.scala-lang.org',
      repo: 'https://github.com/scala/scala',
    },
    'Scala3':{
      desc: "Modern, type-safe, functional, object-oriented, expressive",
      highlighting:"scala",
      ext: 'scala',
      kor: '스칼라3',
      template:"scala3",
      icon:'mdi-database',
      command:"/opt/scala3/bin/scala {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/scala3/bin/scala {ARGS}",
      errorRegEx: ".+?: .+?:(\\d+):(\\d+) -+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://dotty.epfl.ch',
      repo: 'https://github.com/scala/scala3',
    },
    'Scheme(Chez)':{
      desc: "Functional, minimalist, dialect, recursive, expressive",
      highlighting:"scheme",
      ext: 'scm',
      kor: '스킴 - chezscheme',
      template:"chezscheme",
      icon:'mdi-lambda',
      args: '--silent',
      command:"chezscheme --script {FILENAME}.{EXT}",
      cli: "chezscheme",
      errorRegEx: ".+? at line (\\d+), (.+?\\.scm)",
      keyBindings: null,
      dockerImage: "ryusatgat/scheme",
      homepage: 'https://www.scheme.com',
      repo: 'https://github.com/cisco/ChezScheme',
    },
    'Scheme(Gambit)':{
      desc: "Functional, minimalist, dialect, recursive, expressive",
      highlighting:"scheme",
      ext: 'scm',
      kor: '스킴 - gambit',
      template:"gambit",
      icon:'mdi-lambda',
      command:"gsi {ARGS} {FILENAME}.{EXT}",
      cli: "gsi",
      dockerImage: "ryusatgat/scheme",
      homepage: 'https://gambitscheme.org',
      repo: 'https://github.com/gambit/gambit',
    },
    'Scheme(MIT)':{
      desc: "Functional, minimalist, dialect, recursive, expressive",
      highlighting:"scheme",
      ext: 'scm',
      kor: '스킴 - mit-scheme',
      template:"scheme",
      icon:'mdi-lambda',
      args: '--silent',
      command:"mit-scheme {ARGS} < {FILENAME}.{EXT}",
      cli: "mit-scheme --interactive",
      dockerImage: "ryusatgat/scheme",
      homepage: 'https://www.gnu.org/software/mit-scheme',
      repo: 'https://ftp.gnu.org/gnu/mit-scheme',
    },
    'Scilab':{
      desc: "Numerical, scientific, high-level, matrix-based, open-source",
      highlighting:"scilab",
      ext: 'sce',
      kor: '싸이랩',
      template:"scilab",
      icon:'mdi-grid',
      args: "-f {FILENAME}.{EXT}",
      command:"scilab-cli {ARGS} -quit",
      cli: "scilab-cli",
      errorRegEx: "at line .+? (\\d+) of .+\r\n(?:.*\r\n)+?(Error:.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.scilab.org',
      repo: 'https://github.com/scilab/scilab',
    },
    'Scopes':{
      desc: "Expression-based, statically typed, general purpose",
      highlighting:"scopes",
      ext: 'sc',
      kor: '스콥스',
      template:"scopes",
      icon:'mdi-telescope',
      command:"scopes {ARGS} {FILENAME}.{EXT}",
      cli: "scopes",
      errorRegEx: ".+?\\.sc:(\\d+):\\d+:(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/scopes",
      homepage: 'http://scopes.rocks',
      repo: 'https://hg.sr.ht/~duangle/scopes',
    },
    'Scriptol':{
      desc: "Scripting, high-level, easy-to-learn, portable, expressive",
      highlighting:"scriptol",
      ext: 'sol',
      kor: '스크립톨',
      template:"scriptol",
      icon:'mdi-script-outline',
      args: '-q',
      command:"/opt/scriptol/solp {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.sol.L?(\\d+)(:\\d+)?: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.scriptol.com',
      repo: 'https://github.com/Scriptol/JavaScript-Compiler',
    },
    'SCSS':{
      desc: "CSS-based, preprocessor, modular, dynamic, flexible",
      highlighting:"css",
      ext: 'scss',
      kor: 'SCSS',
      template:"scss",
      icon:'mdi-sass',
      command:"sass {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.scss (\\d+):\\d+(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sass-lang.com',
      repo: 'https://github.com/sass/sass',
    },
    'Seed7':{
      desc: "High-level, multi-paradigm, extensible, statically-typed, modular",
      highlighting:"seed7",
      ext: 'sd7',
      kor: '씨드7',
      template:"seed7",
      icon:'mdi-label-outline',
      args: '-q -l /opt/seed7/lib',
      command:"s7 {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\*\\*\\* .+?\\.sd7\\((\\d+)\\):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://seed7.sourceforge.net',
      repo: 'https://github.com/ThomasMertes/seed7',
    },
    'Self':{
      desc: "Prototype-based, object-oriented, dynamic, expressive, flexible",
      highlighting:"self",
      ext: 'self',
      kor: '셀프',
      template:"self",
      icon:'mdi-weather-sunny',
      args: '-s /opt/self/core.snap',
      command:"Self {ARGS} < {FILENAME}.{EXT} 2> /dev/null",
      cli: "Self {ARGS}",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://selflanguage.org',
      repo: 'https://github.com/russellallen/self',
    },
    'Senegal':{
      desc: "Declarative, high-level, concise, modular, functional",
      highlighting:"senegal",
      ext: 'sgl',
      kor: '세네갈',
      template:"senegal",
      icon:'mdi-star-box-outline',
      args: null,
      command:"senegal {ARGS} {FILENAME}.{EXT}",
      cli: "senegal",
      errorRegEx: "< Error on line (\\d+) > (.+\r\n.+?in: .+\\.sgl)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://lang-senegal.web.app',
      repo: 'https://github.com/SenegalLang/Senegal',
    },
    'Seq':{
      desc: "Functional, concise, high-level, modular, expressive",
      highlighting:"seq",
      ext: 'seq',
      kor: 'Seq',
      template:"seq",
      icon:'mdi-view-sequential-outline',
      args: 'run',
      command:"seqc {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://seq-lang.org',
      repo: 'https://github.com/seq-lang/seq',
    },
    'SETL':{
      desc: "Set-oriented, high-level, declarative, mathematical, expressive",
      highlighting:"setl",
      ext: 'setl',
      kor: 'SETL',
      template:"setl",
      icon:'mdi-set-split',
      args: null,
      command:"/opt/setl/setl {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\*\\*\\*  Error.+? line (\\d+) .+?\\.setl(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://setl.org/setl',
      repo: 'https://github.com/davidjbacon/SETL',
    },
    'SGScript':{
      desc: "C-like syntax, highly optimized, register-based VM",
      highlighting:"sgscript",
      ext: 'sgs',
      kor: 'SG스크립트',
      template:"sgscript",
      icon:'mdi-cube-outline',
      args: '-c',
      command:"sgsc {ARGS} {FILENAME}.{EXT}>/dev/null && sgsvm {FILENAME}.sgc",
      cli: null,
      errorRegEx: "Error: \\[line (\\d+)\\] (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'http://www.sgscript.org',
      repo: 'https://github.com/archo5/sgscript',
    },
    'Shen':{
      desc: "Functional, logic-based, dynamic, expressive, concise",
      highlighting:"shen",
      ext: 'shen',
      kor: '셴',
      template:"shen",
      icon:'mdi-head-snowflake-outline',
      command:"/opt/shen/bin/shen script {FILENAME}.{EXT} {ARGS}",
      cli: '/opt/shen/bin/shen repl',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://shenlanguage.org',
      repo: 'https://github.com/Shen-Language/shen-sources',
    },
    'Shiika':{
      desc: "Statically-typed, object-oriented, written in Rust",
      highlighting:"shiika",
      ext: 'sk',
      kor: '쉬이카',
      template:"shiika",
      icon:'mdi-hair-dryer-outline',
      args: 'run',
      command:"shiika {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: '.*?Error: .+?\r\n.+?\\.sk:(\\d+):\\d+.+',
      keyBindings: null,
      dockerImage: "ryusatgat/clang",
      homepage: 'https://github.com/shiika-lang',
      repo: 'https://github.com/shiika-lang/shiika',
    },
    'ShnooTalk':{
      desc: "Implemented in C++, LLVM",
      highlighting:"shnootalk",
      ext: 'shtk',
      kor: '쉬누톡',
      template:"shnootalk",
      icon:'mdi-baby-bottle-outline',
      args: "-c",
      command:"shtkc {FILENAME}.{EXT} {ARGS} && gcc -o {FILENAME} _obj/{FILENAME}_shtk.o && ./{FILENAME}",
      cli: null,
      errorRegEx: "ERROR in Line (\\d+) Col \\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/shnootalk",
      homepage: 'https://github.com/RainingComputers',
      repo: 'https://github.com/RainingComputers/ShnooTalk',
    },
    'Simula':{
      desc: "Object-oriented, class-based, simulation, high-level, pioneering",
      highlighting:"simula",
      ext: 'sim',
      kor: '시뮬라 - cim',
      template:"simula",
      icon:'mdi-sigma',
      args:'--cflags=-w -q',
      command:"cim {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: '.+?\\.sim\\", line (\\d+): (.+)',
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.freshports.org/lang/cim',
      repo: 'https://github.com/freebsd/freebsd-ports/tree/main/lang/cim',
    },
    'Sink':{
      desc: "Stream-based, minimalistic, functional, efficient, concise",
      highlighting:"sink",
      ext: 'sink',
      kor: '싱크',
      template:"sink",
      icon:'mdi-shuriken',
      command:"sink {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+\\.sink:(\\d+):\\d+:(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/velipso',
      repo: 'https://github.com/velipso/sink',
    },
    'Sisal':{
      desc: "Functional, dataflow-oriented, high-performance, declarative, concise",
      highlighting:"sisal",
      ext: 'sis',
      kor: '사이잘',
      template:"sisal",
      icon:'mdi-fruit-pineapple',
      command:"sisalc {ARGS} -o {FILENAME} {FILENAME}.{EXT} 2> /dev/null && echo \"NIL\" | ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.sis:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://kestrel.nmt.edu/~raymond/software/sisal/sisal.xhtml',
      repo: 'https://github.com/qram9/sisal',
    },
    'Skew':{
      desc: "Web-first, cross-platform, readable, easy to integrate",
      highlighting:" skew",
      ext: 'sk',
      kor: '스큐',
      template:"skew",
      icon:'mdi-chart-bar',
      args: '--release',
      command:"skewc {FILENAME}.{EXT} --output-file={FILENAME}.js {ARGS} && node {FILENAME}.js",
      errorRegEx: ".+?\\.sk:(\\d+):\\d:(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://evanw.github.io/skew-lang.org',
      repo: 'https://github.com/evanw/skew',
    },
    'SkyLark':{
      desc: "Scripting, dynamic, high-level, extensible, modern",
      highlighting:"starlark",
      ext: 'sky',
      kor: '스카이라크',
      template:"skylark",
      icon:'mdi-airplane-takeoff',
      command:"skylark {ARGS} {FILENAME}.{EXT}",
      cli: 'skylark {ARGS}',
      errorRegEx: ".+?\\.sky:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://bazel.build/rules/language',
      repo: 'https://github.com/bazelbuild/starlark',
    },
    'Slash':{
      desc: "Scripting, dynamic, flexible, high-level, modular",
      highlighting:"slash",
      ext: 'sl',
      kor: '슬래시',
      template:"slash",
      icon:'mdi-knife-military',
      command:"/opt/slash/bin/slash-cli {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/slash/bin/slash-cli",
      errorRegEx: ".+?: .+\r\n  at .+? in .+?\\.sl, line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://slash-lang.org',
      repo: 'https://github.com/slash-lang/slash',
    },
    'Sleep':{
      desc: "Minimalistic, esoteric, stack-based, concise, experimental",
      highlighting:"sleep",
      ext: 'sl',
      kor: '슬립',
      template:"sleep",
      icon:'mdi-power-sleep',
      command:"sleep.sh {ARGS} {FILENAME}.{EXT}",
      cli: "sleep.sh {ARGS}",
      errorRegEx: "(?:Warning|Error): .+? at (?:line|.+\\.sl)[\\ :](\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://sleep.dashnine.org',
      repo: 'http://sleep.dashnine.org/download.html',
    },
    'Slogan':{
      desc: "Declarative, high-level, concise, modular, functional",
      highlighting:"slogan",
      ext: 'sn',
      kor: '슬로건',
      template:"slogan",
      icon:'mdi-subtitles-outline',
      args: '-e',
      command:"/opt/slogan/slogan {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/slogan/slogan",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://schemer.in/slogan',
      repo: 'https://github.com/vijaymathew/slogan',
    },
    'SmallBasic':{
      desc: "Fast and easy to learn",
      highlighting:"smallbasic",
      ext: 'bas',
      kor: '스몰베이식',
      template:"smallbasic",
      icon:'mdi-teddy-bear',
      command:"sbasic {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: '\\* .+?:(\\d+) \\*',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://smallbasic.github.io',
      repo: 'https://github.com/smallbasic/SmallBASIC',
    },
    'Smalltalk':{
      desc: "Object-oriented, dynamically-typed, messaging language",
      highlighting:"smalltalk",
      ext: 'st',
      kor: '스몰토크',
      template:"smalltalk",
      icon:'mdi-alpha-s-circle-outline',
      command:"gst {ARGS} {FILENAME}.{EXT}",
      cli: "gst {ARGS}",
      errorRegEx: ".+?:(\\d+): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Smalltalk',
      repo: 'https://github.com/janvrany/gst',
    },
    'Smile':{
      desc: "Concise, functional, educational language",
      highlighting:"smile",
      ext: 'sm',
      kor: '스마일',
      template:"smile",
      icon:'mdi-emoticon-outline',
      command:"/opt/smile/bin/smile {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/smile/bin/smile {ARGS}",
      errorRegEx: ".+?\\.sm:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.smile.dev',
      repo: 'https://github.com/seanofw/smile',
    },
    'SML/NJ':{
      desc: "Functional, statically-typed, modular language",
      highlighting:"sml",
      ext: 'sml',
      kor: 'Standard ML',
      template:"sml",
      icon:'mdi-function-variant',
      command:"sml {ARGS} < {FILENAME}.{EXT}",
      cli: "sml {ARGS}",
      errorRegEx: ".+?:(\\d+)\\.\\d+(\\ Error|-\\d+\\.\\d+ \\w+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.smlnj.org',
      repo: 'https://github.com/smlnj/smlnj',
    },
    'Snobol4':{
      desc: "Pattern-oriented, text-processing, procedural, dynamic, legacy",
      highlighting:"snobol",
      ext: 'sno',
      kor: '스노볼4',
      template:"snobol4",
      icon:'mdi-file-document-multiple-outline',
      command:"/opt/snobol4/bin/snobol4 {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/snobol4/bin/snobol4",
      errorRegEx: ".+\\.sno:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sourceforge.net/projects/snobol4',
      repo: 'https://sourceforge.net/projects/snobol4/files',
    },
    'Snobol4(spitbol)':{
      desc: "Pattern-oriented, text-processing, procedural, dynamic, legacy",
      highlighting:"snobol",
      ext: 'sno',
      kor: '스노볼4 - spitbol',
      template:"spitbol",
      icon:'mdi-file-document-multiple-outline',
      command:"spitbol {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\((\\d+(?:,\\d+)?)\\) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/spitbol/spitbol-docs',
      repo: 'https://github.com/spitbol/x64',
    },
    'SoftScript':{
      desc: "Scripting, flexible, dynamic, high-level, extensible",
      highlighting:"softscript",
      ext: 'ss',
      kor: '소프트스크립트',
      template:"softscript",
      icon:'mdi-chart-ppf',
      command:"softscript  {ARGS} {FILENAME}.{EXT}",
      cli: "softscript",
      errorRegEx: "Line (\\d+) in .+?\\.ss\r\nError: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/been-jamming/SoftScript/wiki',
      repo: 'https://github.com/been-jamming/SoftScript',
    },
    'Sol':{
      desc: "Scripting, lightweight, re-entrant, multi-user runtime",
      highlighting:"sol",
      ext: 'sol',
      kor: '솔',
      template:"sol",
      icon:'mdi-music',
      args: 'r',
      command:"sol {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\r\n\\(at lines (\\d+)-\\d+, cols \\d+-\\d+\\)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://sol-lang.github.io',
      repo: 'https://github.com/sol-lang/sol',
    },
    'Solidity':{
      desc: "Smart contract, blockchain, Ethereum-based language",
      highlighting:"solidity",
      ext: 'sol',
      kor: '솔리디티',
      template:"solidity",
      icon:'mdi-ethereum',
      args: '--overwrite --bin --abi',
      command:"solc -o . {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*?: .*\r\n.+?-->.+?:(\\d+):(\\d+):",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://soliditylang.org',
      repo: 'https://github.com/ethereum/solidity',
    },
    'SOM':{
      desc: "Object-oriented, prototype-based, dynamic, modular, expressive",
      highlighting:"som",
      ext: 'som',
      kor: '솜',
      template:"som",
      icon:'mdi-pipe-disconnected',
      args: '-cp /opt/som/core-lib:.',
      command: "SOM++ {ARGS} {FILENAME}",
      cli: "SOM++ {ARGS}",
      errorRegEx: "Error: .+? in line (\\d+)\\. .+:(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://som-st.github.io',
      repo: 'https://github.com/SOM-st/SOM',
    },
    'Sophia':{
      desc: "Smart contract, blockchain, functional language",
      highlighting:"aes",
      ext: 'aes',
      kor: '소피아',
      template:"sophia",
      icon:'mdi-all-inclusive',
      command: "aesophia_cli {ARGS} {FILENAME}.{EXT}",
      errorRegEx: ".*? at line (\\d+), col \\d+:\r\n(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://docs.aeternity.com/aesophia',
      repo: 'https://github.com/aeternity/aesophia',
    },
    'SourcePawn':{
      desc: "Smart contract, blockchain, functional language",
      highlighting:"sourcepawn",
      ext: 'sp',
      kor: '소스폰',
      template:"sourcepawn",
      icon:'mdi-chess-pawn',
      args: '-v 0 -i /opt/sourcepawn/include',
      command: "spcomp {ARGS} {FILENAME}.{EXT} && spshell {FILENAME}.smx",
      errorRegEx: ".+?\\.sp\\((\\d+)\\) : error \\d+: (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/sourcepawn',
      homepage: 'https://github.com/alliedmodders',
      repo: 'https://github.com/alliedmodders/sourcepawn',
    },
    'Sparkling':{
      desc: "Dynamic, high-level, expressive, modular, modern",
      highlighting:"sparkling",
      ext: 'spn',
      kor: '스파클링',
      template:"sparkling",
      icon:'mdi-star-four-points',
      command: "spn {ARGS} {FILENAME}.{EXT}",
      cli: "spn",
      errorRegEx: ".+? line (?:\x1B\\[\\d+m)?(\\d+).*? char .*?\\d+.*?:? (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://h2co3.github.io',
      repo: 'https://github.com/H2CO3/Sparkling',
    },
    'SPL':{
      desc: "Systems Programming Language, known as SPL/3000",
      highlighting:"spl",
      ext: 'spl',
      kor: 'SPL',
      template:"spl",
      icon:'mdi-puzzle',
      command:"spl {ARGS} {FILENAME}.{EXT} > {FILENAME}.c && gcc -o {FILENAME} {FILENAME}.c -lm && ./{FILENAME}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Systems_Programming_Language',
      repo: 'https://github.com/marcinlimanski/Compiler-for-SPL-language',
    },
    'Spow':{
      desc: "Scripting, parallel, object-oriented language",
      highlighting:"spow",
      ext: 'awl',
      kor: '스포',
      template:"spow",
      icon:'mdi-sunglasses',
      command:"spow {ARGS} {FILENAME}.{EXT}",
      cli: 'spow',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/Gioyik',
      repo: 'https://github.com/Gioyik/Spow',
    },
    'Squirrel':{
      desc: "Lightweight, embeddable, scripting language",
      highlighting:"squirrel",
      ext: 'nut',
      kor: '스퀴럴',
      template:"squirrel",
      icon:'mdi-nut',
      command:"sq {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? line = \\((\\d+)\\) column = \\(\\d+\\) : (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://squirrel-lang.org',
      repo: 'https://github.com/albertodemichelis/squirrel',
    },
    'SQLite':{
      desc: "Embedded, lightweight, self-contained database",
      highlighting:"sql",
      ext: 'sql',
      kor: 'SQLite',
      template:"sql",
      icon:'mdi-alpha-s-box-outline',
      command:"echo '<table border=1>' > {FILENAME}.html && sqlite3 {ARGS} -header -html {FILENAME}.db < {FILENAME}.{EXT} >> {FILENAME}.html && echo '</table>'  >> {FILENAME}.html && imshow {FILENAME}.html",
      cli: "sqlite3 {ARGS}",
      keyBindings: monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_M, monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_S),
      dockerImage: '',
      homepage: 'https://www.sqlite.org',
      repo: 'https://github.com/sqlite/sqlite',
    },
    'SQL Server':{
      desc: "Relational database management system",
      highlighting:"sql",
      ext: 'sql',
      kor: 'SQL 서버 - sqlcmd',
      template:"sqlserver",
      icon:'mdi-microsoft-access',
      args: '-S localhost -U SA -P 5ae01a8580f4ed83d7f7e110d268c75b -l 30 -s "|"',
      command:"ps -ef | grep sqlservr | grep -v grep > /dev/null || (echo 'Starting SQL Server...' && (sudo /opt/mssql/bin/sqlservr --accept-eula > /dev/null &))\nsqlcmd -b {ARGS} -i {FILENAME}.{EXT} -o {FILENAME}.out && (sed -e 's/\\(.*\\)/|\\1|/' {FILENAME}.out | grep -v '||' | grep -v 'rows affected' > {FILENAME}.md && imshow {FILENAME}.md) || cat main.out",
      cli: "ps -ef | grep sqlservr | grep -v grep > /dev/null || (echo 'Starting SQL Server...' && (sudo /opt/mssql/bin/sqlservr --accept-eula > /dev/null &))\nsqlcmd {ARGS}",
      errorRegEx: ".+, Line (\\d+)\r\n(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/ms",
      homepage: 'https://en.wikipedia.org/wiki/Microsoft_SQL_Server',
      repo: 'https://www.microsoft.com/en-us/sql-server/sql-server-downloads',
    },
    'Stanza':{
      desc: "Concise, modular, expressive, high-level, flexible",
      highlighting:"stanza",
      ext: 'stanza',
      kor: '스탠자',
      template:"stanza",
      icon:'mdi-format-columns',
      command:"ln -sfT /opt/stanza/.stanza ~/.stanza\n/opt/stanza/stanza {ARGS} {FILENAME}.{EXT} -o {FILENAME} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+\\.stanza:(\\d+)\\.\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://lbstanza.org',
      repo: 'https://github.com/StanzaOrg/lbstanza',
    },
    'StarLark':{
      desc: "Configuration, extensible, scripting, high-level, declarative",
      highlighting:"starlark",
      ext: 'star',
      kor: '스타라크',
      template:"starlark",
      icon:'mdi-star-face',
      command:"starlark {ARGS} {FILENAME}.{EXT}",
      cli: 'starlark {ARGS}',
      errorRegEx: ".+?\\.star:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/bazelbuild/starlark/blob/master/users.md',
      repo: 'https://github.com/bazelbuild/starlark',
    },
    'StaticScript':{
      desc: "Statically typed, syntactically like TypeScript",
      highlighting:"typescript1",
      ext: 'ss',
      kor: '스태틱스크립트',
      template:"staticscript",
      icon:'mdi-cheese',
      command:"staticscript {ARGS} {FILENAME}.{EXT} && ./{FILENAME}-out.exe",
      cli: null,
      errorRegEx: 'line (\\d+):\\d+ (.+)',
      keyBindings: null,
      dockerImage: 'ryusatgat/clang',
      homepage: 'https://staticscript.org',
      repo: 'https://github.com/StaticScript/StaticScript',
    },
    'Steel':{
      desc: "Functional, minimalist, dialect, recursive, expressive",
      highlighting:"scheme",
      ext: 'scm',
      kor: '스틸',
      template:"steel",
      icon:'mdi-lambda',
      args: null,
      command:"steel {ARGS} {FILENAME}.{EXT}",
      cli: "steel",
      errorRegEx: ".+?\r\n.+?\\.scm:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/scheme",
      homepage: 'https://mattwparas.github.io/steel/book',
      repo: 'https://github.com/mattwparas/steel',
    },
    'Stork':{
      desc: "Small footprint scripting language",
      highlighting:"stork",
      ext: 'stork',
      kor: '스토크',
      template:"stork",
      icon:'mdi-bird',
      command:"stork {FILENAME}.{EXT} {FILENAME}",
      cli: null,
      errorRegEx: '^\\((\\d+)\\) (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/esrrhs',
      repo: 'https://github.com/esrrhs/fake',
    },
    'Storm':{
      desc: "Concurrent, distributed, high-performance, scalable, resilient",
      highlighting:"storm",
      ext: 'storm',
      kor: '스톰',
      template:"storm",
      icon:'mdi-weather-tornado',
      command:"/opt/storm/bin/stormcompiler {FILENAME}.{EXT} {FILENAME} && /opt/storm/bin/stormrun {FILENAME}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://stormscript.dev',
      repo: 'https://github.com/stormprograms/Storm',
    },
    'StormScript':{
      desc: "Scripting, dynamic, flexible, high-level, extensible",
      highlighting:"stormscript",
      ext: 'sts',
      kor: '스톰스크립트',
      template:"stormscript",
      icon:'mdi-weather-tornado',
      command:"stormscript {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://stormscript.dev',
      repo: 'https://github.com/stormprograms/StormScript',
    },
    'Strand':{
      desc: "Concurrent, high-level, modular, functional, scalable",
      highlighting:"prolog",
      ext: 'st',
      kor: '스트랜드',
      template:"strand",
      icon:'mdi-shore',
      args: 'run',
      command:"/opt/strand/strand {ARGS} {FILENAME}.{EXT}",
      cli: '/opt/strand/strand',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.call-with-current-continuation.org/strand/strand.html',
      repo: 'https://github.com/ghosthamlet/strand',
    },
    'Streem':{
      desc: "Concurrent, stream processing, functional language",
      highlighting:"streem",
      ext: 'strm',
      kor: '스트림',
      template:"streem",
      icon:'mdi-view-stream-outline',
      command:"streem {ARGS} {FILENAME}.{EXT}",
      cli: 'streem',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/matz',
      repo: 'https://github.com/matz/streem',
    },
    'Strela':{
      desc: "Declarative, functional, high-level, expressive, modular",
      highlighting:"strela",
      ext: 'strela',
      kor: '스트렐라',
      template:"strela",
      icon:'mdi-watch',
      args: '--search /opt/strela',
      command:"strela {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.strela:(\\d+):\\d+ (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/sunverwerth',
      repo: 'https://github.com/sunverwerth/strela',
    },
    'SurgeScript':{
      desc: "Scripting, dynamic, flexible, high-level, extensible",
      highlighting:"surgescript",
      ext: 'ss',
      kor: '서지스크립트',
      template:"surgescript",
      icon:'mdi-shoe-print',
      command:"surgescript {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? on .+?\\.ss:(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://docs.opensurge2d.org',
      repo: 'https://github.com/alemart/surgescript',
    },
    'Swift':{
      desc: "Safe, modern, fast, general-purpose",
      highlighting:"swift",
      ext: 'swift',
      kor: '스위프트',
      template:"swift",
      icon:'mdi-language-swift',
      args: '-no-color-diagnostics',
      command:"swift {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*:(\\d+):\\d+: (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/swift",
      homepage: 'https://developer.apple.com/kr/swift',
      repo: 'https://github.com/swiftlang/swift',
    },
    'Syphon':{
      desc: "Community-Driven, fast performance, open-software, modern",
      highlighting:"syphon",
      ext: 'sy',
      kor: '사이폰',
      template:"syphon",
      icon:'mdi-water-pump',
      args: 'run',
      command:"syphon {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?\\.sy:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/syphon-lang',
      repo: 'https://github.com/syphon-lang/syphon',
    },
    'SZL':{
      desc: "Structured, high-level, simulation language",
      highlighting:"szl",
      ext: 'szl',
      kor: 'SZL',
      template:"szl",
      icon:'mdi-spotlight-beam',
      command:"szl {ARGS} {FILENAME}.{EXT}",
      cli: "szlsh",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://dimakrasner.com/szl',
      repo: 'https://github.com/dimkr/szl',
    },
    'Tamgu':{
      desc: "Dynamic, multi-paradigm, expressive, high-level, flexible",
      highlighting:"tamgu",
      ext: 'tmg',
      kor: '탐구',
      template:"tamgu",
      icon:'mdi-feature-search-outline',
      command:"/opt/tamgu/bin/tamgu {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/tamgu/bin/tamgu",
      errorRegEx: "Error line:(\\d+) (.*?)\\.tmg",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/naver',
      repo: 'https://github.com/naver/tamgu',
    },
    'Tamsin':{
      desc: "Functional, high-level, concise, modern, type-safe",
      highlighting:"tamsin",
      ext: 'tamsin',
      kor: '탐신',
      template:"tamsin",
      icon:'mdi-exit-run',
      command:"tamsin {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://catseye.tc/node/Tamsin',
      repo: 'https://github.com/catseye/Tamsin',
    },
    'Tea':{
      desc: "Concise, functional, high-level, expressive, modern",
      highlighting:"tea",
      ext: 'tea',
      kor: '티',
      template:"tea",
      icon:'mdi-tea',
      command:"ln -sfT /opt/tea tea && tea/bin/tea --init {FILENAME} && mv -f {FILENAME}.{EXT} {FILENAME}\ntea/bin/tea {FILENAME} && php-cgi -q {FILENAME}/dist/{FILENAME}.php > {FILENAME}.html && imshow {FILENAME}.html",
      cli: null,
      errorRegEx: ".+?:\r\n.+?\\.tea:(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://tea-lang.org',
      repo: 'https://github.com/emjun/tea-lang-vis',
    },
    'Teak':{
      desc: "Small scripting language to replace Unix shell scripts",
      highlighting:"teak",
      ext: 'teak',
      kor: '틱',
      template:"teak",
      icon:'mdi-tree-outline',
      command:"teak {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Error on line (\\d+) of .+?",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/nakst',
      repo: 'https://github.com/nakst/teak',
    },
    'TeaScript':{
      desc: "Concise, functional, high-level, expressive, modern",
      highlighting:"teascript",
      ext: 'tea',
      kor: '티스크립트',
      template: 'teascript',
      icon:'mdi-tea',
      command:"TeaScript {FILENAME}.{EXT}",
      cli: 'TeaScript',
      errorRegEx: "in line .*?m(\\d+).*?, column .*?m\\d+.*?:\r\n(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/teascript",
      homepage: 'https://tea-age.solutions/teascript',
      repo: 'https://github.com/Florian-Thake/TeaScript-Cpp-Library',
    },
    'Tengo':{
      desc: "Small, dynamic, fast, secure script language for Go",
      highlighting:"tengo",
      ext: 'tengo',
      kor: '텡고',
      template: 'tengo',
      icon:'mdi-language-go',
      command:"tengo {ARGS} {FILENAME}.{EXT}",
      cli: 'Tengo',
      errorRegEx: ".+?\r\n.+?\\.tengo:(\\d+):\\d+",
      keyBindings: null,
      dockerImage: "ryusatgat/go",
      homepage: 'https://tengolang.com',
      repo: 'https://github.com/d5/tengo',
    },
    'TeX':{
      desc: "Typesetting, document preparation system",
      highlighting:"tex",
      ext: 'tex',
      kor: '텍',
      template:"tex",
      icon:'mdi-newspaper-variant-outline',
      command:"tex {ARGS} {FILENAME}.{EXT} && dvipdfm {FILENAME}.dvi && imshow {FILENAME}.pdf",
      cli: null,
      errorRegEx: ".*\r+\n.*\r+\n.*\r+\n.* line (\\d+)(.*)?",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/TeX',
      repo: '',
    },
    'Tcl':{
      desc: "Scripting, extensible, embeddable language",
      highlighting:"tcl",
      ext: 'tcl',
      kor: '티클',
      template:"tcl",
      icon:'mdi-feather',
      command:"tclsh {ARGS} {FILENAME}.{EXT}",
      cli: "tclsh {ARGS}",
      errorRegEx: ".*\r+\n.*\r+\n.*\r+\n.* line (\\d+)(.*)?",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.tcl.tk',
      repo: 'https://github.com/tcltk/tcl',
    },
    'Tcsh':{
      desc: "Command-line, scripting, interactive, Unix-based, extensible",
      highlighting:"shell",
      ext: 'tcsh',
      kor: 'TC셸',
      template:"tcsh",
      icon:'mdi-emoticon-devil-outline',
      command:"chmod 755 {FILENAME}.{EXT} && tcsh {ARGS} ./{FILENAME}.{EXT}",
      cli: 'tcsh {ARGS}',
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.tcsh.org',
      repo: 'https://github.com/tcsh-org/tcsh',
    },
    'TerminalBasic':{
      desc: "Procedural, text-based, simple, interpreted, educational",
      highlighting:"vb",
      ext: 'bas',
      kor: '터미널베이식',
      template:"terminalbasic",
      icon:'mdi-chip',
      args: "-b",
      command:"/opt/terminalbasic/terminalbasic {ARGS} < {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "/opt/terminalbasic/terminalbasic",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://sourceforge.net/projects/terminal-basic',
      repo: 'https://github.com/terminal-basic-team/terminalbasic',
    },
    'Terra':{
      desc: "Declarative, infrastructure management language",
      highlighting:"terra",
      ext: 't',
      kor: '테라',
      template:"terra",
      icon:'mdi-creation',
      command:"terra {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+\\.t:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://terralang.org/',
      repo: 'https://github.com/terralang/terra',
    },
    'Terraform':{
      desc: "Infrastructure as code, provisioning tool",
      highlighting:"hcl",
      ext: 'tf',
      kor: '테라폼',
      template:"terraform",
      icon:'mdi-terraform',
      args: "-auto-approve",
      command:"terraform init && terraform apply {ARGS}",
      cli: null,
      errorRegEx: ".*\r+\n.*\r+\n.*\r+\n.* line (\\d+)(.*)?",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.terraform.io/',
      repo: 'https://github.com/hashicorp/terraform',
    },
    'TinyScript':{
      desc: "Scripting, designed for very tiny machines",
      highlighting:"tinyscript",
      ext: 'ts',
      kor: '타이니스크립트',
      template:"tinyscript",
      icon:'mdi-mini-sd',
      command:"tinyscript {ARGS} {FILENAME}.{EXT}",
      cli: 'tinyscript',
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://www.totalspectrum.ca',
      repo: 'https://github.com/totalspectrum/tinyscript',
    },
    'TIScript':{
      desc: "Scripting, dynamic, extensible, lightweight, high-level",
      highlighting:"javascript1",
      ext: 'tis',
      kor: 'TI스크립트',
      template:"tiscript",
      icon:'mdi-home',
      command:"wine /opt/tiscript/bin/tis.exe {ARGS} {FILENAME}.{EXT}",
      cli: 'wine /opt/tiscript/bin/tiscript.exe {ARGS}',
      errorRegEx: "Error: .*?\r\r\n\tat .+\\(.+?:(\\d+)\\)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/gfx',
      repo: 'https://github.com/gfx/tiscript',
    },
    'Tokay':{
      desc: "For ad-hoc parsing, text processing",
      highlighting:"tokay",
      ext: 'tok',
      kor: '토카이',
      template:"tokay",
      icon:'mdi-google-downasaur',
      command:"tokay {ARGS} {FILENAME}.{EXT}",
      cli: 'tokay',
      errorRegEx: "Line (\\d+), column \\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://tokay.dev',
      repo: 'https://github.com/tokay-lang/tokay',
    },
    'TotemScript':{
      desc: "Scripting, dynamic, extensible, modular, high-level",
      highlighting:"javascript1",
      ext: 'totem',
      kor: '토템스크립트',
      template:"totemscript",
      icon:'mdi-ev-plug-ccs1',
      args: '-f',
      command:"/opt/totemscript/TotemScriptCmd {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Script error: .+? on line (\\d+):\\d+(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://tdsmale.github.io/totemscript',
      repo: 'https://github.com/tdsmale/TotemScript',
    },
    'Toy':{
      desc: "Bytecode-intermediate embedded scripting",
      highlighting:"toy",
      ext: 'toy',
      kor: '토이',
      template:"toy",
      icon:'mdi-toy-brick',
      args: '-f {FILENAME}.{EXT}',
      command:"toy {ARGS}",
      cli: 'toy',
      errorRegEx: '.*?\\[Line (\\d+)\\] Error at (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://toylang.com',
      repo: 'https://github.com/Ratstail91/Toy',
    },
    'Tug':{
      desc: "Simple and neat syntax as well as minimal in terms of keywords and data types",
      highlighting:"tug",
      ext: 'tug',
      kor: '터그',
      template:"tug",
      icon:'mdi-ferry',
      args: 'run',
      command:'tug {ARGS} {FILENAME}.{EXT}',
      cli: 'tug',
      errorRegEx: ".+?\\.tug:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/tug',
      homepage: 'https://github.com/tuglang',
      repo: 'https://github.com/tuglang/tug',
    },
    'Tula':{
      desc: "Declarative, modular, high-level, concise, flexible",
      highlighting:"tula",
      ext: 'tula',
      kor: '툴라',
      template:"tula",
      icon:'mdi-emoticon-cool',
      args: "run",
      command:"tula {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*?(\\d+):\\d+: ERROR: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/tsoding',
      repo: 'https://github.com/tsoding/tula',
    },
    'Turbo Assembler':{
      desc: "Integrated, fast, assembly language compiler",
      highlighting:"tasm",
      ext: 'asm',
      kor: '터보어셈블러 - turbo assembler - dos 16bit',
      template:"tasm",
      icon:'mdi-car-turbocharger',
      command:"emu2 /opt/dos/tasm/tasm.exe {ARGS} {FILENAME}.{EXT} && emu2 /opt/dos/tasm/tlink.exe {FILENAME}.obj && emu2 {FILENAME}.exe",
      cli: null,
      errorRegEx: "\\*\\*(?:Error|Fatal)\\*\\* .+?\\.asm\\((\\d+)\\) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Turbo_Assembler',
      repo: '',
    },
    'Turbo C':{
      desc: "Integrated, fast, C development environment",
      highlighting:"cpp",
      ext: 'c',
      kor: '터보 C - dos 16bit',
      template:"tc",
      icon:'mdi-language-c',
      command:"unix2dos -q {FILENAME}.{EXT} && ln -sfT /opt/tc tc && emu2 tc/TCC.EXE {ARGS} {FILENAME}.{EXT} -- 'PATH=C:\\TC' && emu2 {FILENAME}.exe",
      cli: null,
      errorRegEx: ".*? (\\d+): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Turbo_C',
      repo: '',
    },
    'Turbo C++':{
      desc: "Compiled, object-oriented, efficient, legacy, integrated",
      highlighting:"cpp",
      ext: 'cpp',
      kor: '터보 C++ - dos 16bit',
      template:"tcpp",
      icon:'mdi-alpha-t-box-outline',
      command:"ln -sfT /opt/tcpp101 tc && emu2 tc/bin/tcc.exe {ARGS} {FILENAME}.{EXT} -- 'PATH=C:\\TC\\BIN' && emu2 {FILENAME}.exe",
               //ln -sf /opt/tcpp101 TC && emu2 TC/bin/tcc.exe  main.cpp -- 'PATH=C:\TC\BIN' && emu2 main.exe
      cli: null,
      errorRegEx: ".*? (\\d+): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Turbo_C%2B%2B',
      repo: '',
    },
    'Turbo Pascal':{
      desc: "Procedural, compiled, efficient, structured, legacy",
      highlighting:"pascal",
      ext: 'pas',
      kor: '터보 파스칼 - dos 16bit',
      template:"tp",
      icon:'mdi-content-save-outline',
      args: "'/TC:\\TP'",
      command:"ln -sfT /opt/tp TP && emu2 TP/tpc.exe {ARGS} {FILENAME}.{EXT} -- 'PATH=C:\\TP' && emu2 {FILENAME}.exe",
      cli: null,
      errorRegEx: ".*?\\((\\d+)\\): (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/Turbo_Pascal',
      repo: '',
    },
    'Turing':{
      desc: "Procedural, educational, high-level, simple, structured",
      highlighting:"turing",
      ext: 't',
      kor: '튜링',
      template:"turing",
      icon:'mdi-school',
      command:"/opt/turing/compiler {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Error on line (\\d+) \\[\\d+\\] of .*?: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://turinglang.org',
      repo: 'https://github.com/TuringLang/Turing.jl',
    },
    'ubasic':{
      desc: "Simple, procedural, interpreted, educational, lightweight",
      highlighting:"vb",
      ext: 'bas',
      kor: '마이크로베이식',
      template:"ubasic",
      icon:'mdi-square-small',
      command:"/opt/ubasic/ubx {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://dunkels.com/adam/ubasic',
      repo: 'https://github.com/adamdunkels/ubasic',
    },
    'uC++':{
      desc: "C++-based, modular, cross-platform, high-performance, expressive",
      highlighting:"cpp",
      ext: 'cc',
      kor: '마이크로 C++',
      template:"upp",
      icon:'mdi-microscope',
      command:"u++ {ARGS} -o {FILENAME} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.cc:(\\d+):\\d+:(.*)",
      keyBindings: null,
      dockerImage: 'ryusatgat/base',
      homepage: 'https://plg.uwaterloo.ca/usystem/uC++.html',
      repo: 'https://github.com/pabuhr/uCPP',
    },
    'Umka':{
      desc: "Procedural, lightweight, efficient, embedded, simple",
      highlighting:"umka",
      ext: 'um',
      kor: '움카',
      template:"umka",
      icon:'mdi-teddy-bear',
      command:"umka {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Error .+\\.um \\((\\d+), \\d+\\): (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/etc',
      homepage: 'https://vtereshkov.github.io/umka-lang',
      repo: 'https://github.com/vtereshkov/umka-lang',
    },
    'Umple':{
      desc: "Model-oriented, code generation, UML-based language",
      highlighting:"umple",
      ext: 'ump',
      kor: '움플레',
      template:"umple",
      icon:'mdi-window-maximize',
      args: '-q {FILENAME}.{EXT} && javac {FILENAME}.java && java -cp . {FILENAME}',
      command:"/opt/umple/umple {ARGS}",
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://cruise.umple.org/umple',
      repo: 'https://github.com/umple/umple',
    },
    'uclang':{
      desc: "Type-safe, modern, concise, expressive, high-level",
      highlighting:"uclang",
      ext: 'ucl',
      kor: 'uc랭',
      template:"uclang",
      icon:'mdi-sign-pole',
      command:"/opt/uclang/bin/uclang {ARGS} {FILENAME}.{EXT}",
      cli: null,
      defaultFilename: 'Main',
      errorRegEx: ".+? in file: \".+?\\.ucl\" on line: (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/izuzanak',
      repo: 'https://github.com/izuzanak/uclang',
    },
    'Unicon':{
      desc: "Extended, high-level, data-oriented language",
      highlighting:"icon",
      ext: 'icn',
      kor: '유니콘',
      template:"unicon",
      icon:'mdi-sign-pole',
      command:"unicon {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.icn:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.unicon.org',
      repo: 'https://github.com/uniconproject/unicon',
    },
    'Ursa':{
      desc: "Systems programming, low-level, type-safe language",
      highlighting:"ursa",
      ext: 'u',
      kor: '우르사',
      template:"ursa",
      icon:'mdi-pinwheel',
      command:"ursa {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://ursalang.github.io/',
      repo: 'https://github.com/ursalang/ursa',
    },
    'V':{
      desc: "Minimalistic, statically-typed, compiled, fast, simple",
      highlighting:"v",
      ext: 'v',
      kor: 'V언어',
      template:"v",
      icon:'mdi-alpha-v-circle-outline',
      command:"v {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: 'v {ARGS}',
      errorRegEx: ".+?:(\\d+):\\d+:(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://vlang.io',
      repo: 'https://github.com/vlang/v',
    },
    'Vala':{
      desc: "Object-oriented, type-safe, modern, concise, high-level",
      highlighting:"vala",
      ext: 'vala',
      kor: '발라',
      template:"vala",
      icon:'mdi-alpha-v-circle',
      command:"valac {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?:(\\d+).\\d+-\\d+\\.\\d+:(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://vala.dev',
      repo: 'https://gitlab.gnome.org/GNOME/vala',
    },
    'Verilog':{
      desc: "Hardware-oriented, procedural, descriptive, efficient, concise",
      highlighting:"verilog",
      ext: 'v',
      kor: '베릴로그',
      template:"verilog",
      icon:'mdi-vector-point',
      args: '-o {FILENAME}',
      command:"iverilog {ARGS} {FILENAME}.{EXT} && vvp {FILENAME}",
      cli: null,
      errorRegEx: ".+?:(\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://steveicarus.github.io/iverilog',
      repo: 'https://github.com/steveicarus/iverilog',
    },
    'VHDL':{
      desc: "Hardware-oriented, descriptive, concurrent, precise, digital",
      highlighting:"vhdl",
      ext: 'vhdl',
      kor: 'VHDL',
      template:"vhdl",
      icon:'mdi-electric-switch',
      command:"ghdl -a {ARGS} {FILENAME}.{EXT} && ghdl -e {FILENAME} && ghdl -r {FILENAME}",
      cli: null,
      errorRegEx: ".+?:(\\d+):\\d+:(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://ghdl.free.fr',
      repo: 'https://github.com/ghdl/ghdl',
    },
    'Victim':{
      desc: "Dynamically typed interpreted scripting",
      highlighting:"victim",
      ext: 'v',
      kor: '빅팀',
      template:"victim",
      icon:'mdi-alpha-v',
      command:"victim {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\(line (\\d+), column \\d+\\):\r\n(.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/Sekomer',
      repo: 'https://github.com/Sekomer/Victim',
    },
    'Vim Script':{
      desc: "Text-based, scripting, extensible, lightweight, editor-focused",
      highlighting:"vim",
      ext: 'vim',
      kor: '빔스크립트',
      template:"vim",
      icon:'mdi-alpha-v-box',
      command:'vim -c ":so %" {ARGS} {FILENAME}.{EXT}',
      cli: "vim",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.vim.org',
      repo: 'https://github.com/vim/vim',
    },
    'Virgil':{
      desc: "Object-oriented, statically-typed, modular, high-level, expressive",
      highlighting:"virgil",
      ext: 'v3',
      kor: '베르길리우스',
      template:"virgil",
      icon:'mdi-zodiac-gemini',
      args: 'run',
      command:'/opt/virgil/bin/virgil {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+?\\.v3.*?@.*?(\\d+):(\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/titzer',
      repo: 'https://github.com/titzer/virgil',
    },
    'Wa':{
      desc: "General-purpose, designed for developing robustness and maintainability",
      highlighting:"wa",
      ext: 'wa',
      kor: '와',
      template:"wa",
      icon:'mdi-image-filter-hdr-outline',
      command:"wa {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: '.+?\\.wa:(\\d+):\\d+: (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/wa",
      homepage: 'https://wa-lang.github.io',
      repo: 'https://github.com/wa-lang/wa',
    },
    'WardScript':{
      desc: "Scripting, modular, high-level, dynamic, flexible",
      highlighting:"wardscript",
      ext: 'ward',
      kor: '와드스크립트',
      template:"wardscript",
      icon:'mdi-crosshairs-gps',
      command:"/opt/wardscript/bin/ward {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://luisalbizo.github.io/WardScript',
      repo: 'https://github.com/LuisAlbizo/WardScript',
    },
    'Wax':{
      desc: "Dynamic, flexible, scripting, high-level, modular",
      highlighting:"wax",
      ext: 'wax',
      kor: '왁스',
      template:"wax",
      icon:'mdi-octagram',
      args: '--silent --c {FILENAME}.c',
      command:"/opt/wax/bin/waxc {ARGS} {FILENAME}.{EXT} && make {FILENAME} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://waxc.netlify.app',
      repo: 'https://github.com/LingDong-/wax',
    },
    'Wenyan':{
      desc: "Ancient chinese",
      highlighting:"wenyan",
      ext: 'wy',
      kor: '문언(文言)',
      template:"wenyan",
      icon:'mdi-ideogram-cjk-variant',
      args: null,
      command: "wenyan {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "Line (\\d+), (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://wy-lang.org',
      repo: 'https://github.com/wenyan-lang/wenyan',
    },
    'Whitespace':{
      desc: "Esoteric, minimalistic, whitespace-based, stack-oriented, unconventional",
      highlighting:"whitespace",
      ext: 'ws',
      kor: '화이트스페이스',
      template:"whitespace",
      icon:'mdi-keyboard-space',
      command:"wspace {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      insertSpaces: false,
      homepage: 'https://esolangs.org/wiki/Whitespace',
      repo: 'https://github.com/Romejanic/Whitespace',
    },
    'Wisnia':{
      desc: "Fast, Small, old-fashioned approach, naive code generation",
      highlighting:"wisnia",
      ext: 'wsn',
      kor: '위즈나',
      template:"wisnia",
      icon:'mdi-school-outline',
      command:"wisnia {ARGS} {FILENAME}.{EXT} && ./a.out",
      cli: null,
      errorRegEx: '.+\\.wsn:(\\d+)',
      keyBindings: null,
      insertSpaces: false,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://belijzajac.dev/wisnialang-compiler-project',
      repo: 'https://github.com/belijzajac/WisniaLang',
    },
    'Wisp':{
      desc: "A lisp👽 written in C++",
      highlighting:"lisp",
      ext: 'lisp',
      kor: '위스프',
      template:"wisp",
      icon:'👻',
      command:"wisp {ARGS} {FILENAME}.{EXT}",
      cli: "wisp {ARGS}",
      errorRegEx: null, // not supported
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://github.com/adam-mcdaniel',
      repo: 'https://github.com/adam-mcdaniel/wisp',
    },
    'Wolfram Script':{
      desc: "Scriptable, mathematical, functional, symbolic, powerful",
      highlighting:"mathics",
      ext: 'wls',
      kor: '울프람스크립트/매스매티카',
      template:"mathics",
      icon:'mdi-math-integral-box',
      command:"mathics {ARGS} {FILENAME}.{EXT}",
      cli: "mathics {ARGS}",
      errorRegEx: "\\w+::\\w+: .+ \\(line (\\d+) of .*\\)(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.wolfram.com/wolframscript',
      repo: 'https://account.wolfram.com/products/downloads/wolframscript',
    },
    'World':{
      desc: "General-purpose, high-level, expressive, modular, versatile",
      highlighting:"world",
      ext: 'w',
      kor: '월드',
      template:"world",
      icon:'mdi-earth-box',
      command:"/opt/world/world {ARGS} {FILENAME}.{EXT}",
      cli: "/opt/world/world",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://world-lang.org',
      repo: 'https://github.com/Geomol/World',
    },
    'Wren':{
      desc: "Lightweight, scripting, high-performance, dynamic, modular",
      highlighting:"wren",
      ext: 'wren',
      kor: '렌',
      template:"wren",
      icon:'mdi-owl',
      command:"wren_cli {ARGS} {FILENAME}.{EXT}",
      cli: "wren_cli {ARGS}",
      errorRegEx: "\\[.+? line (\\d+)\\] (Error .+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://wren.io',
      repo: 'https://github.com/wren-lang/wren',
    },
    'Wu':{
      desc: "Minimalistic, dynamic, esoteric, concise, experimental",
      highlighting:"wu",
      ext: 'wu',
      kor: '우',
      template:"wu",
      icon:'mdi-eye-circle',
      command:"wu {ARGS} {FILENAME}.{EXT} && lua {FILENAME}.lua",
      cli: null,
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://wu-lang.gitbook.io/',
      repo: 'https://github.com/wu-lang/wu',
    },
    'Wyvern':{
      desc: "Statically-typed, functional, concise, expressive, modern",
      highlighting:"wyvern",
      ext: 'wyv',
      kor: '와이번',
      template:"wyvern",
      icon:'mdi-fire',
      command:"wyvern {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+? (?:at|on) line (\\d+) (column \\d+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://wyvernlang.github.io',
      repo: 'https://github.com/wyvernlang/wyvern',
    },
    'X10':{
      desc: "Concurrent, scalable, high-performance, distributed, modern",
      highlighting:"x10",
      ext: 'x10',
      kor: 'x10',
      template:"x10",
      icon:'mdi-numeric-10-box-multiple-outline',
      command:"x10c {ARGS} {FILENAME}.{EXT} && x10 {FILENAME}",
      cli: null,
      errorRegEx: ".+? (?:at|on) line (\\d+) (column \\d+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://x10-lang.org/',
      repo: 'https://github.com/x10-lang/x10',
    },
    'xlang':{
      desc: "Concise, modern, dynamic, flexible, efficient",
      highlighting:"c",
      ext: 'x',
      kor: 'x랭',
      template:"xlang",
      icon:'mdi-alpha-x-circle',
      command:"xlang {ARGS} {FILENAME}.{EXT} && ./a.out",
      cli: null,
      errorRegEx: ".+?\\.x:(\\d+):\\d+ (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/pritamzope',
      repo: 'https://github.com/pritamzope/xlang',
    },
    'XLisp':{
      desc: "Lisp-based, dynamic, extensible, high-level, expressive",
      highlighting:"lisp",
      ext: 'lsp',
      kor: 'X리스프',
      template:"xlisp",
      icon:'mdi-alpha-x-box',
      command:"xlisp {ARGS} < {FILENAME}.{EXT}",
      cli: "xlisp {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://en.wikipedia.org/wiki/XLISP',
      repo: 'https://github.com/dbetz/xlisp',
    },
    'Xion':{
      desc: "High-level, modular, expressive, dynamic, flexible",
      highlighting:"xion",
      ext: 'xn',
      kor: '시온 - Openxion',
      template:"xion",
      icon:'mdi-file-cabinet',
      command:"xion {ARGS} {FILENAME}.{EXT}",
      cli: "xion {ARGS}",
      errorRegEx: ".+? on line (\\d+) at character (\\d+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/kreativekorp/openxion/blob/master/README.md',
      repo: 'https://github.com/kreativekorp/openxion',
    },
    'XPL0':{
      desc: "Educational, procedural, simple, interpretive, minimalistic",
      highlighting:"xpl0",
      ext: 'xpl',
      kor: 'XPL0',
      template:"xpl0",
      icon:'mdi-alpha-x',
      command:"echo 'N' | xpl0 {ARGS} {FILENAME} && emu2 {FILENAME}.com",
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.xpl0.org',
      repo: '',
    },
    'XL':{
      desc: "Concise, high-level, modular, expressive, modern",
      highlighting:"xl",
      ext: 'xl',
      kor: 'XL',
      template:"xl",
      icon:'mdi-video-input-component',
      command:"/opt/xl/bin/xl {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+\\.xl:(\\d+):\\d+: (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://c3d.github.io/xl',
      repo: 'https://github.com/c3d/xl',
    },
    'Yacas':{
      desc: "Symbolic, algebraic, extensible, interactive, high-level",
      highlighting:"yacas",
      ext: 'us',
      kor: '야카스',
      template:"yacas",
      icon:'mdi-chart-bell-curve-cumulative',
      command:"yacas {ARGS} {FILENAME}.{EXT}",
      cli: "yacas {ARGS}",
      errorRegEx: ".+?\\.us\\((\\d+)\\) : (Error .+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://www.yacas.org',
      repo: 'https://github.com/grzegorzmazur/yacas',
    },
    'Yaksha':{
      desc: "Off-side rule syntax, YakshaList sublanguage",
      highlighting:"yaksha",
      ext: 'yaka',
      kor: '약샤',
      template:"yaksha",
      icon:'mdi-temple-buddhist',
      args: 'build -RS',
      command:'yaksha {ARGS} {FILENAME}.{EXT}',
      cli: 'yaksha lisp',
      errorRegEx: ".+?\\.yaka:(\\d+):\\d+ at (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/yaksha",
      homepage: 'https://yakshalang.github.io',
      repo: 'https://github.com/YakshaLang/Yaksha',
    },
    'YASL':{
      desc: "Scripting, Lightweight, Concise, Dynamic, Embedded",
      highlighting:"yasl",
      ext: 'yasl',
      kor: 'YASL',
      template:"yasl",
      icon:'mdi-alpha-y-circle-outline',
      command:'yasl {ARGS} {FILENAME}.{EXT}',
      cli: 'yasl',
      errorRegEx: ".+?: .+? \\(?line (\\d+)\\)?(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://yasl-lang.github.io/playground/interpreter.html',
      repo: 'https://github.com/yasl-lang/yasl',
    },
    'YAsm':{
      desc: "Assembler, low-level, efficient, minimalistic, precise",
      highlighting:"assembly",
      ext: 'asm',
      kor: 'Y어셈블리',
      template:"yasm",
      icon:'mdi-alpha-y-box-outline',
      args: '-f elf64',
      command:'yasm {ARGS} {FILENAME}.{EXT} && ld -s -o {FILENAME} {FILENAME}.o && ./{FILENAME}',
      cli: null,
      errorRegEx: ".*?:(\\d+): \\w+: (.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://yasm.tortall.net',
      repo: 'https://github.com/yasm/yasm',
    },
    'Yorick':{
      desc: "Numerical, interactive, scripting, high-level, extensible",
      highlighting:"yorick",
      ext: 'i',
      kor: '요릭',
      template:"yorick",
      icon:'mdi-skull-outline',
      command:"yorick {ARGS} < {FILENAME}.{EXT}",
      cli: "yorick {ARGS}",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://yorick.sourceforge.net',
      repo: 'https://github.com/LLNL/yorick',
    },
    'Yabasic':{
      desc: "Simple, procedural, interpreted, lightweight, educational",
      highlighting:"vb",
      ext: 'bas',
      kor: '야베이식',
      template:'yabasic',
      icon:'mdi-console',
      command:'yabasic {ARGS} {FILENAME}.{EXT}',
      cli: null,
      errorRegEx: ".+ line (\\d+).+\r\n(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.yabasic.de',
      repo: 'https://github.com/marcIhm/yabasic',
    },
    'Zang':{
      desc: "Dynamically typed, high level",
      highlighting:"zang",
      ext: 'zang',
      kor: '쟁',
      template:"zang",
      icon:'mdi-penguin',
      command:"zang {ARGS} {FILENAME}.{EXT}",
      cli: 'zang -repl',
      errorRegEx: ".+?\r\n.+?\\.zang, line (\\d+)",
      keyBindings: null,
      dockerImage: "ryusatgat/python",
      homepage: 'https://zanglanguage.wordpress.com',
      repo: 'https://github.com/cmspeedrunner/Zang',
    },
    'Zebra':{
      desc: "Concise, high-level, flexible, modular, expressive",
      highlighting:"zebra",
      ext: 'zbr',
      kor: '지브라',
      template:"zebra",
      icon:'mdi-reorder-vertical',
      command:"Zebra {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "\\[Line (\\d+)\\] (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/tbui468',
      repo: 'https://github.com/tbui468/zebra',
    },
    'Zenon':{
      desc: "Statically typed, inspired by C++",
      highlighting:"zenon",
      ext: 'znn',
      kor: '제논',
      template:"zenon",
      icon:'mdi-turtle',
      command:"zenon {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.znn: Line (\\d+), column \\d+: (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/base',
      homepage: 'https://zenon-lang.org',
      repo: 'https://github.com/miki151/zenon',
    },
    'ZetScript':{
      desc: "API that allows bind C++ code in script side",
      highlighting:"zetscript",
      ext: 'zs',
      kor: '제트스크립트',
      template:"zetscript",
      icon:'mdi-zend',
      args: '--no-execution-time',
      command:"zs {ARGS} {FILENAME}.{EXT}",
      cli: 'zs',
      errorRegEx: "\\[.+?\\.zs:(\\d+)\\] (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'http://zetscript.org',
      repo: 'https://github.com/jespa007/zetscript',
    },
    'zForth':{
      desc: " Forth environment combines the compiler with an interactive shell",
      highlighting:"forth",
      ext: 'zf',
      kor: '지포스',
      template:"zforth",
      icon:'mdi-bus-side',
      args: '-q /opt/zforth/forth/core.zf',
      command:"zforth -x {ARGS} {FILENAME}.{EXT}",
      cli: 'zforth {ARGS}',
      errorRegEx: '.+?\\.zf:(\\d+): (.+)',
      keyBindings: null,
      dockerImage: "ryusatgat/etc",
      homepage: 'https://sourceforge.net/projects/zforth',
      repo: 'https://github.com/zevv/zForth',
    },
    'Zig':{
      desc: "Low-level, statically-typed, performant, concise, safety-oriented",
      highlighting:"zig",
      ext: 'zig',
      kor: '지그',
      template:"zig",
      icon:'mdi-alpha-z-box-outline',
      command:"zig run {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?:(\\d+):\\d+:(.+: .+)",
      keyBindings: null,
      dockerImage: "ryusatgat/zig",
      homepage: 'https://ziglang.org',
      repo: 'https://github.com/ziglang/zig',
    },
    'Zimbu':{
      desc: "Statically-typed, efficient, modern, functional, expressive",
      highlighting:"zimbu",
      ext: 'zu',
      kor: '짐부',
      template:"zimbu",
      icon:'mdi-alpha-z-circle-outline',
      args: '{FILENAME}.{EXT} && gcc -o {FILENAME} {FILENAME}.c',
      command:"/opt/zimbu/zimbu {ARGS} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+\\.zu line (\\d+) (.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.zimbu.org',
      repo: 'https://github.com/bsed/zimbuw32',
    },
    'Zion':{
      desc: "High-level, expressive, modular, dynamic, flexible",
      highlighting:"zion",
      ext: 'zion',
      kor: '시온',
      template:"zion",
      icon:'mdi-book-cross',
      command:"export ZION_ROOT=/opt/zion\nzion {ARGS} {FILENAME}",
      cli: null,
      errorRegEx: ".+?\\.zion:(\\d+):\\d+(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/zionlang',
      repo: 'https://github.com/zionlang/zion',
    },
    'zkl':{
      desc: "Declarative, type-safe, high-level, concise, modular",
      highlighting:"zkl",
      ext: 'zkl',
      kor: 'zkl',
      template:"zkl",
      icon:'mdi-flower-outline',
      //args: '-o {FILENAME}',
      command:"runzkl {ARGS} {FILENAME}.{EXT}",
      cli: 'runzkl {ARGS}',
      errorRegEx: ".+?:Line (\\d+):(.+)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://www.zenkinetic.com',
      repo: 'http://www.zenkinetic.com/zklDownloads.html',
    },
    'zScript':{
      desc: "Script interpreter",
      highlighting:"zscript",
      ext: 'zs',
      kor: 'z스크립트',
      template:"zscript",
      icon:'🔱',
      //args: '-o {FILENAME}',
      command:"zScript {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: "from (\\d+) line \\d+ column, to \\d+ line \\d+ column, (.+)",
      keyBindings: null,
      dockerImage: 'ryusatgat/zscript',
      homepage: 'https://github.com/zccrs',
      repo: 'https://github.com/zccrs/zScript',
    },
    'Zx':{
      desc: "Tool for writing better scripts",
      highlighting:"javascript1",
      ext: 'mjs',
      kor: 'Zx',
      template:"zx",
      icon:'mdi-timer-sand-empty',
      command:"zx {ARGS} {FILENAME}.{EXT}",
      cli: 'xz --repl',
      errorRegEx: ".+?\\.mjs:(\\d+)\r\n.+\r\n.+\r\n\r\n(.+)\r\n",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://google.github.io/zx',
      repo: 'https://github.com/google/zx',
    },
    '4tH':{
      desc: "Isn't the only Forth compiler that runs on several systems, cannot be crashed",
      highlighting:"4th",
      ext: '4th',
      kor: '4tH',
      template:"4th",
      icon:'mdi-numeric-4',
      args: 'cx',
      command: "4th {ARGS} {FILENAME}.{EXT}",
      cli: "4tsh",
      errorRegEx: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://thebeez.home.xs4all.nl/4tH',
      repo: 'https://thebeez.home.xs4all.nl/4tH/download.html',
    },
    '8th':{
      desc: "Secure, robust, cross-platform, and fun",
      highlighting:"8th",
      ext: '8th',
      kor: '8th',
      template:"8th",
      icon:'mdi-numeric-8',
      command: "8th {ARGS} {FILENAME}.{EXT}",
      cli: "8th",
      errorRegEx: ".+: at line (\\d+) .+? in .+?\\.8th",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://8th-dev.com',
      repo: 'https://8th-dev.com/order.html',
    },
    '11l':{
      desc: "Concise, functional, high-level language",
      highlighting:"11l",
      ext: '11l',
      kor: '11l',
      template:"11l",
      icon:'mdi-numeric-1',
      command: "11l {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      errorRegEx: ".+?: .+?\r\n.+, line (\\d+)(.*)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://11l-lang.org/',
      repo: 'https://bitbucket.org/11l-lang/11l/downloads',
    },
    '가람':{
      desc: "High-level, functional, concise language",
      highlighting:"javascript1",
      ext: 'gr',
      kor: 'Garam',
      template:"garam",
      icon:'mdi-screwdriver',
      command:"garam {ARGS} < {FILENAME}.{EXT}",
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/ericlee05',
      repo: 'https://github.com/ericlee05/Garam-Interpreter',
    },
    '누리':{
      desc: "Concise, functional, modern, type-safe, expressive",
      highlighting:"nuri",
      ext: 'nuri',
      kor: 'Nuri',
      template:"nuri",
      icon:'mdi-fruit-grapes',
      args: '--haneul /opt/nuri/haneul',
      command:"nuri {ARGS} {FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".+?, (\\d+).+",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://nuri.donghwi.dev',
      repo: 'https://github.com/suhdonghwi/nuri',
    },
    '아희':{
      desc: "Esoteric, minimalistic, stack-based, visual, unconventional",
      highlighting:"shell",
      ext: 'aheui',
      kor: 'Aheui',
      template:"aheui",
      icon:'mdi-syllabary-hangul',
      command:"aheui {ARGS} {FILENAME}.{EXT}",
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://aheui.readthedocs.io/',
      repo: 'https://github.com/aheui/c2aheui',
    },
    '약속':{
      desc: "Declarative, type-safe, expressive, concise, modern",
      highlighting:"yaksok",
      ext: 'yak',
      kor: 'Yaksok',
      template:"yaksok",
      icon:'mdi-hand-okay',
      command:"ysjs compile {ARGS} {FILENAME}.{EXT} && node out",
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'http://yaksok.org',
      repo: 'https://github.com/yaksok/yaksok',
    },
    '엄랭':{
      desc: "Minimalistic, esoteric, stack-based, experimental, unique",
      highlighting:"umm",
      ext: 'umm',
      kor: 'ummc',
      template:"umm",
      icon:'mdi-cow',
      command:"ummc -o {FILENAME} {ARGS} {FILENAME}.{EXT} && ./{FILENAME}",
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://github.com/rycont',
      repo: 'https://github.com/rycont/umjunsik-lang',
    },
    '혀엉...':{
      desc: "Esoteric, Korean, Educational, Simple, Concise",
      highlighting:"shell",
      ext: 'hlang',
      kor: 'hyeong',
      template:"혀엉...",
      icon:'mdi-heart-outline',
      command:"hyeong {ARGS} {FILENAME}.{EXT}",
      cli: null,
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://gist.github.com/xnuk',
      repo: 'https://gist.github.com/xnuk/d9f883ede568d97caa158255e4b4d069',
    },
    'C Shell':{
      desc: "C-like syntax, job control, history mechanism, scripting features, command aliasing",
      highlighting:"shell",
      ext: 'csh',
      kor: 'C셸 - csh',
      template:"csh",
      icon:'mdi-bash',
      command:"chmod 755 {FILENAME}.{EXT} && bash {ARGS} ./{FILENAME}.{EXT}",
      cli: "csh",
      errorRegEx: ".+?\\.csh: line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://docs-archive.freebsd.org/44doc/usd/04.csh/paper.html',
      repo: 'https://github.com/shradhasehgal/C-Shell',
    },
    'Dashell':{
      desc: "Lightweight, fast, POSIX-compliant, compatible, shell scripting",
      highlighting:"shell",
      ext: 'dash',
      kor: '다셸 - ksh',
      template:"dash",
      icon:'mdi-bash',
      command:"chmod 755 {FILENAME}.{EXT} && bash {ARGS} ./{FILENAME}.{EXT}",
      cli: "dash",
      errorRegEx: ".+?\\.dash: line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://github.com/olalonde',
      repo: 'https://github.com/olalonde/dashell',
    },
    'Elvish':{
      desc: "Powerful modern shell scripting",
      highlighting:"elvish",
      ext: 'elv',
      kor: '엘비쉬',
      template:"elvish",
      icon:'mdi-bash',
      command:"chmod 755 {FILENAME}.{EXT} && elvish {ARGS} ./{FILENAME}.{EXT}",
      cli: "elvish",
      errorRegEx: ".+?\\.elv:(\\d+):\\d+-\\d+: (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://elv.sh',
      repo: 'https://github.com/elves/elvish',
    },
    'Fish':{
      desc: "User-friendly, interactive, flexible, scriptable, modern",
      highlighting:"shell",
      ext: 'fish',
      kor: '피쉬셸 - fish',
      template:"fish",
      icon:'mdi-fish',
      command:"fish {ARGS} {FILENAME}.{EXT}",
      cli: "fish",
      errorRegEx: ".+\r\n.+?\\.fish \\(line (\\d+)\\)(:)",
      keyBindings: null,
      dockerImage: '',
      homepage: 'https://fishshell.com',
      repo: 'https://github.com/fish-shell/fish-shell',
    },
    'Korn Shell':{
      desc: "POSIX-compliant, Job control, Scripting features, Command aliasing",
      highlighting:"shell",
      ext: 'ksh',
      kor: '콘셸 - ksh',
      template:"ksh",
      icon:'mdi-bash',
      command:"chmod 755 {FILENAME}.{EXT} && bash {ARGS} ./{FILENAME}.{EXT}",
      cli: "ksh",
      errorRegEx: ".+?\\.ksh: line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'http://www.kornshell.com',
      repo: 'https://github.com/ksh93/ksh',
    },
    'Nushell':{
      desc: "New type of shell",
      highlighting:"shell",
      ext: 'nu',
      kor: '너셸',
      template:"nushell",
      icon:'mdi-bash',
      command:"chmod 755 {FILENAME}.{EXT} && nu {ARGS} ./{FILENAME}.{EXT}",
      cli: "nu",
      errorRegEx: ".+?\\.nu.+?m:(\\d+):\\d+\\]",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://www.nushell.sh',
      repo: 'https://github.com/nushell/nushell',
    },
    'Z Shell':{
      desc: "Shell scripting, command-line, and Unix-based",
      highlighting:"shell",
      ext: 'zsh',
      kor: 'Z셸 - zsh',
      template:"zsh",
      icon:'mdi-bash',
      command:"chmod 755 {FILENAME}.{EXT} && bash {ARGS} ./{FILENAME}.{EXT}",
      cli: "zsh",
      errorRegEx: ".+?\\.zsh: line (\\d+): (.+)",
      keyBindings: null,
      dockerImage: "ryusatgat/base",
      homepage: 'https://wiki.zshell.dev',
      repo: 'https://github.com/z-shell/zi',
    },
    'Arch Linux':{
      desc: "Simple, lightweight Linux distribution aimed for flexibility",
      highlighting:"shell",
      ext: 'sh',
      kor: '아치 리눅스',
      template:"archlinux",
      icon:'mdi-linux',
      command:"chmod 755 {FILENAME}.{EXT} && bash {ARGS} ./{FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*\\.sh: .+? (\\d+): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/arch",
      homepage: 'https://archlinux.org',
      repo: 'https://github.com/archlinux/linux',
    },
    'Kali Linux':{
      desc: "Penetration-testing, Security-focused, Preloaded-tools, Debian-based, Customizable",
      highlighting:"shell",
      ext: 'sh',
      kor: '칼리 리눅스',
      template:"kalilinux",
      icon:'mdi-linux',
      command:"chmod 755 {FILENAME}.{EXT} && bash {ARGS} ./{FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*\\.sh: .+? (\\d+): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/kali",
      homepage: 'https://www.kali.org',
      repo: 'https://www.kali.org/get-kali',
    },
    'Rocky Linux 9':{
      desc: "Compatible with Red Hat Enterprise Linux",
      highlighting:"shell",
      ext: 'sh',
      kor: '록키 리눅스',
      template:"rockylinux9",
      icon:'mdi-linux',
      command:"chmod 755 {FILENAME}.{EXT} && bash {ARGS} ./{FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*\\.sh: .+? (\\d+): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/rocky9",
      homepage: 'https://rockylinux.org',
      repo: 'https://github.com/rocky-linux',
    },
    'Ubuntu Linux':{
      desc: "Canonical, Derived from Debian",
      highlighting:"shell",
      ext: 'sh',
      kor: '우분투 리눅스',
      template:"bash",
      icon:'mdi-linux',
      command:"chmod 755 {FILENAME}.{EXT} && bash {ARGS} ./{FILENAME}.{EXT}",
      cli: null,
      errorRegEx: ".*\\.sh: .+? (\\d+): (.*)",
      keyBindings: null,
      dockerImage: "ryusatgat/ubuntu",
      homepage: 'https://ubuntu.com',
      repo: 'https://github.com/ubuntu',
    },
};
